webpackJsonp([1],{

/***/ "+Gxq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_table_vue__ = __webpack_require__("/Put");
function injectStyle (ssrContext) {
  __webpack_require__("FdwB")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_table_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "+QQc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__complaintsPerimeter__ = __webpack_require__("EjrX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__newPerimeter__ = __webpack_require__("sRqS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__operatorsPerimeter__ = __webpack_require__("2YqD");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "complaintsPerimeter", function() { return __WEBPACK_IMPORTED_MODULE_0__complaintsPerimeter__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "newPerimeter", function() { return __WEBPACK_IMPORTED_MODULE_1__newPerimeter__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "operatorsPerimeter", function() { return __WEBPACK_IMPORTED_MODULE_2__operatorsPerimeter__["a"]; });






/***/ }),

/***/ "+RXk":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/1ZK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__perimeters_actionsPerimeter__ = __webpack_require__("Qh7t");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue2_selectize__ = __webpack_require__("py5U");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue2_selectize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue2_selectize__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants_Status_constants__ = __webpack_require__("XXAu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants_Url_constants__ = __webpack_require__("M1ba");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_apiService__ = __webpack_require__("a/3G");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_layout_Actions__ = __webpack_require__("SUb6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_layout_Comments__ = __webpack_require__("3YGy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_layout_LastActivity__ = __webpack_require__("sX+p");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue2_dropzone__ = __webpack_require__("KvPw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue2_dropzone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue2_dropzone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue2_dropzone_dist_vue2Dropzone_min_css__ = __webpack_require__("9BHd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue2_dropzone_dist_vue2Dropzone_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vue2_dropzone_dist_vue2Dropzone_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vee_validate__ = __webpack_require__("sUu7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_dni__ = __webpack_require__("Eayd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_dni___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_vue_dni__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_forms_ShowBankAccountForm__ = __webpack_require__("zp9P");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utils_dateService__ = __webpack_require__("4F1w");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

















/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'show_complaint',
  components: {
    Actions: __WEBPACK_IMPORTED_MODULE_6__components_layout_Actions__["a" /* default */],
    Comments: __WEBPACK_IMPORTED_MODULE_7__components_layout_Comments__["a" /* default */],
    Selectize: __WEBPACK_IMPORTED_MODULE_2_vue2_selectize___default.a,
    LastActivity: __WEBPACK_IMPORTED_MODULE_8__components_layout_LastActivity__["a" /* default */],
    vueDropzone: __WEBPACK_IMPORTED_MODULE_9_vue2_dropzone___default.a,
    ShowBankAccountForm: __WEBPACK_IMPORTED_MODULE_13__components_forms_ShowBankAccountForm__["a" /* default */]
  },
  perimeters: [__WEBPACK_IMPORTED_MODULE_1__perimeters_actionsPerimeter__["a" /* default */]],
  data: function data() {
    return {
      complaint: {},
      bank_info: {},
      dropzoneOptions: {
        url: __WEBPACK_IMPORTED_MODULE_4__constants_Url_constants__["a" /* default */].API_URL + '/complaints/' + this.$route.params.complaint_id + '/additional_info',
        dictDefaultMessage: 'Cargar archivos',
        thumbnailWidth: 150,
        maxFilesize: 8,
        headers: { Authorization: 'Bearer ' + this.$store.getters.token }
      },
      dialogOptions: {
        okText: 'Continuar',
        cancelText: 'Cancelar'
      },
      new_status: null,
      statuses: __WEBPACK_IMPORTED_MODULE_3__constants_Status_constants__["a" /* default */].STATUSES_ECOMMERCE,
      categories: [],
      accounts: __WEBPACK_IMPORTED_MODULE_3__constants_Status_constants__["a" /* default */].ACCOUNTS,
      complaint_attachment: null,
      request_id: null,
      info_request: null,
      loader: false,
      max: 16,
      allowed_payment_methods: __WEBPACK_IMPORTED_MODULE_3__constants_Status_constants__["a" /* default */].PAYMENT_METHODS,
      refund_methods: __WEBPACK_IMPORTED_MODULE_3__constants_Status_constants__["a" /* default */].REFUND_METHODS,
      signedLink: '',
      refund_method: {
        email: '',
        code: ''
      },
      showDialog: false,
      intervalId: null
    };
  },

  computed: {
    commentsTitle: function commentsTitle() {
      var svgCircle = '<svg aria-hidden="true" data-icon="circle" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="svg-circle"><path fill="red" d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8z" class=""></path></svg>';
      if (this.$store.getters.commentsLength > 0) {
        return 'Comentarios ' + svgCircle;
      }
      return 'Comentarios';
    },
    complaintAge: function complaintAge() {
      return __WEBPACK_IMPORTED_MODULE_14__utils_dateService__["a" /* default */].complaintAge(this.complaint.created_at);
    },
    requests: function requests() {
      if (this.complaint.additional_infos === undefined) {
        return [];
      }
      return this.complaint.additional_infos.filter(function (n) {
        return n.source === 'internal';
      });
    },
    public_url: function public_url() {
      var currentUrl = document.location.href;
      currentUrl = currentUrl.replace('complaints_ecommerce', 'status');

      return currentUrl;
    }
  },
  beforeMount: function beforeMount() {
    __WEBPACK_IMPORTED_MODULE_11_vee_validate__["b" /* Validator */].extend('rut', __WEBPACK_IMPORTED_MODULE_12_vue_dni__["rutValidator"]);
    this.fetchCategories();
    this.fetchComplaint();
    this.refreshReloaAppStatus();
  },

  methods: {
    statusClassName: function statusClassName(complaint) {
      var statusClass = this.statuses[complaint.aasm_state] === undefined ? null : this.statuses[complaint.aasm_state].initials.toLowerCase();
      return 'status-' + statusClass;
    },
    fetchCategories: function fetchCategories() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_5__services_apiService__["a" /* default */].get_categories(null, true).then(function (res) {
        _this.categories = res.body.reduce(function (acc, item) {
          acc[item.number] = { description: item.name };
          return acc;
        }, {});
      });
    },
    fetchComplaint: function fetchComplaint() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_5__services_apiService__["a" /* default */].get(this.$route.params.complaint_id).then(function (data) {
        _this2.complaint = data.body;
        _this2.new_status = data.body.status;
        _this2.bank_info = data.body.bank_account || {};
        if (_this2.complaint.bank_account === undefined) {
          _this2.complaint.bank_account = data.body.bank_account || {};
        }
        document.title = 'Reclamo #' + _this2.complaint.number + ' | Kexa';
        __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].commit('selectComplaint', _this2.complaint);
      });
    },
    slideEditAttribute: function slideEditAttribute(e) {
      var currentElement = e.target;
      var activeEditClass = 'active-edit';
      var editVisibleClass = 'edit-visible';

      // Normalize element selection
      if (currentElement.tagName === 'path') {
        currentElement = currentElement.parentElement;
      } else if (currentElement.tagName === 'SPAN') {
        currentElement = currentElement.querySelector('svg');
      }

      // Toggle classes to display respective edit fields
      if (!currentElement.classList.contains(activeEditClass)) {
        currentElement.classList.add(activeEditClass);
        currentElement.parentElement.nextElementSibling.classList.add(editVisibleClass);
      } else {
        currentElement.classList.remove(activeEditClass);
        currentElement.parentElement.nextElementSibling.classList.remove(editVisibleClass);
      }
    },
    updateComplaintAttributes: function updateComplaintAttributes() {
      var _this3 = this;

      var newAasmState = this.complaint.aasm_state;
      var newCategory = this.complaint.category;
      var newComment = this.complaint.comment;

      __WEBPACK_IMPORTED_MODULE_5__services_apiService__["a" /* default */].forceUpdate(this.$route.params.complaint_id, {
        aasm_state: newAasmState,
        category: newCategory,
        comment: newComment
      }).then(function () {
        _this3.$notify({
          group: 'show_complaint',
          type: 'success',
          title: 'Éxito',
          text: 'Reclamo actualizado',
          duration: 3000
        });
        document.querySelectorAll('.edit-icon-container .fa-icon').forEach(function (c) {
          return c.classList.remove('active-edit');
        });
        document.querySelectorAll('.edit-attribute').forEach(function (c) {
          return c.classList.remove('edit-visible');
        });
        _this3.fetchComplaint();
      }).catch(function (exception) {
        if (exception.status === 405) {
          _this3.$notify({
            group: 'show_complaint',
            type: 'error',
            text: 'No es posible actualizar este reclamo, porque ya está siendo procesado por una cancelación. Solo puede ser actualizado a Resuelto',
            duration: 8000
          });
        } else if (exception.status === 422 && newAasmState === 'approved_reimbursement') {
          _this3.$notify({
            group: 'show_complaint',
            type: 'error',
            text: 'Debe ingresar un porcentaje a reembolsar al reclamo',
            duration: 8000
          });
        } else {
          _this3.$notify({ group: 'show_complaint', title: 'Error', text: 'Error al actualizar el reclamo', type: 'error', duration: 3000 });
        }
      });
    },
    uploadAttachment: function uploadAttachment() {
      var formData = new FormData();
      var $this = this;
      formData.append('request', 'add');
      $this.loader = true;
      if (this.complaint_attachment !== null) {
        formData.append('file', this.complaint_attachment);
        __WEBPACK_IMPORTED_MODULE_5__services_apiService__["a" /* default */].upload_file(this.$route.params.complaint_id, formData).then(function () {
          $this.complaint_attachment = null;
          $this.fetchComplaint();
          $this.loader = false;
        });
      }
    },
    requestInfo: function requestInfo() {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_5__services_apiService__["a" /* default */].request_info(this.$route.params.complaint_id, {
        request: this.info_request
      }).then(function () {
        _this4.info_request = null;
        _this4.fetchComplaint();
      });
    },
    addFile: function addFile(id) {
      document.getElementById('requestFile').click();
      this.request_id = id;
    },
    uploadFile: function uploadFile() {
      var _this5 = this;

      var formData = new FormData();
      formData.append('request_id', this.request_id);
      formData.append('file', document.getElementById('requestFile').files[0]);
      __WEBPACK_IMPORTED_MODULE_5__services_apiService__["a" /* default */].append_file(this.$route.params.complaint_id, formData).then(function () {
        _this5.fetchComplaint();
      });
    },
    updateActivity: function updateActivity() {
      this.$refs.activity.fetchActivities();
    },
    closeModal: function closeModal() {
      this.$refs.editComplaintDataModal.hide();
      this.$refs.bankDataModal.hide();
    },
    back: function back() {
      this.$router.go(-1);
    },
    deleteAttachment: function deleteAttachment(attachment) {
      var $this = this;
      this.$dialog.confirm('¿Deseas eliminar el archivo adjunto?', this.dialogOptions).then(function () {
        __WEBPACK_IMPORTED_MODULE_5__services_apiService__["a" /* default */].removeAttachment($this.$route.params.complaint_id, attachment).then(function () {
          $this.fetchComplaint();
        });
      }).catch(function () {});
    },
    refreshReloaAppStatus: function refreshReloaAppStatus() {
      var _this6 = this;

      this.intervalId = setInterval(function () {
        __WEBPACK_IMPORTED_MODULE_5__services_apiService__["a" /* default */].reloadAppStatus().then(function (response) {
          if (response.body) {
            _this6.showDialog = true;
          }
        });
      }, 900000);
    },
    openFileModal: function openFileModal(additionalInfoId) {
      var _this7 = this;

      __WEBPACK_IMPORTED_MODULE_5__services_apiService__["a" /* default */].getSignedLink(this.$route.params.complaint_id, additionalInfoId).then(function (data) {
        _this7.signedLink = data.body.signed_link;
        _this7.$refs['imageModal-' + additionalInfoId][0].show();
      }).catch(function (response) {
        _this7.$notify({
          group: 'show_complaint',
          type: 'error',
          title: 'Error',
          text: response.bodyText,
          duration: 2000
        });
      });
    },
    openFileTab: function openFileTab(additionalInfoId) {
      var _this8 = this;

      __WEBPACK_IMPORTED_MODULE_5__services_apiService__["a" /* default */].getSignedLink(this.$route.params.complaint_id, additionalInfoId).then(function (data) {
        window.open(data.body.signed_link, '_blank');
      }).catch(function (response) {
        _this8.$notify({
          group: 'show_complaint',
          type: 'error',
          title: 'Error',
          text: response.bodyText,
          duration: 2000
        });
      });
    },
    dowloadFile: function dowloadFile(additionalInfoId) {
      var _this9 = this;

      __WEBPACK_IMPORTED_MODULE_5__services_apiService__["a" /* default */].getSignedLink(this.$route.params.complaint_id, additionalInfoId).then(function (data) {
        var link = document.createElement('a');
        link.href = data.body.signed_link;
        link.download = '';
        link.target = '_blank';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }).catch(function (response) {
        _this9.$notify({
          group: 'show_complaint',
          type: 'error',
          title: 'Error',
          text: response.bodyText,
          duration: 2000
        });
      });
    }
  },
  beforeDestroy: function beforeDestroy() {
    clearInterval(this.intervalId);
  }
});

/***/ }),

/***/ "/E8i":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{class:_vm.clazz,style:(_vm.style),attrs:{"version":"1.1","role":_vm.label ? 'img' : 'presentation',"aria-label":_vm.label,"x":_vm.x,"y":_vm.y,"width":_vm.width,"height":_vm.height,"viewBox":_vm.box}},[_vm._t("default",[(_vm.icon && _vm.icon.paths)?_vm._l((_vm.icon.paths),function(path){return _c('path',_vm._b({},'path',path,false))}):_vm._e(),_vm._v(" "),(_vm.icon && _vm.icon.polygons)?_vm._l((_vm.icon.polygons),function(polygon){return _c('polygon',_vm._b({},'polygon',polygon,false))}):_vm._e(),_vm._v("\b\n    "),(_vm.icon && _vm.icon.raw)?[_c('g',{domProps:{"innerHTML":_vm._s(_vm.icon.raw)}})]:_vm._e()])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "/N/F":
/***/ (function(module, exports) {

module.exports = {"status":{"disclaimer":{"advise":"Recorrido.mx se contactará con la empresa de bus respectiva y actuará como intermediario entre usted y esta con la finalidad de obtener una resolución a su requerimiento. Recorrido.mx no tiene incidencia en las operaciones ni el tráfico de los operadores, solo comercializamos sus pasajes a través de nuestra plataforma online.","contact":"Lo contactaremos una vez que tengamos la respuesta de la empresa de buses, le pedimos disculpas de antemano, esto puede tardar algunos días."}}}

/***/ }),

/***/ "/Put":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__table__ = __webpack_require__("fnDg");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__table__["a" /* default */]);

/***/ }),

/***/ "/ZFF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReloadAppDialog_vue__ = __webpack_require__("q2GD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1f2837c2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_ReloadAppDialog_vue__ = __webpack_require__("lcc6");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReloadAppDialog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1f2837c2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_ReloadAppDialog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "/gGb":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAYAAABV7bNHAAADQElEQVR4AezaNXAUURjAcVxL3N3drcahhRaHvoAuKbEep0V73OHc3d0v7tjlY78inry53Sx5u7nvZv4zKff95u7leztvTENNdKXSqiuE1yQi5kljFPBBIFBaAhAE3F8aGEgE5LG/BzYSAZWDREBsJAJiIxEQG4mA2EgEJB6JgNhIBMRGIiDxSATERiIgNhIBsZEIiIHEBaiY9UM6ZhNX3AZ1+ZBEIP5IooB8zk+SHjji14oCqi+GIej5OqwiAW08n3KPG1GgsO+HJKBk1MLr5zpVBiDx+4OI8NvAAYYjkLoiIAIiIAIiIALqKpt0Qiyo5xVO5soG8jo+4uDHtdp8SLlAibAJ/K4vQp+5FA3oaA+iTZqACIiAuERABERAyYgZX2fyCqdppU/SH2iSZpVNOPBlOET8fErFrLQH0SZNQAREQKOinBEagrdnEdBgJV5Cg2YxNPyYXxJaSEC9K4agwbgfcbqyCY0dESCcRXgOiThN1xcj7OcM3kCU/h0dodsd/N9J1xUYk3TeAg3a1YMBtQhN/O9AxYwPb2rgmYxL+bSb/YyuK4gxVFWVvQel3ggIC1hA2MwKBYpAg+VwXwztUmjUr+sP9LoygSL3+0JoFkOpIw7Q+Rua7Uf6I+2qLKCCFxr0m/sgNJn2QNenPVrVHygrNK5ygHzXcNEMoOrB9qLzlQGU/QENmiVSgEpC02UHwvuGhYwX8mkPjwbOQPbTuFgpQNhj2YEC7q88h0QcVHsuhcaf4SKHA4StkBUILy5wBMLbJXhztuu8JQeQQ2isbED4Fc+lXNyqzQdZ5y0pQNgxVW7S7PPWKjmB2oQmjh4g1yVclJxAWPXoAEq9Zp63GINiOc1SORCetw6VtVg8h5V+5QA6/0KL42S5QG/VDRS5i4sou0bdGmgybse/xbRLnUAFT9d5S+4Y5zQ1AXmvil5ss/0otPrOd+1ZYjqvLqDsdzxvifx5rQJhEwL8tHrPigPqOqepBsh+SvxPRbMY/rb5obPUAc22ro1dVI/VARR/Kn0/0SzC/2bD2Y9WKB/IdAAflFc25QNplvEEKgmNRaB/mzho8e2+Te/POD94f8aBPHxMaR7QkxPJwP1ArAlKQADQwPTRRG6HcwAAAABJRU5ErkJggg=="

/***/ }),

/***/ 0:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "0E/T":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',{staticClass:"justify-content-md-center"},[_c('ReloadAppDialog',{attrs:{"showDialog":_vm.showDialog}}),_c('b-col',{attrs:{"md":"9","offset-md":"3"}},[_c('h4',[_vm._v("Reclamos Ecommerce")])]),_c('b-col',{attrs:{"md":"3"}},[_c('last-activity',{attrs:{"ecommerce":true}})],1),_c('b-col',{attrs:{"md":"9"}},[_c('b-row',[_c('b-col',{attrs:{"md":"4"}},[_c('b-nav',{staticClass:"nav-pills"},[_c('li',{staticClass:"nav-item filters-title"},[_vm._v("Filtrar por:")]),_c('li',{staticClass:"nav-item"},[_c('b-button',{attrs:{"variant":"primary","pressed":_vm.pending},on:{"update:pressed":function($event){_vm.pending=$event},"click":function($event){_vm.showPending($event)}}},[_vm._v("Pendientes"),(_vm.pending)?_c('span',[_vm._v("  ")]):_vm._e(),(_vm.pending)?_c('icon',{attrs:{"name":"check"}}):_vm._e()],1)],1),_c('li',{staticClass:"nav-item"},[_c('b-button',{attrs:{"variant":"link"},on:{"click":_vm.toggleAge}},[(_vm.sortAge)?_c('icon',{attrs:{"name":"chevron-down"}}):_c('icon',{attrs:{"name":"chevron-up"}}),_vm._v("Edad")],1)],1)])],1),_c('b-col',{attrs:{"md":"8"}},[_c('b-input-group',[_c('b-form-input',{nativeOn:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13)){ return null; }_vm.showPending($event)}},model:{value:(_vm.filterText),callback:function ($$v) {_vm.filterText=$$v},expression:"filterText"}}),_c('b-input-group-button',{attrs:{"slot":"right"},slot:"right"},[_c('b-btn',{attrs:{"variant":"primary"},on:{"click":_vm.showPending}},[_c('icon',{attrs:{"name":"search"}})],1)],1)],1)],1)],1),(_vm.complaints.length > 0)?_c('b-table',{attrs:{"hover":"hover","fields":_vm.complaintFields,"items":_vm.complaints},on:{"row-clicked":_vm.showComplaintDetails},scopedSlots:_vm._u([{key:"status",fn:function(thisComplaint){return [_c('div',{staticClass:"complaint-status-wrapper",class:("status-" + (_vm.statuses[thisComplaint.item.aasm_state].initials.toLowerCase())),attrs:{"id":("status-" + (thisComplaint.item._id.$oid))}},[_vm._v(_vm._s(_vm.statuses[thisComplaint.item.aasm_state].initials))]),_c('complaint-popover',{attrs:{"thisComplaint":thisComplaint.item,"popoverTarget":("status-" + (thisComplaint.item._id.$oid))}})]}},{key:"token",fn:function(thisComplaint){return [_vm._v(_vm._s(thisComplaint.item.ticket_info.booking_number))]}},{key:"category",fn:function(thisComplaint){return [_vm._v(_vm._s(thisComplaint.item.complaint_category.name))]}},{key:"comment",fn:function(thisComplaint){return [_c('div',{staticClass:"ellipsis",attrs:{"id":("comment-" + (thisComplaint.item._id.$oid))}},[_vm._v(_vm._s(thisComplaint.item.comment))]),_c('complaint-popover',{attrs:{"thisComplaint":thisComplaint.item,"popoverTarget":("comment-" + (thisComplaint.item._id.$oid))}})]}},{key:"age",fn:function(thisComplaint){return [_vm._v(_vm._s(_vm.complaintAge(thisComplaint.item)))]}},{key:"bus_operator",fn:function(thisComplaint){return [_vm._v(_vm._s(_vm.busOperators(thisComplaint.item)))]}},{key:"amount_requested",fn:function(thisComplaint){return [(thisComplaint.item.reimbursement)?_c('div',[(thisComplaint.item.reimbursement.compensation_type === 'm')?_c('span',[(['WebPay', 'Agencia', 'Fintoc', 'OneClick', 'Mercado Pago', 'Floid'].includes(thisComplaint.item.ticket_info.payment_method))?[_vm._v(_vm._s(_vm._f("currency")(thisComplaint.item.reimbursement.amount,'CLP $', 0, { thousandsSeparator: '.'})))]:[_vm._v(_vm._s(_vm._f("currency")(thisComplaint.item.reimbursement.amount,'USD $', 2, { thousandsSeparator: ',', decimalSeparator: '.' })))]],2):_c('span',[_vm._v("No monetario")])]):(thisComplaint.item.aasm_state === 'rejected')?_c('div',[_vm._v("Reclamo rechazado")]):_c('div',[_vm._v("Aún no está cerrado")])]}},{key:"edit_complaint",fn:function(thisComplaint){return [_c('router-link',{staticClass:"show-link",attrs:{"to":{ name: 'show_complaint', params: { complaint_id: thisComplaint.item._id.$oid } }}})]}}])}):_c('div',{staticClass:"no-complaints-left"},[_c('b-alert',{attrs:{"show":"show","variant":"warning"}},[_vm._v("No se encontraron reclamos")])],1),(_vm.complaints.length > 0)?_c('b-pagination',{attrs:{"align":"center","total-rows":_vm.pagination.total,"per-page":_vm.pagination.per_page},on:{"change":_vm.changePage},model:{value:(_vm.pagination.current),callback:function ($$v) {_vm.pagination.current=$$v},expression:"pagination.current"}}):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "0Kyw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Logout_vue__ = __webpack_require__("7q3b");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8c5f5892_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Logout_vue__ = __webpack_require__("OaZv");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Logout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8c5f5892_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Logout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "0Rud":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "1AIU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2X/Z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',[_c('b-col',{attrs:{"md":"4"}}),_c('b-col',{attrs:{"cols":"12","md":"4"}},[_c('h2',[_vm._v("Confirmando Usuario")]),_c('notifications',{attrs:{"group":"auth","position":"top center"}}),_c('icon',{staticClass:"loader-in-field",attrs:{"name":"refresh","spin":"spin"}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "2YqD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__basePerimeter__ = __webpack_require__("G0wa");


/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_0__basePerimeter__["a" /* default */]({
  purpose: 'operators',
  govern: {
    'can route': function route() {
      return this.isAdmin();
    },
    'can createOperator': function createOperator() {
      return this.isAdmin();
    }
  }
}));

/***/ }),

/***/ "3YGy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Comments_vue__ = __webpack_require__("Zmly");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3ed5b0e0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Comments_vue__ = __webpack_require__("7pL4");
function injectStyle (ssrContext) {
  __webpack_require__("DaHx")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Comments_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3ed5b0e0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Comments_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "4F1w":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_dayjs__ = __webpack_require__("oqQY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_dayjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_dayjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_dayjs_plugin_customParseFormat__ = __webpack_require__("yRb7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_dayjs_plugin_customParseFormat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_dayjs_plugin_customParseFormat__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_dayjs_plugin_duration__ = __webpack_require__("YftN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_dayjs_plugin_duration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_dayjs_plugin_duration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_dayjs_plugin_relativeTime__ = __webpack_require__("B197");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_dayjs_plugin_relativeTime___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_dayjs_plugin_relativeTime__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_dayjs_locale_es__ = __webpack_require__("O6/0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_dayjs_locale_es___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_dayjs_locale_es__);






__WEBPACK_IMPORTED_MODULE_0_dayjs___default.a.extend(__WEBPACK_IMPORTED_MODULE_1_dayjs_plugin_customParseFormat___default.a);
__WEBPACK_IMPORTED_MODULE_0_dayjs___default.a.extend(__WEBPACK_IMPORTED_MODULE_2_dayjs_plugin_duration___default.a);
__WEBPACK_IMPORTED_MODULE_0_dayjs___default.a.extend(__WEBPACK_IMPORTED_MODULE_3_dayjs_plugin_relativeTime___default.a);
__WEBPACK_IMPORTED_MODULE_0_dayjs___default.a.locale(__WEBPACK_IMPORTED_MODULE_4_dayjs_locale_es___default.a);

/* harmony default export */ __webpack_exports__["a"] = ({
  getDate: function getDate(value) {
    var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'DD/MM/YYYY';

    return __WEBPACK_IMPORTED_MODULE_0_dayjs___default()(String(value)).format(format);
  },
  complaintAge: function complaintAge(value) {
    var timeComplaint = __WEBPACK_IMPORTED_MODULE_0_dayjs___default()(value);

    return __WEBPACK_IMPORTED_MODULE_0_dayjs___default.a.duration(__WEBPACK_IMPORTED_MODULE_0_dayjs___default()().diff(timeComplaint)).humanize();
  },
  customFormat: function customFormat(value) {
    return __WEBPACK_IMPORTED_MODULE_0_dayjs___default()(value, 'YYYY-MM-DD HH:mm:ss ZZ');
  },
  isAfterAWeek: function isAfterAWeek(value) {
    var timeComplaint = __WEBPACK_IMPORTED_MODULE_0_dayjs___default()(value);
    var aWeekAfter = __WEBPACK_IMPORTED_MODULE_0_dayjs___default()(timeComplaint).add(1, 'week');

    if (__WEBPACK_IMPORTED_MODULE_0_dayjs___default()().isAfter(aWeekAfter)) {
      return true;
    }
    return false;
  },
  isValidDate: function isValidDate(value) {
    if (__WEBPACK_IMPORTED_MODULE_0_dayjs___default()(String(value)).isValid()) {
      return this.getDate(value, 'DD/MM/YYYY HH:mm:ss');
    }

    return '-';
  },
  isNan: function isNan(value) {
    if (isNaN(__WEBPACK_IMPORTED_MODULE_0_dayjs___default()().diff(__WEBPACK_IMPORTED_MODULE_0_dayjs___default()(value), 'days'))) {
      return '-';
    }

    return __WEBPACK_IMPORTED_MODULE_0_dayjs___default()().diff(__WEBPACK_IMPORTED_MODULE_0_dayjs___default()(value), 'days');
  }
});

/***/ }),

/***/ "4T/p":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Finance_vue__ = __webpack_require__("KQ6S");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_27933837_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Finance_vue__ = __webpack_require__("bmAA");
function injectStyle (ssrContext) {
  __webpack_require__("PT+o")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Finance_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_27933837_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Finance_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "4ZhY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StatusBankAccountForm_vue__ = __webpack_require__("hTEU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1179351c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_StatusBankAccountForm_vue__ = __webpack_require__("DnFM");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StatusBankAccountForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1179351c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_StatusBankAccountForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "55sj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (store) {
  return store ? store.state.user : null;
});

/***/ }),

/***/ "5g7+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6nbN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7Upu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('notifications',{attrs:{"group":"show_complaint","position":"top center"}}),(_vm.complaint.number)?_c('b-row',{staticClass:"justify-content-md-center"},[_c('ReloadAppDialog',{attrs:{"showDialog":_vm.showDialog}}),_c('b-col',{attrs:{"md":"3"}},[_c('b-card',{staticClass:"complaint-actions"},[_c('h4',[_vm._v("Proceder con reclamo")]),_c('h6',[_c('small',[_vm._v("Elige una de las opciones")])]),_c('actions',{attrs:{"complaint":_vm.complaint},on:{"sendUpdate":_vm.updateActivity}})],1)],1),_c('b-col',{attrs:{"md":"9"}},[_c('b-btn',{staticClass:"btn-back",on:{"click":_vm.back}},[_c('icon',{attrs:{"name":"chevron-left"}}),_vm._v(" Volver a Reclamos")],1),_c('b-card',{attrs:{"title":("Reclamo ecommerce #" + (_vm.complaint.number))}},[_c('p',{staticClass:"complaint-main-meta"},[_vm._v("Registrado por "+_vm._s(_vm.complaint.agent_name)),_c('br'),_vm._v("Ingresado el "+_vm._s(_vm._f("formatDate")(_vm.complaint.created_at))+" - Edad "+_vm._s(_vm.complaintAge))]),_c('ul',{staticClass:"complaint-summary-meta"},[_c('li',[_c('span',{staticClass:"meta-info-title"},[_vm._v("Estado")]),_c('span',{staticClass:"complaint-meta-value complaint-status-wrapper",class:_vm.statusClassName(_vm.complaint)},[_vm._v(_vm._s(_vm._f("formatStatusEcommerce")(_vm.complaint.aasm_state)))]),(_vm.$isAllowed('viewAdmin') || _vm.$isAllowed('viewERR'))?_c('span',{staticClass:"edit-icon-container",on:{"click":_vm.slideEditAttribute}},[_c('icon',{attrs:{"name":"chevron-down"}})],1):_vm._e(),(_vm.$isAllowed('viewAdmin') || _vm.$isAllowed('viewERR'))?_c('div',{staticClass:"edit-attribute",attrs:{"title":"Editar"}},[_c('selectize',{model:{value:(_vm.complaint.aasm_state),callback:function ($$v) {_vm.complaint.aasm_state=(typeof $$v === 'string'? $$v.trim(): $$v)},expression:"complaint.aasm_state"}},_vm._l((_vm.statuses),function(status,index){return _c('option',{domProps:{"value":index}},[_vm._v(_vm._s(status.description))])})),_c('b-btn',{attrs:{"title":"Guardar cambio","variant":"outline-success"},on:{"click":_vm.updateComplaintAttributes}},[_c('icon',{attrs:{"name":"save"}})],1)],1):_vm._e()]),_c('li',[_c('span',{staticClass:"meta-info-title"},[_vm._v("Categoría")]),_c('div',[_c('span',{staticClass:"complaint-meta-value"},[_vm._v(_vm._s(_vm.complaint.complaint_category.name))]),(_vm.$isAllowed('viewAdmin') || _vm.$isAllowed('viewERR'))?_c('span',{staticClass:"edit-icon-container",on:{"click":_vm.slideEditAttribute}},[_c('icon',{attrs:{"name":"chevron-down"}})],1):_vm._e(),(_vm.$isAllowed('viewAdmin') || _vm.$isAllowed('viewERR'))?_c('div',{staticClass:"edit-attribute",attrs:{"title":"Editar"}},[_c('selectize',{model:{value:(_vm.complaint.category),callback:function ($$v) {_vm.complaint.category=(typeof $$v === 'string'? $$v.trim(): $$v)},expression:"complaint.category"}},_vm._l((_vm.categories),function(category,index){return _c('option',{domProps:{"value":index}},[_vm._v(_vm._s(category.description))])})),_c('b-btn',{attrs:{"title":"Guardar cambio","variant":"outline-success"},on:{"click":_vm.updateComplaintAttributes}},[_c('icon',{attrs:{"name":"save"}})],1)],1):_vm._e()])]),_c('li',[_c('span',{staticClass:"meta-info-title"},[_vm._v("Exigencia")]),_c('span',{staticClass:"complaint-meta-value"},[_vm._v(_vm._s(_vm.complaint.comment))]),(_vm.$isAllowed('viewAdmin') || _vm.$isAllowed('viewERR'))?_c('span',{staticClass:"edit-icon-container",on:{"click":_vm.slideEditAttribute}},[_c('icon',{attrs:{"name":"chevron-down"}})],1):_vm._e(),(_vm.$isAllowed('viewAdmin') || _vm.$isAllowed('viewERR'))?_c('div',{staticClass:"edit-attribute",attrs:{"title":"Editar"}},[_c('b-input',{model:{value:(_vm.complaint.comment),callback:function ($$v) {_vm.complaint.comment=$$v},expression:"complaint.comment"}}),_c('b-btn',{attrs:{"title":"Guardar cambio","variant":"outline-success"},on:{"click":_vm.updateComplaintAttributes}},[_c('icon',{attrs:{"name":"save"}})],1)],1):_vm._e()])]),(this.complaint.additional_infos && this.complaint.additional_infos.length > 0 && this.complaint.source === 'voice')?_c('audio',{attrs:{"controls":"controls"}},[_c('source',{attrs:{"src":this.complaint.additional_infos[0].url,"type":"audio/mpeg"}})]):_vm._e(),(_vm.complaint.description)?_c('blockquote',{staticClass:"card-text"},[_c('pre',[_vm._v(_vm._s(_vm.complaint.description))])]):_vm._e()]),_c('hr'),_c('b-card',{staticClass:"tabs-container",attrs:{"no-body":"no-body"}},[_c('b-tabs',{ref:"tabs",attrs:{"card":"card"}},[_c('b-tab',{attrs:{"title":"Pasajes afectados","active":"active"}},[(_vm.complaint.ticket_info && _vm.complaint.ticket_info.tickets.length > 0)?_c('h5',[_vm._v("Información de los pasajes afectados")]):_vm._e(),(_vm.complaint.ticket_info && _vm.complaint.ticket_info.tickets.length > 0)?_c('table',{staticClass:"table"},[_c('tr',{directives:[{name:"show",rawName:"v-show",value:(_vm.complaint.ticket_info.booking_number),expression:"complaint.ticket_info.booking_number"}]},[_c('td',[_vm._v("Número de Compra")]),_c('td',[_vm._v(_vm._s(_vm.complaint.ticket_info.booking_number))])]),_c('tr',{directives:[{name:"show",rawName:"v-show",value:(_vm.complaint.ticket_info.tickets.length > 0),expression:"complaint.ticket_info.tickets.length > 0"}]},[_c('td',[_vm._v("Pasajes afectados")]),_c('td',[_vm._v(_vm._s(_vm.complaint.ticket_info.tickets.join(', ')))])]),_c('tr',[_c('td',[_vm._v("Empresa(s)")]),_c('td',[_vm._v(_vm._s(_vm._f("formatOperator")(_vm.complaint.ticket_info.bus_operators)))])]),_c('tr',[_c('td',[_vm._v("Fecha de salida (Ida)")]),_c('td',[_vm._v(_vm._s(_vm._f("formatDate")(_vm.complaint.ticket_info.departure)))])]),_c('tr',[_c('td',[_vm._v("Hora de salida (Ida)")]),_c('td',[_vm._v(_vm._s(_vm._f("formatHour")(_vm.complaint.ticket_info.departure)))])]),(_vm.complaint.ticket_info.arrival)?_c('tr',[_c('td',[_vm._v("Fecha de salida (Vuelta)")]),_c('td',[_vm._v(_vm._s(_vm._f("formatDate")(_vm.complaint.ticket_info.arrival)))])]):_vm._e(),(_vm.complaint.ticket_info.arrival)?_c('tr',[_c('td',[_vm._v("Hora de salida (Vuelta)")]),_c('td',[_vm._v(_vm._s(_vm._f("formatHour")(_vm.complaint.ticket_info.arrival)))])]):_vm._e(),_c('tr',[_c('td',[_vm._v("Método de pago")]),_c('td',[_vm._v(_vm._s(_vm.complaint.ticket_info.payment_method))])]),_c('tr',[_c('td',[_vm._v("Precio")]),_c('td',[_vm._v(_vm._s(_vm.complaint.ticket_info.price)+" "+_vm._s(_vm.complaint.ticket_info.sold_currency))])]),_c('tr',[_c('td',[_vm._v("Precio IBC")]),_c('td',[_vm._v(_vm._s(_vm.complaint.ticket_info.price_ibc))])]),_c('tr',[_c('td',[_vm._v("Comprador")]),_c('td',[_vm._v(_vm._s(_vm.complaint.ticket_info.fullname))])]),_c('tr',[_c('td',[_vm._v("Email comprador")]),_c('td',[_vm._v(_vm._s(_vm.complaint.ticket_info.email))])])]):_vm._e()]),_c('b-tab',{attrs:{"title":"Adjuntos"}},[_c('vue-dropzone',{ref:"attachmentsDrop",attrs:{"id":"dropzone","options":_vm.dropzoneOptions},on:{"vdropzone-success":_vm.fetchComplaint}}),(_vm.complaint.additional_infos)?_c('b-list-group',[_c('hr'),_c('h3',[_vm._v("Archivos adjuntos")]),_vm._l((_vm.complaint.additional_infos),function(info){return (info.url !== null)?_c('div',{staticClass:"list-group-item list-group-item-action"},[(info.format === 'mp3')?_c('span',[_c('audio',{attrs:{"controls":"controls"}},[_c('source',{attrs:{"src":info.url,"type":"audio/mpeg"}})])]):_c('div',[(['png', 'jpg', 'jpeg', 'gif'].includes(info.format))?_c('div',{staticClass:"attachment_content"},[_c('b-btn',{on:{"click":function($event){_vm.openFileModal(info._id.$oid)}}},[_c('icon',{attrs:{"name":"image"}}),_vm._v(" "+_vm._s(((info.name) + "." + (info.format))))],1),_c('b-modal',{ref:("imageModal-" + (info._id.$oid)),refInFor:true,staticClass:"image-modal"},[_c('img',{attrs:{"src":_vm.signedLink}}),_c('div',{attrs:{"slot":"modal-cancel"},slot:"modal-cancel"},[_vm._v("Cerrar")]),_c('div',{attrs:{"slot":"modal-ok"},slot:"modal-ok"},[_c('a',{attrs:{"href":_vm.signedLink,"target":"_blank"}},[_vm._v("Abrir en pestaña externa")])])])],1):(info.format === 'pdf')?_c('div',{staticClass:"attachment_content"},[_c('a',{on:{"click":function($event){_vm.openFileTab(info._id.$oid)}}},[_c('icon',{attrs:{"name":"paperclip"}}),_vm._v(" "+_vm._s(((info.name) + "." + (info.format)))+"  "),_c('icon',{attrs:{"name":"external-link"}})],1)]):_c('span',[_c('a',{on:{"click":function($event){_vm.dowloadFile(info._id.$oid)}}},[_c('icon',{attrs:{"name":"paperclip"}}),_vm._v(" "+_vm._s(((info.name) + "." + (info.format)))+"  "),_c('icon',{attrs:{"name":"download"}})],1)]),(_vm.$isAllowed('deleteAttachment'))?_c('div',{staticClass:"attachment_actions"},[_c('b-btn',{attrs:{"size":"xs"},on:{"click":function($event){_vm.deleteAttachment(info._id.$oid)}}},[_c('icon',{attrs:{"name":"trash"}}),_vm._v(" Eliminar")],1)],1):_vm._e()])]):_vm._e()})],2):_vm._e()],1),_c('b-tab',{attrs:{"title":"Solicitudes de información"}},[_c('input',{attrs:{"id":"requestFile","type":"file","hidden":"hidden"},on:{"change":function($event){_vm.uploadFile()}}}),_c('b-form',{on:{"submit":function($event){$event.preventDefault();_vm.requestInfo($event)}}},[_c('b-input-group',[_c('b-form-input',{staticClass:"form-control",attrs:{"placeholder":"Información a solicitar"},model:{value:(_vm.info_request),callback:function ($$v) {_vm.info_request=(typeof $$v === 'string'? $$v.trim(): $$v)},expression:"info_request"}}),_c('b-input-group-button',{attrs:{"slot":"right"},slot:"right"},[_c('b-btn',{attrs:{"type":"submit","variant":"primary"}},[_vm._v("Solicitar")])],1)],1)],1),(_vm.requests)?_c('b-list-group',[_c('hr'),_vm._l((_vm.requests),function(r){return _c('b-list-group-item',{key:r.name},[_c('icon',{attrs:{"name":"inbox"}}),_c('span',{domProps:{"innerHTML":_vm._s(r.request)}}),(r.url === null)?_c('button',{staticClass:"float-right",attrs:{"variant":"primary"},on:{"click":function($event){_vm.addFile(r._id.$oid)}}},[_c('icon',{attrs:{"name":"paperclip"}}),_vm._v("Adjuntar")],1):_vm._e(),(r.url !== null)?_c('a',{staticClass:"float-right",attrs:{"href":r.url}},[_vm._v(_vm._s(((r.name) + "." + (r.format))))]):_vm._e()],1)})],2):_vm._e()],1),_c('b-tab',{attrs:{"title":_vm.commentsTitle}},[_c('comments',{ref:"comments",attrs:{"complaint":_vm.complaint._id.$oid}})],1),_c('b-tab',{attrs:{"title":"Historial de acciones"}},[_c('last-activity',{ref:"activity",attrs:{"complaint":_vm.complaint._id.$oid}})],1)],1)],1)],1)],1):_c('icon',{staticClass:"loading-section",attrs:{"name":"spinner","scale":"5","pulse":"pulse"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "7pL4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{attrs:{"fluid":"fluid"}},[_c('b-row',[_c('b-col',{attrs:{"md":"12","lg":"6"}},[_c('b-form-group',[_c('vue-editor',{model:{value:(_vm.content),callback:function ($$v) {_vm.content=$$v},expression:"content"}})],1),_c('div',{staticClass:"text-center"},[_c('b-btn',{attrs:{"variant":"primary"},on:{"click":function($event){_vm.postComment()}}},[_vm._v("Comentar")])],1)],1),_c('b-col',{attrs:{"md":"12","lg":"6"}},[(_vm.comments)?_c('h3',[_vm._v("Comentarios")]):_c('small',[_vm._v("Aún no hay comentarios")]),_vm._l((_vm.comments),function(comment){return _c('ul',{key:comment.id.$oid,staticClass:"complaint-comments"},[_c('li',{staticClass:"single-complaint-comment"},[_c('span',{staticClass:"comment-content",domProps:{"innerHTML":_vm._s(comment.content)}}),_c('p',{staticClass:"comment-meta",attrs:{"title":_vm._f("formatDate")(comment.created_at)}},[_c('small',[_vm._v(_vm._s(comment.user_name)+" - "+_vm._s(_vm._f("formatCommentDate")(comment.created_at)))])])])])})],2)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "7q3b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__("IcnI");
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'logout',
  mounted: function mounted() {
    window.localStorage.clear();
    __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].commit('logout');
    __WEBPACK_IMPORTED_MODULE_0__router__["a" /* default */].push('login');
  }
});

/***/ }),

/***/ "83/Z":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8WzD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',[_c('b-col',{attrs:{"md":"4"}}),_c('b-col',{attrs:{"cols":"12","md":"4"}},[_c('h2',[_vm._v("Crear contraseña")]),_c('notifications',{attrs:{"group":"auth","position":"top center"}}),_c('form',{on:{"submit":function($event){$event.preventDefault();_vm.createPassword($event)}}},[_c('b-form-group',{attrs:{"label":"Contraseña","label-for":"user-password"}},[_c('b-form-input',{directives:[{name:"validate",rawName:"v-validate",value:('required|min:8|verify_password'),expression:"'required|min:8|verify_password'"}],ref:"password",staticClass:"field form-control",attrs:{"name":"password","type":"password","placeholder":"******","id":"user-password","data-vv-as":"contraseña"},model:{value:(_vm.password),callback:function ($$v) {_vm.password=(typeof $$v === 'string'? $$v.trim(): $$v)},expression:"password"}}),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('password')),expression:"errors.has('password')"}],staticClass:"danger"},[_vm._v(_vm._s(_vm.errors.first('password')))])],1),_c('b-form-group',{attrs:{"label":"Confirmar contraseña","label-for":"user-confirmation-password"}},[_c('b-form-input',{directives:[{name:"validate",rawName:"v-validate",value:('required|confirmed:password'),expression:"'required|confirmed:password'"}],staticClass:"field form-control",attrs:{"name":"password_confirmation","type":"password","placeholder":"******","id":"user-confirmation-password","data-vv-as":"confirmación contraseña"},model:{value:(_vm.password_confirmation),callback:function ($$v) {_vm.password_confirmation=(typeof $$v === 'string'? $$v.trim(): $$v)},expression:"password_confirmation"}}),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('password_confirmation')),expression:"errors.has('password_confirmation')"}],staticClass:"danger"},[_vm._v(_vm._s(_vm.errors.first('password_confirmation')))])],1),_c('div',{staticClass:"text-center form-group"},[_c('button',{staticClass:"btn btn-default btn-primary btn-lg"},[_vm._v("Guardar")])])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "95Fp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'action_button',
  props: ['variant', 'actionId', 'text'],
  data: function data() {
    return {
      action: {}
    };
  },

  methods: {
    updateStatus: function updateStatus($event, statusId) {
      var buttons = document.querySelectorAll('.buttons-container .btn');
      var complaintActions = document.querySelector('.complaint-actions');
      var thisButton = $event.target;
      var inactiveClass = 'btn-inactive';
      var selected = this.$store.state.selected.aasm_state;

      complaintActions.classList.add('has-active-option');

      buttons.forEach(function (currentButton) {
        currentButton.classList.remove(inactiveClass);

        if (currentButton !== thisButton) {
          currentButton.classList.add(inactiveClass);
        }
      });

      this.action.status = statusId;

      // TODO: Refactor. This code is too complex
      if (this.action.status === 'rejected_communication' && ['pending_err', 'pending_edb'].includes(selected)) {
        this.$emit('extra', { code: 'rejection', next: statusId });
      } else if (this.action.status === 'approved_reimbursement') {
        this.$emit('extra', { code: 'approval', next: statusId });
      } else if (this.action.status === 'pending_edb') {
        this.$emit('extra', { code: 'bus-operator', next: statusId });
      } else if (this.action.status === 'pending_info') {
        this.$emit('extra', { code: 'more-information', next: statusId });
      } else if (this.action.status === 'pending_requested') {
        this.$emit('extra', { code: 'more-information', next: statusId });
      } else if (this.action.status === 'notified_rejection') {
        this.$emit('extra', { code: 'rejection-message', next: statusId });
      } else if (this.action.status === 'notified_approval' && ['approved_communication'].includes(selected)) {
        this.$emit('extra', { code: 'approval-message', next: statusId });
      } else if (this.action.status === 'pending_err') {
        this.$emit('extra', { code: 'to-err', next: statusId });
      } else {
        this.$emit('extra', { code: '-', next: statusId });
      }
    }
  }
});

/***/ }),

/***/ "97At":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ReloadAppDialog',{attrs:{"showDialog":_vm.showDialog}}),_c('b-row',{staticClass:"top-bar"},[_c('notifications',{attrs:{"group":"request","position":"top center"}}),_c('b-col',{attrs:{"md":"11","offset-md":"1"}},[_c('h4',[_vm._v("Usuarios ("+_vm._s(_vm.pagination.total)+")")])]),_c('b-col',{attrs:{"md":"4","offset-md":"1"}},[_c('b-input-group',[_c('b-form-input',{attrs:{"placeholder":"Filtrar por nombre"},nativeOn:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13)){ return null; }_vm.fetchUsers(1)}},model:{value:(_vm.search.text),callback:function ($$v) {_vm.search.text=$$v},expression:"search.text"}}),_c('b-input-group-button',{attrs:{"slot":"right"},slot:"right"},[_c('b-btn',{attrs:{"variant":"primary"},on:{"click":function($event){_vm.fetchUsers(1)}}},[_c('icon',{attrs:{"name":"search"}})],1)],1)],1)],1),_c('b-col',{attrs:{"md":"6","align":"right"}},[(_vm.$isAllowed('createUser'))?_c('b-btn',{attrs:{"variant":"primary"},on:{"click":_vm.createUser}},[_vm._v("Agregar usuario")]):_vm._e()],1)],1),_c('b-row',{staticClass:"justify-content-md-center"},[_c('b-col',{attrs:{"md":"10"}},[_c('b-table',{attrs:{"hover":"hover","fields":_vm.userFields,"items":_vm.users,"striped":"striped"},scopedSlots:_vm._u([{key:"HEAD_active",fn:function(active){return [_vm._v(_vm._s(active.label)),_c('b-form-group',{staticClass:"mb-0"},[_c('b-form-select',{attrs:{"options":_vm.active_options},on:{"input":function($event){_vm.fetchUsers(1)}},model:{value:(_vm.search.active),callback:function ($$v) {_vm.search.active=$$v},expression:"search.active"}})],1)]}},{key:"HEAD_role",fn:function(role){return [_vm._v(_vm._s(role.label)),_c('b-form-group',{staticClass:"mb-0"},[_c('b-form-select',{attrs:{"options":_vm.role_options},on:{"input":function($event){_vm.fetchUsers(1)}},model:{value:(_vm.search.role),callback:function ($$v) {_vm.search.role=$$v},expression:"search.role"}})],1)]}},{key:"actions",fn:function(thisUser){return [_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover.top",value:('Editar'),expression:"'Editar'",modifiers:{"hover":true,"top":true}}],staticClass:"icon-button",attrs:{"variant":"link"},on:{"click":function($event){_vm.loadUser(thisUser.item)}}},[_c('icon',{attrs:{"name":"edit"}})],1),_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover.top",value:('Enviar email de recuperación'),expression:"'Enviar email de recuperación'",modifiers:{"hover":true,"top":true}}],staticClass:"icon-button",attrs:{"variant":"link"},on:{"click":function($event){_vm.recoverPassword(thisUser.item)}}},[_c('icon',{attrs:{"name":"envelope-o"}})],1),_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover.top",value:('Eliminar usuario'),expression:"'Eliminar usuario'",modifiers:{"hover":true,"top":true}}],staticClass:"icon-button",attrs:{"variant":"link"},on:{"click":function($event){_vm.deleteUser(thisUser.item)}}},[_c('icon',{attrs:{"name":"user-times"}})],1),_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover.top",value:('Desactivar/Activar cuenta'),expression:"'Desactivar/Activar cuenta'",modifiers:{"hover":true,"top":true}}],staticClass:"icon-button",attrs:{"variant":"link"},on:{"click":function($event){_vm.shiftActive(thisUser.item)}}},[_c('icon',{attrs:{"name":"ban"}})],1)]}}])}),(_vm.users.length > 0)?_c('b-pagination',{attrs:{"align":"center","total-rows":_vm.pagination.total,"per-page":_vm.pagination.per_page},on:{"change":_vm.changePage},model:{value:(_vm.pagination.current),callback:function ($$v) {_vm.pagination.current=$$v},expression:"pagination.current"}}):_vm._e()],1)],1),_c('b-form',{staticClass:"form-horizontal",on:{"submit":_vm.onSubmit}},[_c('b-modal',{attrs:{"busy":true,"size":"lg","title":_vm.action === 'create' ? 'Crear nuevo usuario' : 'Editar usuario',"no-close-on-backdrop":"no-close-on-backdrop"},on:{"hide":function($event){_vm.closeModal(_vm.user)}},model:{value:(_vm.modalShow),callback:function ($$v) {_vm.modalShow=$$v},expression:"modalShow"}},[_c('b-form-group',{attrs:{"label":"Correo electrónico"}},[_c('b-form-input',{directives:[{name:"validate",rawName:"v-validate",value:('required|email'),expression:"'required|email'"}],staticClass:"form-control",attrs:{"data-vv-as":"correo","name":"user[email]","type":"email","autocomplete":"off","disabled":_vm.user.active},model:{value:(_vm.user.email),callback:function ($$v) {_vm.user.email=$$v},expression:"user.email"}}),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('user[email]')),expression:"errors.has('user[email]')"}],staticClass:"danger"},[_vm._v(_vm._s(_vm.errors.first('user[email]')))])],1),_c('b-form-group',{attrs:{"label":"Nombre"}},[_c('b-form-input',{directives:[{name:"validate",rawName:"v-validate",value:('required|min:4'),expression:"'required|min:4'"}],staticClass:"form-control",attrs:{"data-vv-as":"nombre","name":"user[name]","type":"text","autocomplete":"off"},model:{value:(_vm.user.name),callback:function ($$v) {_vm.user.name=$$v},expression:"user.name"}}),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('user[name]')),expression:"errors.has('user[name]')"}],staticClass:"danger"},[_vm._v(_vm._s(_vm.errors.first('user[name]')))])],1),_c('b-form-group',{attrs:{"label":"Apellido"}},[_c('b-form-input',{directives:[{name:"validate",rawName:"v-validate",value:('required|min:4'),expression:"'required|min:4'"}],staticClass:"form-control",attrs:{"data-vv-as":"apellido","name":"user[last_name]","type":"text","autocomplete":"off"},model:{value:(_vm.user.last_name),callback:function ($$v) {_vm.user.last_name=$$v},expression:"user.last_name"}}),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('user[last_name]')),expression:"errors.has('user[last_name]')"}],staticClass:"danger"},[_vm._v(_vm._s(_vm.errors.first('user[last_name]')))])],1),_c('b-form-group',{attrs:{"label":"Rol"}},[_c('b-form-select',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"data-vv-as":"rol","name":"user[role]","options":_vm.role_options,"autocomplete":"off"},model:{value:(_vm.user.role),callback:function ($$v) {_vm.user.role=$$v},expression:"user.role"}}),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('user[role]')),expression:"errors.has('user[role]')"}],staticClass:"danger"},[_vm._v(_vm._s(_vm.errors.first('user[role]')))])],1),_c('b-form-group',{attrs:{"label":"Subteam"}},[_c('b-form-select',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"data-vv-as":"subteam","name":"user[subteam]","options":_vm.subteam_options,"autocomplete":"off"},model:{value:(_vm.user.subteam),callback:function ($$v) {_vm.user.subteam=$$v},expression:"user.subteam"}}),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('user[subteam]')),expression:"errors.has('user[subteam]')"}],staticClass:"danger"},[_vm._v(_vm._s(_vm.errors.first('user[subteam]')))])],1),_c('div',{attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('b-btn',{staticClass:"btn-space",attrs:{"variant":"secondary"},on:{"click":function($event){_vm.closeModal(_vm.user)}}},[_vm._v("Cancelar")]),_c('b-btn',{staticClass:"btn-space",attrs:{"variant":"primary","type":"submit"}},[_vm._v(_vm._s(_vm.action === 'create' ? 'Registrar' : 'Actualizar'))])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "9BHd":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9M+g":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9NIY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return changeTitle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return filterParams; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);

/* eslint-disable no-unused-vars no-undef */

var changeTitle = function changeTitle(to, from, next) {
  var name = to.name;


  var TITLE = {
    login: 'Iniciar sesión',
    complaints: 'Todos los Reclamos',
    new: 'Nuevo Reclamo',
    new_pre_approved: 'Nuevo Reclamo Pre aprobado',
    operators: 'Empresas de buses',
    finance: 'Finanzas',
    all: 'Todos los Reclamos',
    confirm_email: 'Confirmar correo'
  };

  document.title = 'Recorrido';

  if (TITLE[name]) {
    document.title = TITLE[name] + ' | recorrido';
  }

  next();
};

/* eslint no-param-reassign: ["error", { "props": false }] */
var filterParams = function filterParams(params, status) {
  var mappings = {
    approved_reimbursement: ['reimbursement'],
    approved_communication: ['internal_messages'],
    rejected_communication: ['internal_messages'],
    pending_edb: ['response'],
    pending_info: ['internal_messages'],
    pending_requested: ['internal_messages'],
    rejected: ['response'],
    closed: ['response'],
    notified_rejection: ['response'],
    notified_approval: ['response'],
    pending_err: ['response'],
    reimbursement_error: ['response']
  };

  if (status === 'pending_err' || status === 'refunded_ecommerce' || status === 'rejected_ecommerce') {
    return [];
  }
  var filtered = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(params).filter(function (key) {
    return mappings[status].includes(key);
  }).reduce(function (obj, key) {
    obj[key] = params[key];
    return obj;
  }, {});
  return filtered;
};



/***/ }),

/***/ "9eaa":
/***/ (function(module, exports) {

module.exports = {"status":{"disclaimer":{"advise":"Recorrido.pe se contactará con la empresa de bus respectiva y actuará como intermediario entre usted y esta con la finalidad de obtener una resolución a su requerimiento. Recorrido.pe no tiene incidencia en las operaciones ni el tráfico de los operadores, solo comercializamos sus pasajes a través de nuestra plataforma online.","contact":"Lo contactaremos una vez que tengamos la respuesta de la empresa de buses, le pedimos disculpas de antemano, esto puede tardar algunos días."}}}

/***/ }),

/***/ "AkGe":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "BYbG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "CJ5O":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{staticClass:"action",attrs:{"variant":_vm.variant},on:{"click":function($event){_vm.updateStatus($event, _vm.actionId)}}},[_vm._v(_vm._s(_vm.text))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "CZfS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_apiService__ = __webpack_require__("a/3G");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__perimeters_operatorsPerimeter__ = __webpack_require__("2YqD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue2_selectize__ = __webpack_require__("py5U");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue2_selectize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue2_selectize__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue2_editor__ = __webpack_require__("m6he");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue2_editor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue2_editor__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint no-console: ["error", { allow: ["warn", "error", "log"] }] */





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'operators',
  components: {
    Selectize: __WEBPACK_IMPORTED_MODULE_2_vue2_selectize___default.a,
    VueEditor: __WEBPACK_IMPORTED_MODULE_3_vue2_editor__["VueEditor"]
  },
  data: function data() {
    return {
      operatorFields: {
        name: {
          label: 'Nombre',
          sortable: true
        },
        auto: {
          label: 'Envío automático',
          sortable: true
        },
        email: {
          label: 'Correo Electrónico',
          sortable: true
        },
        asignee: {
          label: 'Remitente',
          sortable: true
        },
        reminder: {
          label: 'Recordatorio',
          sortable: true
        }
      },
      operators: [],
      err: [],
      operator: {},
      modalShow: false,
      action: null,
      search: '',
      customToolbar: [['bold', 'italic', 'underline'], [{ list: 'ordered' }, { list: 'bullet' }]],
      showDialog: false,
      intervalId: null
    };
  },

  perimeters: [__WEBPACK_IMPORTED_MODULE_1__perimeters_operatorsPerimeter__["a" /* default */]],
  computed: {
    filteredOperators: function filteredOperators() {
      var _this = this;

      return this.operators.filter(function (item) {
        return item.name.toLowerCase().indexOf(_this.search.toLowerCase()) > -1;
      });
    }
  },
  created: function created() {
    this.fetchOperators();
    this.fetchERR();
  },
  beforeMount: function beforeMount() {
    this.refreshReloaAppStatus();
  },

  methods: {
    fetchOperators: function fetchOperators() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_0__services_apiService__["a" /* default */].get_operators().then(function (data) {
        _this2.operators = data.body;
      });
    },
    fetchERR: function fetchERR() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_0__services_apiService__["a" /* default */].err().then(function (data) {
        _this3.err = data.body;
      });
    },
    loadOperator: function loadOperator(operator) {
      this.operator = operator;
      this.action = 'update';
      this.modalShow = true;
    },
    createOperator: function createOperator() {
      this.operator = {};
      this.action = 'create';
      this.modalShow = true;
    },
    registerOperator: function registerOperator() {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_0__services_apiService__["a" /* default */].create_operator(this.operator).then(function () {
        _this4.modalShow = false;
        _this4.fetchOperators();
      });
    },
    updateOperator: function updateOperator() {
      var _this5 = this;

      __WEBPACK_IMPORTED_MODULE_0__services_apiService__["a" /* default */].update_operator(this.operator, this.operator.id).then(function () {
        _this5.action = null;
        _this5.modalShow = false;
        _this5.fetchOperators();
      });
    },
    closeModal: function closeModal() {
      this.action = null;
      this.modalShow = false;
    },
    refreshReloaAppStatus: function refreshReloaAppStatus() {
      var _this6 = this;

      this.intervalId = setInterval(function () {
        __WEBPACK_IMPORTED_MODULE_0__services_apiService__["a" /* default */].reloadAppStatus().then(function (response) {
          if (response.body) {
            _this6.showDialog = true;
          }
        });
      }, 900000);
    }
  },
  beforeDestroy: function beforeDestroy() {
    clearInterval(this.intervalId);
  }
});

/***/ }),

/***/ "Ccy/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ConfirmEmail_vue__ = __webpack_require__("kYY1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_593ff376_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_ConfirmEmail_vue__ = __webpack_require__("2X/Z");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ConfirmEmail_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_593ff376_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_ConfirmEmail_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "D4uH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Icon_vue__ = __webpack_require__("dXrS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_ab946280_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_Icon_vue__ = __webpack_require__("/E8i");
function injectStyle (ssrContext) {
  __webpack_require__("1AIU")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Icon_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_ab946280_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_Icon_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "DaHx":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "DnFM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-form',{staticClass:"form-horizontal",on:{"submit":function($event){$event.preventDefault();_vm.updateBank($event)}}},[(_vm.complaint.country === 'CL')?_c('div',[_c('b-form-group',{attrs:{"label":"Nombre"}},[_c('b-form-input',{directives:[{name:"validate",rawName:"v-validate",value:('required|alpha_spaces|max:40'),expression:"'required|alpha_spaces|max:40'"}],staticClass:"form-control",attrs:{"data-vv-as":"nombre","name":"bank_account[name]","required":"required"},model:{value:(_vm.complaint.bank_account.name),callback:function ($$v) {_vm.complaint.bank_account.name=(typeof $$v === 'string'? $$v.trim(): $$v)},expression:"complaint.bank_account.name"}}),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('bank_account[name]')),expression:"errors.has('bank_account[name]')"}],staticClass:"has-error"},[_vm._v(_vm._s(_vm.errors.first('bank_account[name]')))])],1),_c('b-form-group',{attrs:{"label":"RUT"}},[_c('b-form-input',{directives:[{name:"rut",rawName:"v-rut:live",arg:"live"},{name:"validate",rawName:"v-validate",value:('required|rut|max:12'),expression:"'required|rut|max:12'"}],staticClass:"form-control",attrs:{"data-vv-as":"rut","name":"bank_account[rut]","required":"required"},model:{value:(_vm.complaint.bank_account.rut),callback:function ($$v) {_vm.complaint.bank_account.rut=(typeof $$v === 'string'? $$v.trim(): $$v)},expression:"complaint.bank_account.rut"}}),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('bank_account[rut]')),expression:"errors.has('bank_account[rut]')"}],staticClass:"has-error"},[_vm._v("Ingrese un rut válido")])],1),_c('b-form-group',{attrs:{"label":"Banco"}},[_c('selectize',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"data-vv-as":"banco","name":"bank_account[bank]"},on:{"input":function($event){_vm.account_types($event)}},model:{value:(_vm.complaint.bank_account.bank),callback:function ($$v) {_vm.complaint.bank_account.bank=$$v},expression:"complaint.bank_account.bank"}},_vm._l((_vm.banks),function(bank){return _c('option',{key:bank,domProps:{"value":bank}},[_vm._v(_vm._s(bank))])})),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('bank_account[bank]')),expression:"errors.has('bank_account[bank]')"}],staticClass:"has-error"},[_vm._v(_vm._s(_vm.errors.first('bank_account[bank]')))])],1),_c('b-form-group',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover.leftbottom",value:(_vm.accounts.length === 0 ? 'Debe seleccionar el banco primero' : ''),expression:"accounts.length === 0 ? 'Debe seleccionar el banco primero' : ''",modifiers:{"hover":true,"leftbottom":true}}],attrs:{"label":"Tipo de cuenta"}},[_c('selectize',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"id":"account-type","data-vv-as":"tipo de cuenta","name":"bank_account[type]","disabled":_vm.accounts.length === 0},model:{value:(_vm.complaint.bank_account.account_type),callback:function ($$v) {_vm.complaint.bank_account.account_type=$$v},expression:"complaint.bank_account.account_type"}},_vm._l((_vm.accounts),function(account){return _c('option',{key:account.code,domProps:{"value":account.code}},[_vm._v(_vm._s(account.description))])})),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('bank_account[type]')),expression:"errors.has('bank_account[type]')"}],staticClass:"has-error"},[_vm._v(_vm._s(_vm.errors.first('bank_account[type]')))])],1),_c('b-form-group',{attrs:{"label":"Número de cuenta"}},[_c('b-form-input',{directives:[{name:"validate",rawName:"v-validate",value:('required|numeric|max:17'),expression:"'required|numeric|max:17'"}],staticClass:"form-control",attrs:{"data-vv-as":"número de cuenta","name":"bank_account[number]"},model:{value:(_vm.complaint.bank_account.account_number),callback:function ($$v) {_vm.complaint.bank_account.account_number=(typeof $$v === 'string'? $$v.trim(): $$v)},expression:"complaint.bank_account.account_number"}}),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('bank_account[number]')),expression:"errors.has('bank_account[number]')"}],staticClass:"has-error"},[_vm._v(_vm._s(_vm.errors.first('bank_account[number]')))])],1),_c('b-form-group',{staticClass:"text-center"},[_c('b-button',{attrs:{"type":"submit","variant":"primary"}},[_vm._v(_vm._s(_vm.bank_button))])],1)],1):(_vm.complaint.country === 'PE')?_c('div',[_c('b-form-group',{attrs:{"label":"Tipo de documento"}},[_c('selectize',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"data-vv-as":"tipo de documento","name":"bank_account[document_type]"},model:{value:(_vm.complaint.bank_account.document_type),callback:function ($$v) {_vm.complaint.bank_account.document_type=$$v},expression:"complaint.bank_account.document_type"}},_vm._l((_vm.documents),function(document){return _c('option',{key:document,domProps:{"value":document}},[_vm._v(_vm._s(document))])})),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('bank_account[document_type]')),expression:"errors.has('bank_account[document_type]')"}],staticClass:"has-error"},[_vm._v(_vm._s(_vm.errors.first('bank_account[document_type]')))])],1),_c('b-form-group',{attrs:{"label":"Número de documento"}},[_c('b-form-input',{directives:[{name:"validate",rawName:"v-validate",value:('required|numeric'),expression:"'required|numeric'"}],staticClass:"form-control",attrs:{"data-vv-as":"número de documento","name":"bank_account[document_number]"},model:{value:(_vm.complaint.bank_account.document_number),callback:function ($$v) {_vm.complaint.bank_account.document_number=(typeof $$v === 'string'? $$v.trim(): $$v)},expression:"complaint.bank_account.document_number"}}),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('bank_account[document_number]')),expression:"errors.has('bank_account[document_number]')"}],staticClass:"has-error"},[_vm._v(_vm._s(_vm.errors.first('bank_account[document_number]')))])],1),_c('b-form-group',{attrs:{"label":"Nombre del titular"}},[_c('b-form-input',{directives:[{name:"validate",rawName:"v-validate",value:('required|alpha_spaces|max:40'),expression:"'required|alpha_spaces|max:40'"}],staticClass:"form-control",attrs:{"data-vv-as":"nombre","name":"bank_account[name]","required":"required"},model:{value:(_vm.complaint.bank_account.name),callback:function ($$v) {_vm.complaint.bank_account.name=(typeof $$v === 'string'? $$v.trim(): $$v)},expression:"complaint.bank_account.name"}}),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('bank_account[name]')),expression:"errors.has('bank_account[name]')"}],staticClass:"has-error"},[_vm._v(_vm._s(_vm.errors.first('bank_account[name]')))])],1),_c('b-form-group',{attrs:{"label":"Correo"}},[_c('b-form-input',{directives:[{name:"validate",rawName:"v-validate",value:('required|email'),expression:"'required|email'"}],staticClass:"form-control",attrs:{"data-vv-as":"correo","name":"bank_account[email]","type":"email","autocomplete":"off"},model:{value:(_vm.complaint.bank_account.email),callback:function ($$v) {_vm.complaint.bank_account.email=$$v},expression:"complaint.bank_account.email"}}),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('bank_account[email]')),expression:"errors.has('bank_account[email]')"}],staticClass:"has-error"},[_vm._v(_vm._s(_vm.errors.first('bank_account[email]')))])],1),_c('b-form-group',{attrs:{"label":"Banco"}},[_c('selectize',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"data-vv-as":"banco","name":"bank_account[bank]"},model:{value:(_vm.complaint.bank_account.bank),callback:function ($$v) {_vm.complaint.bank_account.bank=$$v},expression:"complaint.bank_account.bank"}},_vm._l((_vm.banks),function(bank){return _c('option',{key:bank,domProps:{"value":bank}},[_vm._v(_vm._s(bank))])})),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('bank_account[bank]')),expression:"errors.has('bank_account[bank]')"}],staticClass:"has-error"},[_vm._v(_vm._s(_vm.errors.first('bank_account[bank]')))])],1),_c('b-form-group',{attrs:{"label":"Tipo de cuenta"}},[_c('selectize',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"data-vv-as":"tipo de cuenta","name":"bank_account[type]"},model:{value:(_vm.complaint.bank_account.account_type),callback:function ($$v) {_vm.complaint.bank_account.account_type=$$v},expression:"complaint.bank_account.account_type"}},_vm._l((_vm.accounts),function(account){return _c('option',{key:account.code,domProps:{"value":account.code}},[_vm._v(_vm._s(account.description))])})),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('bank_account[type]')),expression:"errors.has('bank_account[type]')"}],staticClass:"has-error"},[_vm._v(_vm._s(_vm.errors.first('bank_account[type]')))])],1),_c('b-form-group',{attrs:{"label":"Número de cuenta"}},[_c('b-form-input',{directives:[{name:"validate",rawName:"v-validate",value:('required|numeric|max:17'),expression:"'required|numeric|max:17'"}],staticClass:"form-control",attrs:{"data-vv-as":"número de cuenta","name":"bank_account[number]"},model:{value:(_vm.complaint.bank_account.account_number),callback:function ($$v) {_vm.complaint.bank_account.account_number=(typeof $$v === 'string'? $$v.trim(): $$v)},expression:"complaint.bank_account.account_number"}}),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('bank_account[number]')),expression:"errors.has('bank_account[number]')"}],staticClass:"has-error"},[_vm._v(_vm._s(_vm.errors.first('bank_account[number]')))])],1),_c('b-form-group',{attrs:{"label":"CCI"}},[_c('b-form-input',{directives:[{name:"validate",rawName:"v-validate",value:('required|numeric'),expression:"'required|numeric'"}],staticClass:"form-control",attrs:{"data-vv-as":"CCI","name":"bank_account[cci]"},model:{value:(_vm.complaint.bank_account.cci),callback:function ($$v) {_vm.complaint.bank_account.cci=(typeof $$v === 'string'? $$v.trim(): $$v)},expression:"complaint.bank_account.cci"}}),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('bank_account[cci]')),expression:"errors.has('bank_account[cci]')"}],staticClass:"has-error"},[_vm._v(_vm._s(_vm.errors.first('bank_account[cci]')))])],1),_c('b-form-group',{staticClass:"text-center"},[_c('b-button',{attrs:{"type":"submit","variant":"primary"}},[_vm._v(_vm._s(_vm.bank_button))])],1)],1):_vm._e()]),_c('b-modal',{ref:"bankModal",attrs:{"size":"lg","hide-header":"hide-header","hide-footer":"hide-footer","no-close-on-backdrop":"no-close-on-backdrop"}},[_c('div',{staticClass:"modal-body"},[_c('p',{staticClass:"text-center cancellation-modal-success-icon"},[_c('icon',{attrs:{"name":"check","scale":"5"}})],1),_c('p',{staticClass:"text-center"},[_vm._v("Hemos recibido sus datos bancarios exitosamente. Por favor revise su correo electrónico.")]),_c('br'),_c('br'),_c('p',{staticClass:"text-center"},[_c('b-button',{staticClass:"btn btn-recorrido",on:{"click":_vm.closeModal}},[_vm._v("Cerrar")])],1)])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "E7HZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_apiService__ = __webpack_require__("a/3G");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__perimeters_categoriesPerimeter__ = __webpack_require__("gR+i");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ui_ToggleSwitch__ = __webpack_require__("kKUE");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





var parse = __webpack_require__("UVyn");

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'categories',
  components: {
    ToggleSwitch: __WEBPACK_IMPORTED_MODULE_4__ui_ToggleSwitch__["a" /* default */]
  },
  data: function data() {
    return {
      categoryFields: {
        name: { label: 'Categoría', sortable: true },
        urgency: {
          label: 'Urgencia',
          sortable: true,
          formatter: function formatter(value) {
            return {
              1: 'Normal',
              2: 'Medio',
              3: 'Urgente'
            }[value] || 'Desconocido';
          }
        },
        color: { label: 'Color', sortable: false },
        use_color: {
          label: 'Usar color',
          sortable: true,
          formatter: function formatter(value) {
            return value ? 'SI' : 'NO';
          }
        },
        actions: { label: 'Acciones' }
      },
      categories: [],
      category: {},
      modalShow: false,
      disableUseColor: false,
      pagination: {},
      current_page: 1,
      urgency_options: [{ value: 1, text: 'Normal' }, { value: 2, text: 'Medio' }, { value: 3, text: 'Urgente' }],
      showDialog: false,
      intervalId: null
    };
  },

  perimeters: [__WEBPACK_IMPORTED_MODULE_3__perimeters_categoriesPerimeter__["a" /* default */]],
  created: function created() {
    this.fetchCategories(1);
  },
  beforeMount: function beforeMount() {
    this.refreshReloaAppStatus();
  },

  methods: {
    fetchCategories: function fetchCategories(page) {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_2__services_apiService__["a" /* default */].get_categories(page).then(function (data) {
        _this.categories = data.body;
        _this.setPagination(data);
      });
    },
    setPagination: function setPagination(res) {
      var links = Object.prototype.hasOwnProperty.call(res.headers.map, 'links') ? parse(res.headers.map.link[0]) : null;
      var pagination = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
        current: parseInt(res.headers.map.page, 10),
        total: parseInt(res.headers.map.total, 10),
        per_page: parseInt(res.headers.map['per-page'], 10)
      }, links);
      this.pagination = pagination;
    },
    changePage: function changePage(page) {
      this.current_page = page;
      this.fetchCategories(page);
    },
    loadCategory: function loadCategory(category) {
      this.beforeEditingCache = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, category);
      this.category = category;
      this.modalShow = true;
    },
    updateCategory: function updateCategory() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_2__services_apiService__["a" /* default */].update_category(this.category, this.category.id).then(function () {
        _this2.modalShow = false;
        _this2.fetchCategories(_this2.current_page);
        _this2.$notify({
          group: 'request',
          type: 'success',
          title: 'Categoría modificada con éxito',
          duration: 3000
        });
      }).catch(function (response) {
        _this2.notifyError(response);
      });
    },
    closeModal: function closeModal(category) {
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(category, this.beforeEditingCache);
      this.$validator.reset();
      this.modalShow = false;
    },
    onSubmit: function onSubmit(event) {
      var _this3 = this;

      event.preventDefault();
      this.$validator.validate().then(function (valid) {
        if (valid) {
          _this3.updateCategory();
        }
      });
    },
    notifyError: function notifyError(response) {
      this.$notify({
        group: 'request',
        type: 'error',
        title: 'Error',
        text: response.body,
        duration: 3000
      });
    },
    refreshReloaAppStatus: function refreshReloaAppStatus() {
      var _this4 = this;

      this.intervalId = setInterval(function () {
        __WEBPACK_IMPORTED_MODULE_2__services_apiService__["a" /* default */].reloadAppStatus().then(function (response) {
          if (response.body) {
            _this4.showDialog = true;
          }
        });
      }, 900000);
    }
  },
  beforeDestroy: function beforeDestroy() {
    clearInterval(this.intervalId);
  },

  watch: {
    category: {
      handler: function handler(newCategory) {
        if (newCategory.urgency === 1) {
          this.category.use_color = false;
          this.disableUseColor = true;
        } else {
          this.disableUseColor = false;
        }
      },

      deep: true
    }
  }
});

/***/ }),

/***/ "EjrX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__basePerimeter__ = __webpack_require__("G0wa");


/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_0__basePerimeter__["a" /* default */]({
  purpose: 'complaints',
  govern: {
    'can createComplaint': function createComplaint() {
      return this.isCRM() || this.isAdmin();
    },
    'can manageOperators': function manageOperators() {
      return this.isAdmin();
    },
    'can manageUsers': function manageUsers() {
      return this.isAdmin();
    },
    'can manageCategories': function manageCategories() {
      return this.isAdmin();
    },
    'can viewFinance': function viewFinance() {
      return this.isAdmin() || this.isFDP();
    },
    'can viewAll': function viewAll() {
      return this.isERR();
    }
  }
}));

/***/ }),

/***/ "F6JL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{attrs:{"title":"Editar plantilla","no-close-on-backdrop":"no-close-on-backdrop"},on:{"hide":_vm.onHide},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[_c('b-form-textarea',{attrs:{"rows":8},model:{value:(_vm.draft),callback:function ($$v) {_vm.draft=$$v},expression:"draft"}}),_c('div',{attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('b-btn',{staticClass:"mr-2",attrs:{"variant":"secondary"},on:{"click":_vm.cancel}},[_vm._v("Cancelar")]),_c('b-btn',{attrs:{"variant":"primary"},on:{"click":_vm.save}},[_vm._v("Guardar")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "FKAQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',{staticClass:"justify-content-md-center"},[_c('ReloadAppDialog',{attrs:{"showDialog":_vm.showDialog}}),_c('b-col',{attrs:{"md":"9","offset-md":"3"}},[_c('h4',[_vm._v("Reclamos Recorrido")])]),_c('b-col',{attrs:{"md":"3"}},[_c('last-activity')],1),_c('b-col',{attrs:{"md":"9"}},[_c('b-row',[_c('b-col',{attrs:{"md":"4"}},[_c('b-nav',{staticClass:"nav-pills"},[_c('li',{staticClass:"nav-item filters-title"},[_vm._v("Filtrar por:")]),_c('li',{staticClass:"nav-item"},[_c('b-button',{attrs:{"variant":"primary","pressed":_vm.pending},on:{"update:pressed":function($event){_vm.pending=$event},"click":function($event){_vm.showPending($event)}}},[_vm._v("Pendientes"),(_vm.pending)?_c('span',[_vm._v("  ")]):_vm._e(),(_vm.pending)?_c('icon',{attrs:{"name":"check"}}):_vm._e()],1)],1),_c('li',{staticClass:"nav-item"},[_c('b-button',{attrs:{"variant":"link"},on:{"click":_vm.toggleAge}},[(_vm.sortAge)?_c('icon',{attrs:{"name":"chevron-down"}}):_c('icon',{attrs:{"name":"chevron-up"}}),_vm._v("Edad")],1)],1)])],1),_c('b-col',{attrs:{"md":"8"}},[_c('b-input-group',[_c('b-form-input',{nativeOn:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13)){ return null; }_vm.showPending($event)}},model:{value:(_vm.filterText),callback:function ($$v) {_vm.filterText=$$v},expression:"filterText"}}),_c('b-input-group-button',{attrs:{"slot":"right"},slot:"right"},[_c('b-btn',{attrs:{"variant":"primary"},on:{"click":_vm.showPending}},[_c('icon',{attrs:{"name":"search"}})],1)],1)],1)],1)],1),(_vm.complaints.length > 0)?_c('b-table',{attrs:{"hover":"hover","fields":_vm.complaintFields,"items":_vm.complaints},on:{"row-clicked":_vm.showComplaintDetails},scopedSlots:_vm._u([{key:"status",fn:function(thisComplaint){return [_c('div',{staticClass:"complaint-status-wrapper",class:("status-" + (_vm.statuses[thisComplaint.item.aasm_state].initials.toLowerCase())),attrs:{"id":("status-" + (thisComplaint.item._id.$oid))}},[_vm._v(_vm._s(_vm.statuses[thisComplaint.item.aasm_state].initials))]),_c('complaint-popover',{attrs:{"thisComplaint":thisComplaint.item,"popoverTarget":("status-" + (thisComplaint.item._id.$oid))}})]}},{key:"token",fn:function(thisComplaint){return [_vm._v(_vm._s(thisComplaint.item.ticket_info.booking_number))]}},{key:"category",fn:function(thisComplaint){return [_vm._v(_vm._s(thisComplaint.item.complaint_category.name))]}},{key:"comment",fn:function(thisComplaint){return [_c('div',{staticClass:"ellipsis",attrs:{"id":("comment-" + (thisComplaint.item._id.$oid))}},[_vm._v(_vm._s(thisComplaint.item.comment))]),_c('complaint-popover',{attrs:{"thisComplaint":thisComplaint.item,"popoverTarget":("comment-" + (thisComplaint.item._id.$oid))}})]}},{key:"age",fn:function(thisComplaint){return [_vm._v(_vm._s(_vm.complaintAge(thisComplaint.item)))]}},{key:"bus_operator",fn:function(thisComplaint){return [_vm._v(_vm._s(_vm.busOperators(thisComplaint.item)))]}},{key:"amount_requested",fn:function(thisComplaint){return [(thisComplaint.item.reimbursement)?_c('div',[(thisComplaint.item.reimbursement.compensation_type === 'm')?_c('span',[(['WebPay', 'Agencia', 'Fintoc', 'OneClick','Mercado Pago', 'Floid'].includes(thisComplaint.item.ticket_info.payment_method))?[_vm._v(_vm._s(_vm._f("currency")(thisComplaint.item.reimbursement.amount,'CLP $', 0, { thousandsSeparator: '.'})))]:[_vm._v(_vm._s(_vm._f("currency")(thisComplaint.item.reimbursement.amount,'USD $', 2, { thousandsSeparator: ',', decimalSeparator: '.' })))]],2):_c('span',[_vm._v("No monetario")])]):(thisComplaint.item.aasm_state === 'rejected')?_c('div',[_vm._v("Reclamo rechazado")]):_c('div',[_vm._v("Aún no está cerrado")])]}},{key:"edit_complaint",fn:function(thisComplaint){return [_c('router-link',{staticClass:"show-link",attrs:{"to":{ name: 'show_complaint', params: { complaint_id: thisComplaint.item._id.$oid } }}})]}}])}):_c('div',{staticClass:"no-complaints-left"},[_c('b-alert',{attrs:{"show":"show","variant":"warning"}},[_vm._v("No se encontraron reclamos")])],1),(_vm.complaints.length > 0)?_c('b-pagination',{attrs:{"align":"center","total-rows":_vm.pagination.total,"per-page":_vm.pagination.per_page},on:{"change":_vm.changePage},model:{value:(_vm.pagination.current),callback:function ($$v) {_vm.pagination.current=$$v},expression:"pagination.current"}}):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "FPDf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "FdwB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "G0wa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__("Zx67");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__("zwoO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__("Pf15");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_kindergarten__ = __webpack_require__("Ar/W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_kindergarten___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_kindergarten__);







var BasePerimeter = function (_Perimeter) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(BasePerimeter, _Perimeter);

  function BasePerimeter() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, BasePerimeter);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (BasePerimeter.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(BasePerimeter)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(BasePerimeter, [{
    key: 'isAdmin',
    value: function isAdmin() {
      return this.child && this.child.role === 1;
    }
  }, {
    key: 'isCRM',
    value: function isCRM() {
      return this.child && this.child.role === 2;
    }
  }, {
    key: 'isERR',
    value: function isERR() {
      return this.child && this.child.role === 3;
    }
  }, {
    key: 'isEDB',
    value: function isEDB() {
      return this.child && this.child.role === 4;
    }
  }, {
    key: 'isFDP',
    value: function isFDP() {
      return this.child && this.child.role === 5;
    }
  }]);

  return BasePerimeter;
}(__WEBPACK_IMPORTED_MODULE_5_vue_kindergarten__["Perimeter"]);

/* harmony default export */ __webpack_exports__["a"] = (BasePerimeter);

/***/ }),

/***/ "GBGs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('notifications',{attrs:{"group":"show_complaint","position":"top center"}}),(_vm.complaint.number)?_c('b-row',{staticClass:"justify-content-md-center"},[_c('ReloadAppDialog',{attrs:{"showDialog":_vm.showDialog}}),_c('b-col',{attrs:{"md":"3"}},[_c('b-card',{staticClass:"complaint-actions"},[_c('h4',[_vm._v("Proceder con reclamo")]),_c('h6',[_c('small',[_vm._v("Elige una de las opciones")])]),_c('actions',{attrs:{"complaint":_vm.complaint},on:{"sendUpdate":_vm.updateActivity}})],1)],1),_c('b-col',{attrs:{"md":"9"}},[_c('b-btn',{staticClass:"btn-back",on:{"click":_vm.back}},[_c('icon',{attrs:{"name":"chevron-left"}}),_vm._v(" Volver a Reclamos")],1),_c('b-card',{attrs:{"title":("Reclamo #" + (_vm.complaint.number))}},[_c('b-btn',{directives:[{name:"clipboard",rawName:"v-clipboard:copy",value:(_vm.public_url),expression:"public_url",arg:"copy"},{name:"clipboard",rawName:"v-clipboard:success",value:(_vm.notifyCopy),expression:"notifyCopy",arg:"success"}],attrs:{"size":"sm","title":"Copiar URL pública del reclamo en el portapapeles"}},[_vm._v("Copiar link "),_c('icon',{attrs:{"name":"copy"}})],1),_c('br'),_c('p',{staticClass:"complaint-main-meta"},[_vm._v("Registrado por "+_vm._s(_vm.complaint.agent_name)),_c('br'),_vm._v("Ingresado el "+_vm._s(_vm._f("formatDate")(_vm.complaint.created_at))+" - Edad "+_vm._s(_vm.complaintAge))]),_c('ul',{staticClass:"complaint-summary-meta"},[_c('li',[_c('span',{staticClass:"meta-info-title"},[_vm._v("Estado")]),_c('span',{staticClass:"complaint-meta-value complaint-status-wrapper",class:_vm.statusClassName(_vm.complaint)},[_vm._v(_vm._s(_vm._f("formatStatus")(_vm.complaint.aasm_state)))]),(_vm.$isAllowed('viewAdmin') || _vm.$isAllowed('viewERR'))?_c('span',{staticClass:"edit-icon-container",on:{"click":_vm.slideEditAttribute}},[_c('icon',{attrs:{"name":"chevron-down"}})],1):_vm._e(),(_vm.$isAllowed('viewAdmin') || _vm.$isAllowed('viewERR'))?_c('div',{staticClass:"edit-attribute",attrs:{"title":"Editar"}},[_c('selectize',{model:{value:(_vm.complaint.aasm_state),callback:function ($$v) {_vm.complaint.aasm_state=(typeof $$v === 'string'? $$v.trim(): $$v)},expression:"complaint.aasm_state"}},_vm._l((_vm.statuses),function(status,index){return _c('option',{domProps:{"value":index}},[_vm._v(_vm._s(status.description))])})),_c('b-btn',{attrs:{"title":"Guardar cambio","variant":"outline-success"},on:{"click":_vm.updateComplaintAttributes}},[_c('icon',{attrs:{"name":"save"}})],1)],1):_vm._e()]),_c('li',[_c('span',{staticClass:"meta-info-title"},[_vm._v("Categoría")]),_c('div',[_c('span',{staticClass:"complaint-meta-value"},[_vm._v(_vm._s(_vm.complaint.complaint_category.name))]),(_vm.$isAllowed('viewAdmin') || _vm.$isAllowed('viewERR'))?_c('span',{staticClass:"edit-icon-container",on:{"click":_vm.slideEditAttribute}},[_c('icon',{attrs:{"name":"chevron-down"}})],1):_vm._e(),(_vm.$isAllowed('viewAdmin') || _vm.$isAllowed('viewERR'))?_c('div',{staticClass:"edit-attribute",attrs:{"title":"Editar"}},[_c('selectize',{model:{value:(_vm.complaint.category),callback:function ($$v) {_vm.complaint.category=(typeof $$v === 'string'? $$v.trim(): $$v)},expression:"complaint.category"}},_vm._l((_vm.categories),function(category,index){return _c('option',{domProps:{"value":index}},[_vm._v(_vm._s(category.description))])})),_c('b-btn',{attrs:{"title":"Guardar cambio","variant":"outline-success"},on:{"click":_vm.updateComplaintAttributes}},[_c('icon',{attrs:{"name":"save"}})],1)],1):_vm._e()])]),_c('li',[_c('span',{staticClass:"meta-info-title"},[_vm._v("Exigencia")]),_c('span',{staticClass:"complaint-meta-value"},[_vm._v(_vm._s(_vm.complaint.comment))]),(_vm.$isAllowed('viewAdmin') || _vm.$isAllowed('viewERR'))?_c('span',{staticClass:"edit-icon-container",on:{"click":_vm.slideEditAttribute}},[_c('icon',{attrs:{"name":"chevron-down"}})],1):_vm._e(),(_vm.$isAllowed('viewAdmin') || _vm.$isAllowed('viewERR'))?_c('div',{staticClass:"edit-attribute",attrs:{"title":"Editar"}},[_c('b-input',{model:{value:(_vm.complaint.comment),callback:function ($$v) {_vm.complaint.comment=$$v},expression:"complaint.comment"}}),_c('b-btn',{attrs:{"title":"Guardar cambio","variant":"outline-success"},on:{"click":_vm.updateComplaintAttributes}},[_c('icon',{attrs:{"name":"save"}})],1)],1):_vm._e()])]),(_vm.complaint.zendesk.length > 0)?_c('p',{staticClass:"related-zendesk"},[_vm._v("Comunicación con el cliente (Zendesk "),_vm._l((_vm.complaint.zendesk),function(zendesk_id,index){return _c('span',[_c('a',{staticClass:"zendesk-ticket-link",attrs:{"href":("https://recorrido.zendesk.com/agent/tickets/" + zendesk_id),"target":"_blank","title":"Ver ticket en Zendesk"}},[_vm._v(_vm._s(zendesk_id))]),(index < _vm.complaint.zendesk.length - 1)?_c('span',[_vm._v(", ")]):_vm._e()])}),_vm._v(" "),_c('icon',{attrs:{"name":"external-link"}}),_vm._v(")")],2):_vm._e(),(this.complaint.additional_infos && this.complaint.additional_infos.length > 0 && this.complaint.source === 'voice')?_c('audio',{attrs:{"controls":"controls"}},[_c('source',{attrs:{"src":this.complaint.additional_infos[0].url,"type":"audio/mpeg"}})]):_vm._e(),(_vm.complaint.description)?_c('blockquote',{staticClass:"card-text"},[_c('pre',[_vm._v(_vm._s(_vm.complaint.description))])]):_vm._e()],1),_c('hr'),_c('b-card',{staticClass:"tabs-container",attrs:{"no-body":"no-body"}},[_c('b-tabs',{ref:"tabs",attrs:{"card":"card"}},[_c('b-tab',{attrs:{"title":"Pasajes afectados","active":"active"}},[(_vm.complaint.ticket_info && _vm.complaint.ticket_info.tickets.length > 0)?_c('h5',[_vm._v("Información de los pasajes afectados")]):_vm._e(),(_vm.complaint.ticket_info && _vm.complaint.ticket_info.tickets.length > 0)?_c('table',{staticClass:"table"},[_c('tr',{directives:[{name:"show",rawName:"v-show",value:(_vm.complaint.ticket_info.booking_number),expression:"complaint.ticket_info.booking_number"}]},[_c('td',[_vm._v("Número de Compra")]),_c('td',[_vm._v(_vm._s(_vm.complaint.ticket_info.booking_number))])]),_c('tr',{directives:[{name:"show",rawName:"v-show",value:(_vm.complaint.ticket_info.tickets.length > 0),expression:"complaint.ticket_info.tickets.length > 0"}]},[_c('td',[_vm._v("Pasajes afectados")]),_c('td',[_vm._v(_vm._s(_vm.complaint.ticket_info.tickets.join(', ')))])]),_c('tr',[_c('td',[_vm._v("Empresa(s)")]),_c('td',[_vm._v(_vm._s(_vm._f("formatOperator")(_vm.complaint.ticket_info.bus_operators)))])]),_c('tr',[_c('td',[_vm._v("Fecha de salida (Ida)")]),_c('td',[_vm._v(_vm._s(_vm._f("formatDate")(_vm.complaint.ticket_info.departure)))])]),_c('tr',[_c('td',[_vm._v("Hora de salida (Ida)")]),_c('td',[_vm._v(_vm._s(_vm._f("formatHour")(_vm.complaint.ticket_info.departure)))])]),(_vm.complaint.ticket_info.arrival)?_c('tr',[_c('td',[_vm._v("Fecha de salida (Vuelta)")]),_c('td',[_vm._v(_vm._s(_vm._f("formatDate")(_vm.complaint.ticket_info.arrival)))])]):_vm._e(),(_vm.complaint.ticket_info.arrival)?_c('tr',[_c('td',[_vm._v("Hora de salida (Vuelta)")]),_c('td',[_vm._v(_vm._s(_vm._f("formatHour")(_vm.complaint.ticket_info.arrival)))])]):_vm._e(),_c('tr',[_c('td',[_vm._v("Método de pago")]),_c('td',[_vm._v(_vm._s(_vm.complaint.ticket_info.payment_method))])]),_c('tr',[_c('td',[_vm._v("Método de reembolso")]),_c('td',[_vm._v(_vm._s(_vm.refundMethod))])]),_c('tr',[_c('td',[_vm._v("Precio")]),_c('td',[_vm._v(_vm._s(_vm.complaint.ticket_info.price)+" "+_vm._s(_vm.complaint.ticket_info.sold_currency))])]),_c('tr',[_c('td',[_vm._v("Precio IBC")]),_c('td',[_vm._v(_vm._s(_vm.complaint.ticket_info.price_ibc))])]),_c('tr',[_c('td',[_vm._v("Comprador")]),_c('td',[_vm._v(_vm._s(_vm.complaint.ticket_info.fullname))])]),_c('tr',[_c('td',[_vm._v("Email comprador")]),_c('td',[_vm._v(_vm._s(_vm.complaint.ticket_info.email))])])]):_vm._e()]),_c('b-tab',{attrs:{"title":"Adjuntos"}},[_c('vue-dropzone',{ref:"attachmentsDrop",attrs:{"id":"dropzone","options":_vm.dropzoneOptions},on:{"vdropzone-success":_vm.fetchComplaint}}),(_vm.complaint.additional_infos)?_c('b-list-group',[_c('hr'),_c('h3',[_vm._v("Archivos adjuntos")]),_vm._l((_vm.complaint.additional_infos),function(info){return (info.url !== null)?_c('div',{staticClass:"list-group-item list-group-item-action"},[(info.format === 'mp3')?_c('span',[_c('audio',{attrs:{"controls":"controls"}},[_c('source',{attrs:{"src":info.url,"type":"audio/mpeg"}})])]):_c('div',[(['png', 'jpg', 'jpeg', 'gif'].includes(info.format))?_c('div',{staticClass:"attachment_content"},[_c('b-btn',{on:{"click":function($event){_vm.openFileModal(info._id.$oid)}}},[_c('icon',{attrs:{"name":"image"}}),_vm._v(" "+_vm._s(((info.name) + "." + (info.format))))],1),_c('b-modal',{ref:("imageModal-" + (info._id.$oid)),refInFor:true,staticClass:"image-modal"},[_c('img',{attrs:{"src":_vm.signedLink}}),_c('div',{attrs:{"slot":"modal-cancel"},slot:"modal-cancel"},[_vm._v("Cerrar")]),_c('div',{attrs:{"slot":"modal-ok"},slot:"modal-ok"},[_c('a',{attrs:{"href":_vm.signedLink,"target":"_blank"}},[_vm._v("Abrir en pestaña externa")])])])],1):(info.format === 'pdf')?_c('div',{staticClass:"attachment_content"},[_c('a',{on:{"click":function($event){_vm.openFileTab(info._id.$oid)}}},[_c('icon',{attrs:{"name":"paperclip"}}),_vm._v(" "+_vm._s(((info.name) + "." + (info.format)))+"  "),_c('icon',{attrs:{"name":"external-link"}})],1)]):_c('span',[_c('a',{on:{"click":function($event){_vm.dowloadFile(info._id.$oid)}}},[_c('icon',{attrs:{"name":"paperclip"}}),_vm._v(" "+_vm._s(((info.name) + "." + (info.format)))+"  "),_c('icon',{attrs:{"name":"download"}})],1)]),(_vm.$isAllowed('deleteAttachment'))?_c('div',{staticClass:"attachment_actions"},[_c('b-btn',{attrs:{"size":"xs"},on:{"click":function($event){_vm.deleteAttachment(info._id.$oid)}}},[_c('icon',{attrs:{"name":"trash"}}),_vm._v(" Eliminar")],1)],1):_vm._e()])]):_vm._e()})],2):_vm._e()],1),_c('b-tab',{attrs:{"title":"Solicitudes de información"}},[_c('input',{attrs:{"id":"requestFile","type":"file","hidden":"hidden"},on:{"change":function($event){_vm.uploadFile()}}}),_c('b-form',{on:{"submit":function($event){$event.preventDefault();_vm.requestInfo($event)}}},[_c('b-input-group',[_c('b-form-input',{staticClass:"form-control",attrs:{"placeholder":"Información a solicitar"},model:{value:(_vm.info_request),callback:function ($$v) {_vm.info_request=(typeof $$v === 'string'? $$v.trim(): $$v)},expression:"info_request"}}),_c('b-input-group-button',{attrs:{"slot":"right"},slot:"right"},[_c('b-btn',{attrs:{"type":"submit","variant":"primary"}},[_vm._v("Solicitar")])],1)],1)],1),(_vm.requests)?_c('b-list-group',[_c('hr'),_vm._l((_vm.requests),function(r){return _c('b-list-group-item',{key:r.name},[_c('icon',{attrs:{"name":"inbox"}}),_c('span',{domProps:{"innerHTML":_vm._s(r.request)}}),(r.url === null)?_c('button',{staticClass:"float-right",attrs:{"variant":"primary"},on:{"click":function($event){_vm.addFile(r._id.$oid)}}},[_c('icon',{attrs:{"name":"paperclip"}}),_vm._v("Adjuntar")],1):_vm._e(),(r.url !== null)?_c('a',{staticClass:"float-right",attrs:{"href":r.url}},[_vm._v(_vm._s(((r.name) + "." + (r.format))))]):_vm._e()],1)})],2):_vm._e()],1),(('reimbursement' in _vm.complaint) && _vm.complaint.reimbursement.compensation_type === 'm' && _vm.allowed_payment_methods.includes(_vm.complaint.ticket_info.payment_method) || _vm.complaint.category === -1)?_c('b-tab',{attrs:{"title":"Datos de reembolso"}},[(Object.keys(_vm.bank_info).length === 0)?_c('div',[_c('div',{staticClass:"bank-btns"},[_c('div',{staticStyle:{"float":"right"}},[(_vm.canAddBankData())?_c('b-row',{staticClass:"mb-1"},[_c('b-col',[_c('button',{directives:[{name:"b-modal",rawName:"v-b-modal",value:('editBankData'),expression:"'editBankData'"}],staticClass:"btn btn-success"},[_vm._v("Ingresar datos bancarios")])])],1):_vm._e(),(_vm.canUpdateRefundMethod())?_c('b-row',[_c('b-col',[_c('button',{directives:[{name:"b-modal",rawName:"v-b-modal",value:('editRefundMethod'),expression:"'editRefundMethod'"}],staticClass:"btn btn-success"},[_vm._v("Cambiar método de reembolso")])])],1):_vm._e()],1)]),_c('table',{staticClass:"table table-bordered table-responsive"},[_c('tr',[_c('th',[_vm._v("Método de reembolso")]),_c('td',{directives:[{name:"clipboard",rawName:"v-clipboard:copy",value:(_vm.refundMethod),expression:"refundMethod",arg:"copy"},{name:"clipboard",rawName:"v-clipboard:success",value:(_vm.dataCopied),expression:"dataCopied",arg:"success"}],staticClass:"selectable"},[_vm._v(_vm._s(_vm.refundMethod))])]),(_vm.complaint.reimbursement && _vm.isPaypalRefundMethod)?_c('tr',[_c('th',[_vm._v("Correo PayPal")]),(_vm.complaint.reimbursement.paypal_email)?_c('td',{directives:[{name:"clipboard",rawName:"v-clipboard:copy",value:(_vm.complaint.reimbursement.paypal_email),expression:"complaint.reimbursement.paypal_email",arg:"copy"},{name:"clipboard",rawName:"v-clipboard:success",value:(_vm.dataCopied),expression:"dataCopied",arg:"success"}],staticClass:"selectable"},[_vm._v(_vm._s(_vm.complaint.reimbursement.paypal_email))]):_c('td',[_vm._v("No se ha registrado")])]):_vm._e(),('reimbursement' in _vm.complaint)?[_c('tr',[_c('th',[_vm._v("Monto devolución")]),(_vm.complaint.reimbursement.amount)?_c('td',{directives:[{name:"clipboard",rawName:"v-clipboard:copy",value:(_vm.complaint.reimbursement.amount),expression:"complaint.reimbursement.amount",arg:"copy"},{name:"clipboard",rawName:"v-clipboard:success",value:(_vm.dataCopied),expression:"dataCopied",arg:"success"}],staticClass:"selectable"},[_vm._v(_vm._s(_vm.complaint.reimbursement.amount))]):_c('td',[_vm._v("No se ha registrado")])]),(!_vm.isPaypalRefundMethod)?_c('tr',[_c('th',[_vm._v("Código de TEF")]),(_vm.complaint.reimbursement.tef_code)?_c('td',{directives:[{name:"clipboard",rawName:"v-clipboard:copy",value:(_vm.complaint.reimbursement.tef_code),expression:"complaint.reimbursement.tef_code",arg:"copy"},{name:"clipboard",rawName:"v-clipboard:success",value:(_vm.dataCopied),expression:"dataCopied",arg:"success"}]},[_vm._v(_vm._s(_vm.complaint.reimbursement.tef_code))]):_c('td',[_vm._v("No se ha registrado")])]):_vm._e(),(!_vm.isPaypalRefundMethod)?_c('tr',[_c('th',[_vm._v("Fecha de TEF")]),(_vm.complaint.reimbursement.tef_date)?_c('td',[_vm._v(" "+_vm._s(_vm._f("formatDate")(_vm.complaint.reimbursement.tef_date)))]):_c('td',[_vm._v("No se ha registrado")])]):_vm._e()]:_vm._e()],2)]):_c('div',[_c('div',{staticClass:"bank-btns"},[_c('div',{staticStyle:{"float":"right"}},[_c('b-row',{staticClass:"mb-1"},[_c('b-col',[_c('button',{directives:[{name:"b-modal",rawName:"v-b-modal",value:('editBankData'),expression:"'editBankData'"}],staticClass:"btn btn-success"},[_vm._v("Editar datos bancarios")])])],1),(_vm.canUpdateRefundMethod())?_c('b-row',[_c('b-col',[_c('button',{directives:[{name:"b-modal",rawName:"v-b-modal",value:('editRefundMethod'),expression:"'editRefundMethod'"}],staticClass:"btn btn-success"},[_vm._v("Cambiar método de reembolso")])])],1):_vm._e()],1),_c('button',{directives:[{name:"clipboard",rawName:"v-clipboard:copy",value:(_vm.copyBankData),expression:"copyBankData",arg:"copy"},{name:"clipboard",rawName:"v-clipboard:success",value:(_vm.notifyCopyBank),expression:"notifyCopyBank",arg:"success"}],staticClass:"btn btn-primary",attrs:{"size":"sm","title":"Copiar datos bancarios"}},[_vm._v("Copiar datos")])]),_c('table',{staticClass:"table table-bordered table-responsive"},[(_vm.complaint.country === 'CL')?_c('tbody',[_c('tr',[_c('th',[_vm._v("Método de reembolso")]),_c('td',{directives:[{name:"clipboard",rawName:"v-clipboard:copy",value:(_vm.refundMethod),expression:"refundMethod",arg:"copy"},{name:"clipboard",rawName:"v-clipboard:success",value:(_vm.dataCopied),expression:"dataCopied",arg:"success"}],staticClass:"selectable"},[_vm._v(_vm._s(_vm.refundMethod))])]),(!_vm.isPaypalRefundMethod)?_c('tr',[_c('th',[_vm._v("Nombre")]),_c('td',{directives:[{name:"clipboard",rawName:"v-clipboard:copy",value:(_vm.bank_info.name),expression:"bank_info.name",arg:"copy"},{name:"clipboard",rawName:"v-clipboard:success",value:(_vm.dataCopied),expression:"dataCopied",arg:"success"}],staticClass:"selectable"},[_vm._v(_vm._s(_vm.bank_info.name))])]):_vm._e(),(!_vm.isPaypalRefundMethod)?_c('tr',[_c('th',[_vm._v("RUT")]),_c('td',{directives:[{name:"clipboard",rawName:"v-clipboard:copy",value:(_vm.bank_info.rut),expression:"bank_info.rut",arg:"copy"},{name:"clipboard",rawName:"v-clipboard:success",value:(_vm.dataCopied),expression:"dataCopied",arg:"success"}],staticClass:"selectable"},[_vm._v(_vm._s(_vm._f("rutFilter")(_vm.bank_info.rut)))])]):_vm._e(),(_vm.isPaypalRefundMethod)?_c('tr',[_c('th',[_vm._v("Correo PayPal")]),(_vm.complaint.reimbursement.paypal_email)?_c('td',{directives:[{name:"clipboard",rawName:"v-clipboard:copy",value:(_vm.complaint.reimbursement.paypal_email),expression:"complaint.reimbursement.paypal_email",arg:"copy"},{name:"clipboard",rawName:"v-clipboard:success",value:(_vm.dataCopied),expression:"dataCopied",arg:"success"}],staticClass:"selectable"},[_vm._v(_vm._s(_vm.complaint.reimbursement.paypal_email))]):_c('td',[_vm._v("No se ha registrado")])]):_vm._e(),('reimbursement' in _vm.complaint)?[(!_vm.isPaypalRefundMethod)?_c('tr',[_c('th',[_vm._v("Correo comprador")]),_c('td',{directives:[{name:"clipboard",rawName:"v-clipboard:copy",value:(_vm.complaint.ticket_info.email),expression:"complaint.ticket_info.email",arg:"copy"},{name:"clipboard",rawName:"v-clipboard:success",value:(_vm.dataCopied),expression:"dataCopied",arg:"success"}],staticClass:"selectable"},[_vm._v(_vm._s(_vm.complaint.ticket_info.email))])]):_vm._e(),(!_vm.isPaypalRefundMethod)?_c('tr',[_c('th',[_vm._v("Banco")]),_c('td',{directives:[{name:"clipboard",rawName:"v-clipboard:copy",value:(_vm.bank_info.bank),expression:"bank_info.bank",arg:"copy"},{name:"clipboard",rawName:"v-clipboard:success",value:(_vm.dataCopied),expression:"dataCopied",arg:"success"}],staticClass:"selectable"},[_vm._v(_vm._s(_vm.bank_info.bank))])]):_vm._e(),(!_vm.isPaypalRefundMethod)?_c('tr',[_c('th',[_vm._v("Tipo de Cuenta")]),(_vm.bank_info.account_type !== null)?_c('td',{directives:[{name:"clipboard",rawName:"v-clipboard:copy",value:(_vm.accounts[_vm.bank_info.account_type].description),expression:"accounts[bank_info.account_type].description",arg:"copy"},{name:"clipboard",rawName:"v-clipboard:success",value:(_vm.dataCopied),expression:"dataCopied",arg:"success"}],staticClass:"selectable"},[_vm._v(_vm._s(_vm.accounts[_vm.bank_info.account_type].description))]):_c('td',[_vm._v("No se indicó tipo de cuenta")])]):_vm._e(),(!_vm.isPaypalRefundMethod)?_c('tr',[_c('th',[_vm._v("Número de Cuenta")]),_c('td',{directives:[{name:"clipboard",rawName:"v-clipboard:copy",value:(_vm.bank_info.account_number),expression:"bank_info.account_number",arg:"copy"},{name:"clipboard",rawName:"v-clipboard:success",value:(_vm.dataCopied),expression:"dataCopied",arg:"success"}],staticClass:"selectable"},[_vm._v(_vm._s(_vm.bank_info.account_number))])]):_vm._e(),_c('tr',[_c('th',[_vm._v("Monto devolución")]),(_vm.complaint.reimbursement.amount)?_c('td',{directives:[{name:"clipboard",rawName:"v-clipboard:copy",value:(_vm.complaint.reimbursement.amount),expression:"complaint.reimbursement.amount",arg:"copy"},{name:"clipboard",rawName:"v-clipboard:success",value:(_vm.dataCopied),expression:"dataCopied",arg:"success"}],staticClass:"selectable"},[_vm._v(_vm._s(_vm.complaint.reimbursement.amount))]):_c('td',[_vm._v("No se ha registrado")])]),(!_vm.isPaypalRefundMethod)?_c('tr',[_c('th',[_vm._v("Código de TEF")]),(_vm.complaint.reimbursement.tef_code)?_c('td',{directives:[{name:"clipboard",rawName:"v-clipboard:copy",value:(_vm.complaint.reimbursement.tef_code),expression:"complaint.reimbursement.tef_code",arg:"copy"},{name:"clipboard",rawName:"v-clipboard:success",value:(_vm.dataCopied),expression:"dataCopied",arg:"success"}]},[_vm._v(_vm._s(_vm.complaint.reimbursement.tef_code))]):_c('td',[_vm._v("No se ha registrado")])]):_vm._e(),(!_vm.isPaypalRefundMethod)?_c('tr',[_c('th',[_vm._v("Fecha de TEF")]),(_vm.complaint.reimbursement.tef_date)?_c('td',[_vm._v(" "+_vm._s(_vm._f("formatDate")(_vm.complaint.reimbursement.tef_date)))]):_c('td',[_vm._v("No se ha registrado")])]):_vm._e()]:_vm._e()],2):_vm._e(),(_vm.complaint.country === 'PE')?_c('tbody',[_c('tr',[_c('th',[_vm._v("Método de reembolso")]),_c('td',{directives:[{name:"clipboard",rawName:"v-clipboard:copy",value:(_vm.refundMethod),expression:"refundMethod",arg:"copy"},{name:"clipboard",rawName:"v-clipboard:success",value:(_vm.dataCopied),expression:"dataCopied",arg:"success"}],staticClass:"selectable"},[_vm._v(_vm._s(_vm.refundMethod))])]),(_vm.complaint.reimbursement.paypal_email)?_c('tr',[_c('th',[_vm._v("Correo PayPal")]),_c('td',{directives:[{name:"clipboard",rawName:"v-clipboard:copy",value:(_vm.complaint.reimbursement.paypal_email),expression:"complaint.reimbursement.paypal_email",arg:"copy"},{name:"clipboard",rawName:"v-clipboard:success",value:(_vm.dataCopied),expression:"dataCopied",arg:"success"}],staticClass:"selectable"},[_vm._v(_vm._s(_vm.complaint.reimbursement.paypal_email))])]):_vm._e(),_c('tr',[_c('th',[_vm._v("Nombre")]),_c('td',{directives:[{name:"clipboard",rawName:"v-clipboard:copy",value:(_vm.bank_info.name),expression:"bank_info.name",arg:"copy"},{name:"clipboard",rawName:"v-clipboard:success",value:(_vm.dataCopied),expression:"dataCopied",arg:"success"}],staticClass:"selectable"},[_vm._v(_vm._s(_vm.bank_info.name))])]),_c('tr',[_c('th',[_vm._v("Documento")]),_c('td',{directives:[{name:"clipboard",rawName:"v-clipboard:copy",value:(_vm.bank_info.document_type),expression:"bank_info.document_type",arg:"copy"},{name:"clipboard",rawName:"v-clipboard:success",value:(_vm.dataCopied),expression:"dataCopied",arg:"success"}],staticClass:"selectable"},[_vm._v(_vm._s(_vm.bank_info.document_type))])]),_c('tr',[_c('th',[_vm._v("Número de Documento")]),_c('td',{directives:[{name:"clipboard",rawName:"v-clipboard:copy",value:(_vm.bank_info.document_number),expression:"bank_info.document_number",arg:"copy"},{name:"clipboard",rawName:"v-clipboard:success",value:(_vm.dataCopied),expression:"dataCopied",arg:"success"}],staticClass:"selectable"},[_vm._v(_vm._s(_vm.bank_info.document_number))])]),_c('tr',[_c('th',[_vm._v("Correo comprador")]),_c('td',{directives:[{name:"clipboard",rawName:"v-clipboard:copy",value:(_vm.complaint.ticket_info.email),expression:"complaint.ticket_info.email",arg:"copy"},{name:"clipboard",rawName:"v-clipboard:success",value:(_vm.dataCopied),expression:"dataCopied",arg:"success"}],staticClass:"selectable"},[_vm._v(_vm._s(_vm.complaint.ticket_info.email))])]),_c('tr',[_c('th',[_vm._v("Banco")]),_c('td',{directives:[{name:"clipboard",rawName:"v-clipboard:copy",value:(_vm.bank_info.bank),expression:"bank_info.bank",arg:"copy"},{name:"clipboard",rawName:"v-clipboard:success",value:(_vm.dataCopied),expression:"dataCopied",arg:"success"}],staticClass:"selectable"},[_vm._v(_vm._s(_vm.bank_info.bank))])]),_c('tr',[_c('th',[_vm._v("Tipo de Cuenta")]),(_vm.bank_info.account_type !== null)?_c('td',{directives:[{name:"clipboard",rawName:"v-clipboard:copy",value:(_vm.accounts[_vm.bank_info.account_type].description),expression:"accounts[bank_info.account_type].description",arg:"copy"},{name:"clipboard",rawName:"v-clipboard:success",value:(_vm.dataCopied),expression:"dataCopied",arg:"success"}],staticClass:"selectable"},[_vm._v(_vm._s(_vm.accounts[_vm.bank_info.account_type].description))]):_c('td',[_vm._v("No se indicó tipo de cuenta")])]),_c('tr',[_c('th',[_vm._v("Número de Cuenta")]),_c('td',{directives:[{name:"clipboard",rawName:"v-clipboard:copy",value:(_vm.bank_info.account_number),expression:"bank_info.account_number",arg:"copy"},{name:"clipboard",rawName:"v-clipboard:success",value:(_vm.dataCopied),expression:"dataCopied",arg:"success"}],staticClass:"selectable"},[_vm._v(_vm._s(_vm.bank_info.account_number))])]),_c('tr',[_c('th',[_vm._v("CCI")]),_c('td',{directives:[{name:"clipboard",rawName:"v-clipboard:copy",value:(_vm.bank_info.cci),expression:"bank_info.cci",arg:"copy"},{name:"clipboard",rawName:"v-clipboard:success",value:(_vm.dataCopied),expression:"dataCopied",arg:"success"}],staticClass:"selectable"},[_vm._v(_vm._s(_vm.bank_info.cci))])]),('reimbursement' in _vm.complaint)?[_c('tr',[_c('th',[_vm._v("Monto devolución")]),(_vm.complaint.reimbursement.amount)?_c('td',{directives:[{name:"clipboard",rawName:"v-clipboard:copy",value:(_vm.complaint.reimbursement.amount),expression:"complaint.reimbursement.amount",arg:"copy"},{name:"clipboard",rawName:"v-clipboard:success",value:(_vm.dataCopied),expression:"dataCopied",arg:"success"}],staticClass:"selectable"},[_vm._v(_vm._s(_vm.complaint.reimbursement.amount))]):_c('td',[_vm._v("No se ha registrado")])]),_c('tr',[_c('th',[_vm._v("Código de TEF")]),(_vm.complaint.reimbursement.tef_code)?_c('td',{directives:[{name:"clipboard",rawName:"v-clipboard:copy",value:(_vm.complaint.reimbursement.tef_code),expression:"complaint.reimbursement.tef_code",arg:"copy"},{name:"clipboard",rawName:"v-clipboard:success",value:(_vm.dataCopied),expression:"dataCopied",arg:"success"}]},[_vm._v(_vm._s(_vm.complaint.reimbursement.tef_code))]):_c('td',[_vm._v("No se ha registrado")])]),_c('tr',[_c('th',[_vm._v("Fecha de TEF")]),(_vm.complaint.reimbursement.tef_date)?_c('td',[_vm._v(" "+_vm._s(_vm._f("formatDate")(_vm.complaint.reimbursement.tef_date)))]):_c('td',[_vm._v("No se ha registrado")])])]:_vm._e()],2):_vm._e()])]),_c('b-modal',{ref:"bankDataModal",attrs:{"id":"editBankData","hide-footer":"hide-footer","no-close-on-backdrop":"no-close-on-backdrop"}},[_c('show-bank-account-form',{attrs:{"complaint":_vm.complaint},on:{"fetchComplaint":_vm.fetchComplaint}})],1),_c('b-modal',{ref:"editRefundMethod",attrs:{"id":"editRefundMethod","hide-footer":"hide-footer","no-close-on-backdrop":"no-close-on-backdrop"},on:{"hide":function($event){_vm.closeRefundMethodModal()}}},[_c('b-form',{staticClass:"form-horizontal",on:{"submit":function($event){$event.preventDefault();_vm.updateRefundMethod($event)}}},[_c('b-form-group',{attrs:{"label":"Método de reembolso"}},[_c('selectize',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"data-vv-as":"método de reembolso","name":"refund_method[code]"},model:{value:(_vm.refund_method.code),callback:function ($$v) {_vm.refund_method.code=$$v},expression:"refund_method.code"}},_vm._l((_vm.availableRefundMethods),function(rm){return _c('option',{key:rm.code,domProps:{"value":rm.code}},[_vm._v(_vm._s(rm.description))])})),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('refund_method[code]')),expression:"errors.has('refund_method[code]')"}],staticClass:"has-error"},[_vm._v(_vm._s(_vm.errors.first('refund_method[code]')))])],1),(_vm.refund_method.code && _vm.estimatedAmountUsd !== null)?_c('p',{staticClass:"text-info"},[_c('strong',[_vm._v("Monto a devolver: $"+_vm._s(_vm.estimatedAmountUsd)+" USD")])]):_vm._e(),_c('b-form-group',{attrs:{"label":"Correo electrónico PayPal"}},[_c('b-form-input',{directives:[{name:"validate",rawName:"v-validate",value:('required|email'),expression:"'required|email'"}],staticClass:"form-control",attrs:{"data-vv-as":"correo","name":"refund_method[email]","type":"email","autocomplete":"off"},model:{value:(_vm.refund_method.email),callback:function ($$v) {_vm.refund_method.email=$$v},expression:"refund_method.email"}}),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('refund_method[email]')),expression:"errors.has('refund_method[email]')"}],staticClass:"has-error"},[_vm._v(_vm._s(_vm.errors.first('refund_method[email]')))])],1),_c('b-form-group',{staticClass:"text-center"},[_c('b-button',{attrs:{"type":"submit","variant":"primary"}},[_vm._v("Actualizar")])],1)],1)],1)],1):_vm._e(),_c('b-tab',{attrs:{"title":_vm.commentsTitle}},[_c('comments',{ref:"comments",attrs:{"complaint":_vm.complaint._id.$oid}})],1),_c('b-tab',{attrs:{"title":"Historial de acciones"}},[_c('last-activity',{ref:"activity",attrs:{"complaint":_vm.complaint._id.$oid}})],1),(_vm.complaint.approved_at !== null && (_vm.$isAllowed('viewAdmin') || _vm.$isAllowed('viewFDP') || _vm.$isAllowed('viewERR')))?_c('b-tab',{attrs:{"title":"Editar descuento"}},[_c('button',{directives:[{name:"b-modal",rawName:"v-b-modal",value:('editComplaintDataModal'),expression:"'editComplaintDataModal'"}],staticClass:"btn btn-success",staticStyle:{"float":"right"}},[_c('icon',{attrs:{"name":"warning"}}),_vm._v(" Editar reclamo")],1),_c('table',{staticClass:"table table-bordered table-responsive"},[_c('tbody',[_c('tr',[_c('th',[_vm._v("Descuento de la empresa de bus")]),(_vm.complaint.reimbursement.discount_from_company)?_c('td',[_vm._v("Sí")]):_c('td',[_vm._v("No")])]),(_vm.complaint.reimbursement.discount_from_company)?_c('tr',[_c('th',[_vm._v("Porcentaje")]),_c('td',[_vm._v(_vm._s(_vm.complaint.reimbursement.discount_percentage)+"%")])]):_vm._e(),(_vm.complaint.reimbursement.discount_from_company)?_c('tr',[_c('th',[_vm._v("Monto de descuento empresa de bus")]),_c('td',[_vm._v(_vm._s(_vm._f("currency")(_vm.complaint.reimbursement.discount,'CLP $', 0, { thousandsSeparator: '.'})))])]):_vm._e()])]),_c('b-modal',{ref:"editComplaintDataModal",attrs:{"id":"editComplaintDataModal"}},[_c('b-form',{staticClass:"form-horizontal",on:{"submit":function($event){$event.preventDefault();_vm.updateBusOperatorDiscount($event)}}},[_c('b-form-group',{attrs:{"label":"Descontar de empresa de bus"}},[_c('b-form-radio-group',{attrs:{"options":[{ text: 'Sí', value: true }, { text: 'No', value: false }]},on:{"value":_vm.complaint.reimbursement.discount_from_company},model:{value:(_vm.complaint.reimbursement.discount_from_company),callback:function ($$v) {_vm.complaint.reimbursement.discount_from_company=$$v},expression:"complaint.reimbursement.discount_from_company"}})],1),_c('b-form-group',{attrs:{"label":"Descuento de la empresa de bus"}},[_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.complaint.reimbursement.discount),expression:"complaint.reimbursement.discount",modifiers:{"trim":true}}],staticClass:"form-control",domProps:{"value":(_vm.complaint.reimbursement.discount)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.complaint.reimbursement.discount=$event.target.value.trim()},function($event){_vm.setCompanyDiscount($event)}],"blur":function($event){_vm.$forceUpdate()}}})]),_c('b-form-group',{attrs:{"label":"Porcentaje de descuento"}},[_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.complaint.reimbursement.discount_percentage),expression:"complaint.reimbursement.discount_percentage",modifiers:{"trim":true}}],staticClass:"form-control",domProps:{"value":(_vm.complaint.reimbursement.discount_percentage)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.complaint.reimbursement.discount_percentage=$event.target.value.trim()},function($event){_vm.setCompanyDiscountPercentage($event)}],"blur":function($event){_vm.$forceUpdate()}}})])],1),_c('div',{staticClass:"form-group text-center",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('b-button',{attrs:{"variant":"primary"},on:{"click":_vm.updateBusOperatorDiscount}},[_vm._v("Actualizar")]),_vm._v(" "),_c('b-button',{on:{"click":_vm.closeModal}},[_vm._v("Cancelar")])],1)],1)],1):_vm._e()],1)],1)],1)],1):_c('icon',{staticClass:"loading-section",attrs:{"name":"spinner","scale":"5","pulse":"pulse"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "H64N":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "HUt/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_form_input_vue__ = __webpack_require__("fcFS");
function injectStyle (ssrContext) {
  __webpack_require__("ff44")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_form_input_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Hj+A":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isLoggedIn)?_c('b-navbar',{staticClass:"fixed-top",attrs:{"type":"dark","variant":"kexa-nav","toggleable":"md"}},[_c('b-container',[_c('b-nav-toggle',{attrs:{"target":"navbar_collapse"}}),_c('b-navbar-brand',[_c('router-link',{attrs:{"to":{ path: '/complaints' }}},[_c('img',{attrs:{"src":_vm.logo,"width":"250","height":"30","alt":""}})])],1),_c('b-collapse',{attrs:{"id":"navbar_collapse","is-nav":"is-nav"}},[_c('b-navbar-nav',{staticClass:"ml-auto",attrs:{"is-nav-bar":"is-nav-bar"}},[_c('li',{staticClass:"nav-item b-nav-dropdown dropdown"},[(_vm.$isAllowed('viewAll'))?_c('router-link',{staticClass:"nav-link",attrs:{"to":{ path: '/complaints/all' },"exact":"exact"}},[_vm._v("Todos")]):_vm._e()],1),(_vm.$isAllowed('manageUsers') || _vm.$isAllowed('viewAll'))?_c('b-nav-item-dropdown',{attrs:{"text":"Pendientes","right":"right"}},[_c('b-dropdown-item',{attrs:{"to":{ path: '/complaints' },"exact":"exact"}},[_vm._v("Recorrido")]),_c('b-dropdown-item',{attrs:{"to":{ path: '/complaints_ecommerce' },"exact":"exact"}},[_vm._v("Ecommerce")])],1):_vm._e(),_c('li',{staticClass:"nav-item b-nav-dropdown dropdown"},[(_vm.$isAllowed('createComplaint'))?_c('router-link',{staticClass:"nav-link",attrs:{"to":{ path: '/complaints/new' },"exact":"exact"}},[_vm._v("Registrar")]):_vm._e()],1),_c('li',{staticClass:"nav-item b-nav-dropdown dropdown"},[(_vm.$isAllowed('createComplaint'))?_c('router-link',{staticClass:"nav-link",attrs:{"to":{ path: '/complaints/pre-approved' },"exact":"exact"}},[_vm._v("Nuevo pre-aprobado")]):_vm._e()],1),_c('li',{staticClass:"nav-item b-nav-dropdown dropdown"},[(_vm.$isAllowed('manageOperators'))?_c('router-link',{staticClass:"nav-link",attrs:{"to":{ path: '/operators' },"exact":"exact"}},[_vm._v("Empresas")]):_vm._e()],1),_c('li',{staticClass:"nav-item b-nav-dropdown dropdown"},[(_vm.$isAllowed('viewFinance'))?_c('router-link',{staticClass:"nav-link",attrs:{"to":{ path: '/finance' },"exact":"exact"}},[_vm._v("Finanzas")]):_vm._e()],1),(_vm.$isAllowed('manageUsers'))?_c('b-nav-item-dropdown',{attrs:{"text":"Configuración","right":"right"}},[_c('b-dropdown-item',{attrs:{"to":{ path: '/users' },"exact":"exact"}},[_vm._v("Gestión de usuarios")]),_c('b-dropdown-item',{attrs:{"to":{ path: '/categories' },"exact":"exact"}},[_vm._v("Gestión de categorías")])],1):_vm._e(),_c('div',{staticClass:"dropdown-divider"}),_c('b-nav-item-dropdown',{attrs:{"text":_vm.user,"right":"right"}},[_c('b-dropdown-item',[_c('icon',{attrs:{"name":"sign-out"}}),_c('router-link',{attrs:{"to":{ path: '/logout' }}},[_vm._v("Salir")])],1)],1)],1)],1)],1)],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "IcnI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex_persistedstate__ = __webpack_require__("UIay");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex_persistedstate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuex_persistedstate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jwt_decode__ = __webpack_require__("365x");
/* eslint no-param-reassign: ["error", { "props": false }] */
/* eslint no-underscore-dangle: ["error", { "allow": ["_id"] }] */




/* eslint-disable camelcase */


__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  strict: "production" !== 'production',
  plugins: [__WEBPACK_IMPORTED_MODULE_2_vuex_persistedstate___default()()],
  state: {
    isLogged: !!localStorage.getItem('token'),
    token: localStorage.getItem('token'),
    expiration: null,
    user: {},
    selected: {},
    commentsLength: null,
    reloadApp: null
  },
  getters: {
    isLoggedIn: function isLoggedIn(state) {
      return state.isLogged;
    },
    selected: function selected(state) {
      return state.selected;
    },
    user: function user(state) {
      return state.user.name;
    },
    token: function token(state) {
      return state.token;
    },
    commentsLength: function commentsLength(state) {
      return state.commentsLength;
    },
    reloadApp: function reloadApp(state) {
      return state.reloadApp;
    },
    id: function id(state) {
      return state.id;
    }
  },
  mutations: {
    login: function login(state, token) {
      var data = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_jwt_decode__["a" /* default */])(token);
      localStorage.setItem('token', token);
      state.token = token;
      state.isLogged = true;
      state.expiration = data.exp;
      state.user = data.user;
      state.reloadApp = data.user.reload_app;
      state.id = data.user_id;
    },
    logout: function logout(state) {
      state.isLogged = false;
      state.expiration = null;
      state.user = {};
      state.token = null;
      state.selected = {};
      state.reloadApp = null;
      state.id = null;
      localStorage.removeItem('token');
    },
    selectComplaint: function selectComplaint(state, complaint) {
      state.selected = complaint;
    },
    setCommentsLength: function setCommentsLength(state, length) {
      state.commentsLength = length;
    },
    setReloadApp: function setReloadApp(state, value) {
      state.reloadApp = value;
    }
  }
});

/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),

/***/ "J6kb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  BEHATZAILE_TOKEN: 'YjNoNHR6NDFsMw=='
});

/***/ }),

/***/ "JCpY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_modal_vue__ = __webpack_require__("aPSQ");
function injectStyle (ssrContext) {
  __webpack_require__("pOFu")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_modal_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "JDVb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_form_file_vue__ = __webpack_require__("kJiG");
function injectStyle (ssrContext) {
  __webpack_require__("FPDf")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_form_file_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Jd5C":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "KQ6S":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue2_datepicker__ = __webpack_require__("VrvJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue2_datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue2_datepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue2_selectize__ = __webpack_require__("py5U");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue2_selectize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue2_selectize__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants_Status_constants__ = __webpack_require__("XXAu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_apiService__ = __webpack_require__("a/3G");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_layout_LastActivity__ = __webpack_require__("sX+p");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_layout_PopoverDetail__ = __webpack_require__("gs9z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__perimeters_financePerimeter__ = __webpack_require__("nOi6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_dateService__ = __webpack_require__("4F1w");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











var parse = __webpack_require__("UVyn");

/* eslint no-underscore-dangle: ["error", { "allow": ["_id"] }] */

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'finance',
  components: {
    LastActivity: __WEBPACK_IMPORTED_MODULE_6__components_layout_LastActivity__["a" /* default */],
    complaintPopover: __WEBPACK_IMPORTED_MODULE_7__components_layout_PopoverDetail__["a" /* default */],
    DatePicker: __WEBPACK_IMPORTED_MODULE_1_vue2_datepicker___default.a,
    Selectize: __WEBPACK_IMPORTED_MODULE_2_vue2_selectize___default.a
  },
  perimeters: [__WEBPACK_IMPORTED_MODULE_8__perimeters_financePerimeter__["a" /* default */]],
  data: function data() {
    return {
      complaintFields: {
        number: {
          label: 'ID',
          sortable: true
        },
        status: {
          label: 'Estado',
          sortable: true,
          tdClass: 'status-holder'
        },
        token: { label: 'Número de compra' },
        category: {
          label: 'Categoría',
          sortable: true
        },
        age: { label: 'Edad' },
        bus_operator: { label: 'Empresa de bus' },
        amount_requested: { label: 'Monto reclamado' },
        payment_method: { label: 'Medio de pago' },
        approved_at: { label: 'Fecha de aprobación' },
        devolution_at: { label: 'Fecha de devolución' },
        statuses: { label: 'Descuentos' }
      },
      categories: [],
      statuses: __WEBPACK_IMPORTED_MODULE_4__constants_Status_constants__["a" /* default */].STATUSES,
      complaints: [],
      operators: [],
      pagination: {},
      filterText: '',
      intervalId: null,
      modalDate: false,
      modalReimbursement: false,
      resolved: false,
      from: null,
      to: null,
      busOperator: '',
      excludedOperators: [],
      complaintCategory: null,
      intervalType: 'approved_at',
      intervalOptions: [{ text: 'Fecha aprobación', value: 'approved_at' }, { text: 'Fecha ingreso', value: 'created_at' }],
      maxAmount: 0,
      total: 0,
      action: null,
      showDialog: false
    };
  },
  created: function created() {
    this.fetchCategories();
    this.fetchComplaints(undefined, false);
    this.fetchOperators();
  },

  watch: {
    from: function from() {
      this.updateTotals();
    },
    to: function to() {
      this.updateTotals();
    },
    busOperator: function busOperator() {
      this.updateTotals();
    },
    complaintCategory: function complaintCategory() {
      this.updateTotals();
    },
    intervalType: function intervalType() {
      this.updateTotals();
    },
    excludedOperators: function excludedOperators() {
      this.updateTotals();
    }
  },
  methods: {
    busOperators: function busOperators(complaint) {
      var busOperators = complaint.ticket_info.bus_operators;

      if (busOperators.length > 1) {
        return String(busOperators).replace(',', ', ');
      }
      return String(busOperators);
    },
    complaintAge: function complaintAge(complaint) {
      return __WEBPACK_IMPORTED_MODULE_9__utils_dateService__["a" /* default */].complaintAge(complaint.created_at);
    },
    fetchCategories: function fetchCategories() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_5__services_apiService__["a" /* default */].get_categories().then(function (res) {
        _this.categories = res.body.reduce(function (acc, item) {
          acc[item.number] = { description: item.name };
          return acc;
        }, {});
      });
    },
    fetchComplaints: function fetchComplaints(page) {
      var _this2 = this;

      var $this = this;
      __WEBPACK_IMPORTED_MODULE_5__services_apiService__["a" /* default */].finance(page, this.filterText, this.resolved).then(function (data) {
        $this.complaints = data.body;
        if (data.body.length === 0 && _this2.filterText !== '') {
          $this.$notify({
            group: 'finance',
            type: 'error',
            title: 'Error',
            text: 'No se encontraron resultados',
            duration: 2000
          });
        }
        $this.setPagination(data);
      });
    },
    fetchOperators: function fetchOperators() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_5__services_apiService__["a" /* default */].get_operators().then(function (data) {
        _this3.operators = data.body;
      });
    },
    setPagination: function setPagination(res) {
      var links = Object.prototype.hasOwnProperty.call(res.headers.map, 'links') ? parse(res.headers.map.link[0]) : null;
      var pagination = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
        current: parseInt(res.headers.map.page, 10),
        total: parseInt(res.headers.map.total, 10),
        per_page: parseInt(res.headers.map['per-page'], 10)
      }, links);
      this.$set(this, 'pagination', pagination);
    },
    changePage: function changePage(page) {
      this.fetchComplaints(page);
    },
    showComplaintDetails: function showComplaintDetails(complaint) {
      __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].commit('selectComplaint', complaint);
      this.$router.push('/complaints/' + complaint._id.$oid);
    },
    search: function search() {
      this.fetchComplaints(1);
    },
    refreshComplaints: function refreshComplaints() {
      var _this4 = this;

      this.intervalId = setInterval(function () {
        _this4.fetchComplaints(undefined, false);
      }, 120000);
    },
    openModal: function openModal(action) {
      this.modalDate = true;
      this.action = action;
    },
    paypalModal: function paypalModal() {
      this.modalReimbursement = true;
      this.action = 'paypal';
    },
    paypalReimburse: function paypalReimburse() {
      var $this = this;
      if (this.from === null || this.to === null || this.maxAmount <= 0) {
        $this.$notify({
          group: 'finance',
          type: 'error',
          title: 'Error',
          text: 'Error al ingresar los parámetros',
          duration: 2000
        });
      } else {
        var from = __WEBPACK_IMPORTED_MODULE_9__utils_dateService__["a" /* default */].getDate(this.from);
        var to = __WEBPACK_IMPORTED_MODULE_9__utils_dateService__["a" /* default */].getDate(this.to);
        __WEBPACK_IMPORTED_MODULE_5__services_apiService__["a" /* default */].refundPaypal({
          from: from,
          to: to,
          max_amount: this.maxAmount,
          busOperator: this.busOperator,
          category: this.complaintCategory,
          interval: this.intervalType,
          excludedOperators: this.excludedOperators
        }).then(function (res) {
          $this.fetchComplaints(1);
          $this.closeModal();
          $this.$notify({
            group: 'finance',
            type: 'success',
            title: 'Reembolso finalizado',
            text: res.body,
            duration: 3000
          });
        }).catch(function () {
          $this.$notify({
            group: 'finance',
            type: 'error',
            title: 'Error',
            text: 'Ocurrió un error al realizar el reembolso',
            duration: 2000
          });
        });
      }
    },
    exportAll: function exportAll() {
      var _this5 = this;

      __WEBPACK_IMPORTED_MODULE_5__services_apiService__["a" /* default */].downloadAll().then(function () {
        _this5.$notify({
          group: 'finance',
          type: 'success',
          title: 'Descargar Reclamos',
          text: 'Se enviará un mail junto con el archivo csv',
          duration: 5000
        });
      });
    },
    exportData: function exportData() {
      var $this = this;
      if (this.from === null || this.to === null) {
        $this.$notify({
          group: 'finance',
          type: 'error',
          title: 'Error',
          text: 'Debe ingresar fechas',
          duration: 2000
        });
      } else {
        var from = __WEBPACK_IMPORTED_MODULE_9__utils_dateService__["a" /* default */].getDate(this.from);
        var to = __WEBPACK_IMPORTED_MODULE_9__utils_dateService__["a" /* default */].getDate(this.to);
        if (this.action === 'discount') {
          __WEBPACK_IMPORTED_MODULE_5__services_apiService__["a" /* default */].downloadDiscount(from, to).then(function (res) {
            $this.handleDownload(res);
            $this.closeModal();
          });
        } else {
          var options = {
            from: from,
            to: to,
            busOperator: this.busOperator,
            category: this.complaintCategory,
            interval: this.intervalType,
            excludedOperators: this.excludedOperators
          };
          __WEBPACK_IMPORTED_MODULE_5__services_apiService__["a" /* default */].downloadBice(options).then(function (res) {
            $this.handleDownload(res);
            $this.closeModal();
          });
        }
      }
    },
    importBice: function importBice() {
      document.getElementById('requestFile').click();
    },
    uploadFile: function uploadFile() {
      var $this = this;
      var formData = new FormData();
      formData.append('file', document.getElementById('requestFile').files[0]);
      __WEBPACK_IMPORTED_MODULE_5__services_apiService__["a" /* default */].uploadBice(formData).then(function (res) {
        $this.fetchComplaints(1);
        $this.$notify({
          group: 'finance',
          type: 'success',
          title: 'Carga finalizada',
          text: res.body,
          duration: 3000
        });
      }).catch(function () {
        $this.$notify({
          group: 'finance',
          type: 'error',
          title: 'Error',
          text: 'Ocurrió un error al subir el archivo',
          duration: 3000
        });
      });
    },
    handleDownload: function handleDownload(res) {
      var blob = new Blob([res.body], { type: res.headers.get('content-type') });
      var filename = (res.headers.get('content-disposition') || '').split('filename=')[1];
      var a = document.createElement('a');
      a.href = window.URL.createObjectURL(blob);
      a.download = filename.replace(/"/g, '');
      a.click();
    },
    closeModal: function closeModal() {
      this.from = null;
      this.to = null;
      this.action = null;
      this.maxAmount = 0;
      this.total = 0;
      this.modalDate = false;
      this.modalReimbursement = false;
      this.busOperator = '';
      this.complaintCategory = null;
      this.excludedOperators = [];
    },
    showResolved: function showResolved() {
      this.fetchComplaints(1);
    },
    updateTotals: function updateTotals() {
      var $this = this;
      if (this.from !== null && this.to !== null) {
        var from = __WEBPACK_IMPORTED_MODULE_9__utils_dateService__["a" /* default */].getDate(this.from);
        var to = __WEBPACK_IMPORTED_MODULE_9__utils_dateService__["a" /* default */].getDate(this.to);
        var options = {
          from: from,
          to: to,
          action: this.action,
          busOperator: this.busOperator,
          category: this.complaintCategory,
          interval: this.intervalType,
          excludedOperators: this.excludedOperators
        };
        __WEBPACK_IMPORTED_MODULE_5__services_apiService__["a" /* default */].getTotal(options).then(function (res) {
          console.log(res.body); // eslint-disable-line
          $this.total = res.body.total;
        }).catch(function () {
          $this.total = 0;
        });
      }
    },
    refreshReloaAppStatus: function refreshReloaAppStatus() {
      var _this6 = this;

      this.intervalId = setInterval(function () {
        __WEBPACK_IMPORTED_MODULE_5__services_apiService__["a" /* default */].reloadAppStatus().then(function (response) {
          if (response.body) {
            _this6.showDialog = true;
          }
        });
      }, 900000);
    }
  },
  computed: {
    operatorsForSelect: function operatorsForSelect() {
      return [{ name: 'Todos los operadores', id: '' }].concat(this.operators);
    }
  },
  mounted: function mounted() {
    this.refreshComplaints();
    this.refreshReloaAppStatus();
  },
  beforeDestroy: function beforeDestroy() {
    clearInterval(this.intervalId);
  }
});

/***/ }),

/***/ "L60Q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Operators_vue__ = __webpack_require__("CZfS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_216ed7aa_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Operators_vue__ = __webpack_require__("O0rK");
function injectStyle (ssrContext) {
  __webpack_require__("gG4h")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Operators_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_216ed7aa_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Operators_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "M1ba":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var base = void 0;

var envName = "qa" || 'development';
var topLevelDomain = envName !== 'development' ? location.host.split('.').pop() : '';
var isNotProduction = envName !== 'production' && envName !== 'productionNew';

// API URL resolution: Use API_SUBDOMAIN for non-production if set, otherwise check
// built-in environment map. Custom QA environments MUST set API_SUBDOMAIN.
// See README.md "API URL Resolution Logic" section for details.
if ("kexa-qa" && isNotProduction) {
  base = 'https://' + "kexa-qa" + '.recorrido.' + topLevelDomain;
} else {
  var domainsByEnvironment = {
    productionNew: 'https://kexa-production.recorrido.' + topLevelDomain,
    production: 'http://kexa.recorrido.' + topLevelDomain,
    qa: 'https://kexa-qa.recorrido.' + topLevelDomain
  };

  base = domainsByEnvironment[envName] || 'http://localhost:4000';
}

/* harmony default export */ __webpack_exports__["a"] = ({
  API_URL: base + '/api/v1',
  TOKEN_URL: base + '/token'
});

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1e0d565a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("NTCI");
function injectStyle (ssrContext) {
  __webpack_require__("v/ar")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1e0d565a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MRiZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__perimeters_actionsPerimeter__ = __webpack_require__("Qh7t");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue2_selectize__ = __webpack_require__("py5U");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue2_selectize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue2_selectize__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants_Status_constants__ = __webpack_require__("XXAu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants_Url_constants__ = __webpack_require__("M1ba");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_apiService__ = __webpack_require__("a/3G");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_layout_Actions__ = __webpack_require__("SUb6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_layout_Comments__ = __webpack_require__("3YGy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_layout_LastActivity__ = __webpack_require__("sX+p");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue2_dropzone__ = __webpack_require__("KvPw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue2_dropzone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vue2_dropzone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue2_dropzone_dist_vue2Dropzone_min_css__ = __webpack_require__("9BHd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue2_dropzone_dist_vue2Dropzone_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vue2_dropzone_dist_vue2Dropzone_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vee_validate__ = __webpack_require__("sUu7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_dni__ = __webpack_require__("Eayd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_dni___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_vue_dni__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_forms_ShowBankAccountForm__ = __webpack_require__("zp9P");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__utils_dateService__ = __webpack_require__("4F1w");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

















/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'show_complaint',
  components: {
    Actions: __WEBPACK_IMPORTED_MODULE_7__components_layout_Actions__["a" /* default */],
    Comments: __WEBPACK_IMPORTED_MODULE_8__components_layout_Comments__["a" /* default */],
    Selectize: __WEBPACK_IMPORTED_MODULE_3_vue2_selectize___default.a,
    LastActivity: __WEBPACK_IMPORTED_MODULE_9__components_layout_LastActivity__["a" /* default */],
    vueDropzone: __WEBPACK_IMPORTED_MODULE_10_vue2_dropzone___default.a,
    ShowBankAccountForm: __WEBPACK_IMPORTED_MODULE_14__components_forms_ShowBankAccountForm__["a" /* default */]
  },
  perimeters: [__WEBPACK_IMPORTED_MODULE_2__perimeters_actionsPerimeter__["a" /* default */]],
  data: function data() {
    return {
      complaint: {},
      bank_info: {},
      dropzoneOptions: {
        url: __WEBPACK_IMPORTED_MODULE_5__constants_Url_constants__["a" /* default */].API_URL + '/complaints/' + this.$route.params.complaint_id + '/additional_info',
        dictDefaultMessage: 'Cargar archivos',
        thumbnailWidth: 150,
        maxFilesize: 8,
        headers: { Authorization: 'Bearer ' + this.$store.getters.token }
      },
      dialogOptions: {
        okText: 'Continuar',
        cancelText: 'Cancelar'
      },
      new_status: null,
      statuses: __WEBPACK_IMPORTED_MODULE_4__constants_Status_constants__["a" /* default */].STATUSES,
      categories: [],
      accounts: __WEBPACK_IMPORTED_MODULE_4__constants_Status_constants__["a" /* default */].ACCOUNTS,
      complaint_attachment: null,
      request_id: null,
      info_request: null,
      loader: false,
      max: 16,
      allowed_payment_methods: __WEBPACK_IMPORTED_MODULE_4__constants_Status_constants__["a" /* default */].PAYMENT_METHODS,
      refund_methods: __WEBPACK_IMPORTED_MODULE_4__constants_Status_constants__["a" /* default */].REFUND_METHODS,
      signedLink: '',
      refund_method: {
        email: '',
        code: ''
      },
      showDialog: false,
      intervalId: null
    };
  },

  computed: {
    commentsTitle: function commentsTitle() {
      var svgCircle = '<svg aria-hidden="true" data-icon="circle" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="svg-circle"><path fill="red" d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8z" class=""></path></svg>';
      if (this.$store.getters.commentsLength > 0) {
        return 'Comentarios ' + svgCircle;
      }
      return 'Comentarios';
    },
    complaintAge: function complaintAge() {
      return __WEBPACK_IMPORTED_MODULE_15__utils_dateService__["a" /* default */].complaintAge(this.complaint.created_at);
    },
    requests: function requests() {
      if (this.complaint.additional_infos === undefined) {
        return [];
      }
      return this.complaint.additional_infos.filter(function (n) {
        return n.source === 'internal';
      });
    },
    public_url: function public_url() {
      var currentUrl = document.location.href;
      currentUrl = currentUrl.replace('complaints', 'status');

      return currentUrl;
    },
    copyBankData: function copyBankData() {
      switch (this.complaint.country) {
        case 'PE':
          return 'M\xE9todo de reembolso: ' + this.complaint.refund_method + '\n' + ('Nombre: ' + this.bank_info.name + '\n') + ('Tipo de documento: ' + this.bank_info.document_type + '\n') + ('N\xFAmero de documento: ' + this.bank_info.document_number + '\n') + ('Correo comprador: ' + this.complaint.ticket_info.email + '\n') + ('Banco: ' + this.bank_info.bank + '\n') + ('Tipo de Cuenta: ' + this.accounts[this.bank_info.account_type].description + '\n') + ('N\xFAmero de Cuenta: ' + this.bank_info.account_number + '\n') + ('CCI: ' + this.bank_info.cci);
        default:
          return 'M\xE9todo de reembolso: ' + this.complaint.refund_method + '\n' + ('Nombre: ' + this.bank_info.name + '\n') + ('RUT: ' + this.bank_info.rut + '\n') + ('Correo comprador: ' + this.complaint.ticket_info.email + '\n') + ('Banco: ' + this.bank_info.bank + '\n') + ('Tipo de Cuenta: ' + this.accounts[this.bank_info.account_type].description + '\n') + ('N\xFAmero de Cuenta: ' + this.bank_info.account_number);
      }
    },
    refundMethod: function refundMethod() {
      switch (this.complaint.refund_method) {
        case 'payroll_bank':
          return 'Nómina Banco';
        case 'devolution_paypal':
          return 'Reembolso PayPal';
        case 'payroll_paypal':
          return 'Nómina PayPal';
        case 'devolution_payu':
          return 'Reembolso PayU';
        case 'devolution_tbk':
          return 'Reembolso TBK';
        case 'devolution_oneclick':
          return 'Reembolso Oneclick';
        case 'devolution_fintoc':
          return 'Reembolso Fintoc';
        case 'devolution_mercado_pago':
          return 'Reembolso Mercado Pago';
        case 'devolution_floid':
          return 'Reembolso Floid';
        default:
          return '';
      }
    },
    availableRefundMethods: function availableRefundMethods() {
      var targetCode = __WEBPACK_IMPORTED_MODULE_4__constants_Status_constants__["a" /* default */].REFUND_METHOD_TARGETS[this.complaint.refund_method];
      if (!targetCode) return [];
      return this.refund_methods.filter(function (m) {
        return m.code === targetCode;
      });
    },
    isPaypalRefundMethod: function isPaypalRefundMethod() {
      return ['payroll_paypal', 'devolution_paypal'].includes(this.complaint.refund_method);
    },
    estimatedAmountUsd: function estimatedAmountUsd() {
      var priceUsd = Number(this.complaint.ticket_info && this.complaint.ticket_info.price_usd);
      var percentage = Number(this.complaint.reimbursement && this.complaint.reimbursement.percentage);
      if (!priceUsd || !percentage) return null;
      var total = priceUsd / 100 * percentage;
      var rounded = Math.round(total * 100) / 100;
      return rounded.toFixed(2);
    }
  },
  beforeMount: function beforeMount() {
    __WEBPACK_IMPORTED_MODULE_12_vee_validate__["b" /* Validator */].extend('rut', __WEBPACK_IMPORTED_MODULE_13_vue_dni__["rutValidator"]);
    this.fetchCategories();
    this.fetchComplaint();
    this.refreshReloaAppStatus();
  },

  methods: {
    statusClassName: function statusClassName(complaint) {
      var statusClass = this.statuses[complaint.aasm_state] === undefined ? null : this.statuses[complaint.aasm_state].initials.toLowerCase();
      return 'status-' + statusClass;
    },
    fetchCategories: function fetchCategories() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_6__services_apiService__["a" /* default */].get_categories().then(function (res) {
        _this.categories = res.body.reduce(function (acc, item) {
          acc[item.number] = { description: item.name };
          return acc;
        }, {});
      });
    },
    fetchComplaint: function fetchComplaint() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_6__services_apiService__["a" /* default */].get(this.$route.params.complaint_id).then(function (data) {
        _this2.complaint = data.body;
        _this2.new_status = data.body.status;
        _this2.bank_info = data.body.bank_account || {};
        if (_this2.complaint.bank_account === undefined) {
          _this2.complaint.bank_account = data.body.bank_account || {};
        }
        document.title = 'Reclamo #' + _this2.complaint.number + ' | Kexa';
        __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].commit('selectComplaint', _this2.complaint);
      });
    },
    slideEditAttribute: function slideEditAttribute(e) {
      var currentElement = e.target;
      var activeEditClass = 'active-edit';
      var editVisibleClass = 'edit-visible';

      // Normalize element selection
      if (currentElement.tagName === 'path') {
        currentElement = currentElement.parentElement;
      } else if (currentElement.tagName === 'SPAN') {
        currentElement = currentElement.querySelector('svg');
      }

      // Toggle classes to display respective edit fields
      if (!currentElement.classList.contains(activeEditClass)) {
        currentElement.classList.add(activeEditClass);
        currentElement.parentElement.nextElementSibling.classList.add(editVisibleClass);
      } else {
        currentElement.classList.remove(activeEditClass);
        currentElement.parentElement.nextElementSibling.classList.remove(editVisibleClass);
      }
    },
    setCompanyDiscount: function setCompanyDiscount(e) {
      this.complaint.reimbursement.discount = e.target.value;
      this.complaint.reimbursement.discount_percentage = (100 * (this.complaint.reimbursement.discount / this.complaint.ticket_info.original_price)).toFixed(2);
    },
    setCompanyDiscountPercentage: function setCompanyDiscountPercentage(e) {
      this.complaint.reimbursement.discount_percentage = e.target.value;
      this.complaint.reimbursement.discount = (this.complaint.reimbursement.discount_percentage * this.complaint.ticket_info.original_price / 100).toFixed(2);
    },
    updateBusOperatorDiscount: function updateBusOperatorDiscount() {
      var _this3 = this;

      var $this = this;
      var currentReimbursement = $this.complaint.reimbursement;

      if (currentReimbursement.discount_from_company === false) {
        currentReimbursement.discount_percentage = 0;
        currentReimbursement.discount = 0;
      }

      if (currentReimbursement.discount_from_company === true && (currentReimbursement.discount_percentage === 0 || currentReimbursement.discount === 0)) {
        this.$notify({
          group: 'show_complaint',
          type: 'error',
          title: 'Error',
          text: 'No puedes guardar un descuento de 0',
          duration: 3000
        });
      } else {
        __WEBPACK_IMPORTED_MODULE_6__services_apiService__["a" /* default */].update($this.$route.params.complaint_id, {
          new_state: '',
          reimbursement: currentReimbursement
        }).then(function () {
          _this3.$notify({
            group: 'show_complaint',
            type: 'success',
            title: 'Éxito',
            text: 'Se ha actualizado el descuento del reclamo',
            duration: 3000
          });
          $this.fetchComplaint();
          $this.$refs.editComplaintDataModal.hide();
        });
      }
    },
    updateComplaintAttributes: function updateComplaintAttributes() {
      var _this4 = this;

      var newAasmState = this.complaint.aasm_state;
      var newCategory = this.complaint.category;
      var newComment = this.complaint.comment;

      __WEBPACK_IMPORTED_MODULE_6__services_apiService__["a" /* default */].forceUpdate(this.$route.params.complaint_id, {
        aasm_state: newAasmState,
        category: newCategory,
        comment: newComment
      }).then(function () {
        _this4.$notify({
          group: 'show_complaint',
          type: 'success',
          title: 'Éxito',
          text: 'Reclamo actualizado',
          duration: 3000
        });
        document.querySelectorAll('.edit-icon-container .fa-icon').forEach(function (c) {
          return c.classList.remove('active-edit');
        });
        document.querySelectorAll('.edit-attribute').forEach(function (c) {
          return c.classList.remove('edit-visible');
        });
        _this4.fetchComplaint();
      }).catch(function (exception) {
        if (exception.status === 405) {
          _this4.$notify({
            group: 'show_complaint',
            type: 'error',
            text: 'No es posible actualizar este reclamo, porque ya está siendo procesado por una cancelación. Solo puede ser actualizado a Resuelto',
            duration: 8000
          });
        } else if (exception.status === 422 && newAasmState === 'approved_reimbursement') {
          _this4.$notify({
            group: 'show_complaint',
            type: 'error',
            text: 'Debe ingresar un porcentaje a reembolsar al reclamo',
            duration: 8000
          });
        } else {
          _this4.$notify({ group: 'show_complaint', title: 'Error', text: 'Error al actualizar el reclamo', type: 'error', duration: 3000 });
        }
      });
    },
    uploadAttachment: function uploadAttachment() {
      var formData = new FormData();
      var $this = this;
      formData.append('request', 'add');
      $this.loader = true;
      if (this.complaint_attachment !== null) {
        formData.append('file', this.complaint_attachment);
        __WEBPACK_IMPORTED_MODULE_6__services_apiService__["a" /* default */].upload_file(this.$route.params.complaint_id, formData).then(function () {
          $this.complaint_attachment = null;
          $this.fetchComplaint();
          $this.loader = false;
        });
      }
    },
    requestInfo: function requestInfo() {
      var _this5 = this;

      __WEBPACK_IMPORTED_MODULE_6__services_apiService__["a" /* default */].request_info(this.$route.params.complaint_id, {
        request: this.info_request
      }).then(function () {
        _this5.info_request = null;
        _this5.fetchComplaint();
      });
    },
    addFile: function addFile(id) {
      document.getElementById('requestFile').click();
      this.request_id = id;
    },
    uploadFile: function uploadFile() {
      var _this6 = this;

      var formData = new FormData();
      formData.append('request_id', this.request_id);
      formData.append('file', document.getElementById('requestFile').files[0]);
      __WEBPACK_IMPORTED_MODULE_6__services_apiService__["a" /* default */].append_file(this.$route.params.complaint_id, formData).then(function () {
        _this6.fetchComplaint();
      });
    },
    updateActivity: function updateActivity() {
      this.$refs.activity.fetchActivities();
    },
    closeModal: function closeModal() {
      this.$refs.editComplaintDataModal.hide();
      this.$refs.bankDataModal.hide();
    },
    notifyCopy: function notifyCopy() {
      this.$notify({
        group: 'show_complaint',
        type: 'success',
        title: 'Éxito',
        text: 'La URL pública de este reclamo ha sido copiada a tu portapapeles.',
        duration: 3000
      });
    },
    notifyCopyBank: function notifyCopyBank() {
      this.$notify({
        group: 'show_complaint',
        type: 'success',
        title: 'Éxito',
        text: 'Los datos bancarios han sido copiados a tu portapapeles.',
        duration: 3000
      });
    },
    dataCopied: function dataCopied() {
      this.$notify({
        group: 'show_complaint',
        type: 'success',
        title: 'Éxito',
        text: 'Dato copiado al portapapeles.',
        duration: 3000
      });
    },
    back: function back() {
      this.$router.go(-1);
    },
    deleteAttachment: function deleteAttachment(attachment) {
      var $this = this;
      this.$dialog.confirm('¿Deseas eliminar el archivo adjunto?', this.dialogOptions).then(function () {
        __WEBPACK_IMPORTED_MODULE_6__services_apiService__["a" /* default */].removeAttachment($this.$route.params.complaint_id, attachment).then(function () {
          $this.fetchComplaint();
        });
      }).catch(function () {});
    },
    updateRefundMethod: function updateRefundMethod() {
      var _this7 = this;

      this.$validator.validateAll().then(function (valid) {
        if (valid) {
          _this7.$dialog.confirm({
            title: 'Método de reembolso',
            body: '¿Desea continuar con los cambios?'
          }).then(function () {
            __WEBPACK_IMPORTED_MODULE_6__services_apiService__["a" /* default */].updateRefundMethod(_this7.$route.params.complaint_id, _this7.refund_method).then(function () {
              _this7.$refs.editRefundMethod.hide();
              _this7.refund_method = { email: '', code: '' };
              _this7.$validator.reset();
              _this7.fetchComplaint();
            }).catch(function (response) {
              _this7.$notify({
                group: 'show_complaint',
                type: 'error',
                title: 'Error',
                text: response.bodyText,
                duration: 2000
              });
            });
          }).catch(function () {});
        }
      });
    },
    closeRefundMethodModal: function closeRefundMethodModal() {
      this.$refs.editRefundMethod.hide();
      this.refund_method = { email: '', code: '' };
      this.$validator.reset();
    },
    canAddBankData: function canAddBankData() {
      if (this.complaint.refund_method === 'devolution_tbk' || this.complaint.refund_method === 'devolution_oneclick') {
        return false;
      }

      return true;
    },
    canUpdateRefundMethod: function canUpdateRefundMethod() {
      if (__WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.user.role !== 3) {
        return false;
      }
      var allowedStates = ['approved_bank', 'approved_reimbursement', 'reimbursement_error'];
      var allowedMethods = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(__WEBPACK_IMPORTED_MODULE_4__constants_Status_constants__["a" /* default */].REFUND_METHOD_TARGETS);
      return allowedStates.includes(this.complaint.aasm_state) && allowedMethods.includes(this.complaint.refund_method);
    },
    refreshReloaAppStatus: function refreshReloaAppStatus() {
      var _this8 = this;

      this.intervalId = setInterval(function () {
        __WEBPACK_IMPORTED_MODULE_6__services_apiService__["a" /* default */].reloadAppStatus().then(function (response) {
          if (response.body) {
            _this8.showDialog = true;
          }
        });
      }, 900000);
    },
    openFileModal: function openFileModal(additionalInfoId) {
      var _this9 = this;

      __WEBPACK_IMPORTED_MODULE_6__services_apiService__["a" /* default */].getSignedLink(this.$route.params.complaint_id, additionalInfoId).then(function (data) {
        _this9.signedLink = data.body.signed_link;
        _this9.$refs['imageModal-' + additionalInfoId][0].show();
      }).catch(function (response) {
        _this9.$notify({
          group: 'show_complaint',
          type: 'error',
          title: 'Error',
          text: response.bodyText,
          duration: 2000
        });
      });
    },
    openFileTab: function openFileTab(additionalInfoId) {
      var _this10 = this;

      __WEBPACK_IMPORTED_MODULE_6__services_apiService__["a" /* default */].getSignedLink(this.$route.params.complaint_id, additionalInfoId).then(function (data) {
        window.open(data.body.signed_link, '_blank');
      }).catch(function (response) {
        _this10.$notify({
          group: 'show_complaint',
          type: 'error',
          title: 'Error',
          text: response.bodyText,
          duration: 2000
        });
      });
    },
    dowloadFile: function dowloadFile(additionalInfoId) {
      var _this11 = this;

      __WEBPACK_IMPORTED_MODULE_6__services_apiService__["a" /* default */].getSignedLink(this.$route.params.complaint_id, additionalInfoId).then(function (data) {
        var link = document.createElement('a');
        link.href = data.body.signed_link;
        link.download = '';
        link.target = '_blank';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }).catch(function (response) {
        _this11.$notify({
          group: 'show_complaint',
          type: 'error',
          title: 'Error',
          text: response.bodyText,
          duration: 2000
        });
      });
    }
  },
  beforeDestroy: function beforeDestroy() {
    clearInterval(this.intervalId);
  }
});

/***/ }),

/***/ "MZ6X":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('notifications',{attrs:{"group":"status","position":"top center"}}),_c('header',{staticClass:"public-header row justify-content-md-center"},[_c('b-col',{attrs:{"md":"10"}},[_c('a',{attrs:{"href":"https://www.recorrido.cl/es/","target":"_blank"}},[_c('img',{staticClass:"recorrido-logo",attrs:{"src":_vm.logo}})])])],1),(_vm.complaint.aasm_state)?_c('b-row',{staticClass:"justify-content-md-center",staticStyle:{"padding-top":"25px"}},[_c('b-col',{attrs:{"md":"10"}},[_c('h3',[_vm._v("Reclamo #"+_vm._s(_vm.complaint.number)),_c('span',{staticClass:"complaint-category"},[_vm._v(_vm._s(_vm.complaint.complaint_category.name))])]),_c('div',{staticClass:"complaint-wizard"},[_c('ol',{staticClass:"complaint-wizard-steps"},[_c('li',{staticClass:"a-wizard-step"},[_c('span',{staticClass:"step-number"},[_vm._v("1")]),_vm._v("Reclamo ingresado")]),_c('li',{staticClass:"a-wizard-step"},[_c('span',{staticClass:"step-number"},[_vm._v("2")]),_vm._v("En revisión")]),_c('li',{staticClass:"a-wizard-step"},[_c('span',{staticClass:"step-number"},[_vm._v("3")]),_vm._v(_vm._s(_vm.complaint.aasm_state === 'expired' ? 'Expirado' : 'Resuelto'))])])]),(_vm.complaint.category)?_c('div',{staticClass:"complaint-category-container"},[(_vm.complaint.category === 8)?_c('p',[_c('strong',[_vm._v("Hola equipo Busbud,"),(_vm.wizard_status === 'review')?_c('span',[_c('br'),_vm._v("Hemos recibido su requerimiento y ha sido ingresado con el ID "+_vm._s(_vm.complaint.number)+". Nos pondremos en contacto con la empresa de buses y volveremos con una respuesta a través de este mismo medio.")]):_vm._e(),(_vm.wizard_status === 'resolved')?_c('span',[_vm._v(" el reclamo ha sido resuelto.")]):_vm._e()])]):_c('p',[_c('strong',[_vm._v(_vm._s(_vm.setFormalOpening)+" "+_vm._s(_vm.issuer_name)+","),(_vm.wizard_status === 'review')?_c('span',[_vm._v(" su reclamo se encuentra en revisión.")]):_vm._e(),(_vm.wizard_status === 'resolved')?_c('span',[_vm._v(" su reclamo "+_vm._s(_vm.complaint.aasm_state === 'expired' ? 'ha expirado.': 'se ha resuelto.'))]):_vm._e()])])]):_vm._e(),_c('p',[_vm._v("Número de compra: "+_vm._s(_vm.complaint.ticket_info.booking_number)),_c('br'),_vm._v("Fecha ingreso de reclamo: "+_vm._s(_vm._f("formatDate")(_vm.customFormat(_vm.complaint.created_at)))),_c('br'),_vm._v("Fecha actualización de reclamo: "+_vm._s(_vm._f("formatDate")(_vm.customFormat(_vm.complaint.updated_at)))),_c('br')]),(this.complaint.additional_infos.length > 0 && _vm.complaint.aasm_state === 'pending_requested')?_c('div',{staticClass:"requested-information-notice"},[_c('img',{staticClass:"request-icon",attrs:{"src":_vm.requestIcon}}),_c('p',[_c('strong',[_vm._v("Información adicional requerida")]),_c('br'),_vm._v("Para poder solucionar su reclamo, necesitamos información adicional."),_c('br'),_c('a',{staticClass:"inline-dark-link",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.openInformationRequestTab($event)}}},[_vm._v("Haga clic aquí")]),_vm._v(" para subir la información adicional solicitada al sistema.")])]):_vm._e(),_c('div',{staticClass:"resolved-status-container"},[(_vm.complaint.aasm_state === 'expired')?_c('div',[_c('h4',[_c('img',{attrs:{"src":_vm.rejectIcon}}),_c('span',[_vm._v("Reclamo expirado.")])]),_c('p',[_c('img',{attrs:{"src":_vm.messageIcon}}),_vm._v(_vm._s(this.getExpiredMessage()))])]):_vm._e(),(_vm.complaint.aasm_state === 'rejected')?_c('div',[_c('h4',[_c('img',{attrs:{"src":_vm.rejectIcon}}),_c('span',[_vm._v("Reclamo rechazado.")])]),_c('p',[_c('img',{attrs:{"src":_vm.messageIcon}}),_c('strong',{domProps:{"innerHTML":_vm._s(_vm.complaint.response.comment)}})])]):_vm._e(),(_vm.complaint.aasm_state === 'approved_bank' && _vm.complaint.reimbursement)?_c('div',[_c('h4',[_c('img',{attrs:{"src":_vm.approveIcon}}),_vm._v("Reclamo aprobado."),_c('br'),_vm._v("Monto devolución: \n"+_vm._s(_vm.complaint.reimbursement.amount)+" "+_vm._s(_vm.complaint.ticket_info.sold_currency))]),(_vm.complaint.reimbursement.comment)?_c('p',[_c('img',{attrs:{"src":_vm.messageIcon}}),_c('strong',{staticClass:"reimbursement",domProps:{"innerHTML":_vm._s(_vm.complaint.reimbursement.comment)}})]):_vm._e()]):_vm._e(),(_vm.complaint.aasm_state === 'closed' && _vm.complaint.reimbursement && _vm.complaint.reimbursement.compensation_type === 'o')?_c('div',[_c('h4',[_c('img',{attrs:{"src":_vm.approveIcon}}),_vm._v("Reclamo aprobado."),_c('br')]),(_vm.complaint.response.comment)?_c('p',[_c('img',{attrs:{"src":_vm.messageIcon}}),_c('strong',{staticClass:"reimbursement",domProps:{"innerHTML":_vm._s(_vm.complaint.response.comment)}})]):_vm._e()]):_vm._e(),(_vm.complaint.aasm_state === 'closed' && _vm.complaint.reimbursement && _vm.complaint.reimbursement.compensation_type === 'm')?_c('div',[_c('h4',[_c('img',{attrs:{"src":_vm.approveIcon}}),_vm._v("Reclamo aprobado.")])]):_vm._e()]),_c('div',{staticClass:"update-status"},[(_vm.complaintOlderThanAWeek && _vm.wizard_status !== 'resolved')?_c('p',{staticClass:"update-message"},[_vm._v("Ya insistimos con la empresa de bus para obtener una resolución lo antes posible."),_c('br'),_vm._v("Lamentablemente aún no tenemos respuesta."),_c('br'),_vm._v("Una vez que tengamos respuesta de la empresa de bus, le contactaremos.")]):_vm._e(),(_vm.complaint.aasm_state === 'approved_bank' || _vm.complaint.aasm_state === 'reimbursement_error')?_c('div',[(_vm.complaint.refund_method !== 'payroll_paypal')?_c('div',[_c('h4',[_vm._v("Ingresa tus datos bancarios")]),_c('status-bank-account-form',{attrs:{"complaint":_vm.complaint},on:{"fetchComplaint":_vm.fetchComplaint}})],1):_c('div',[_c('h4',[_vm._v("Actualiza tu cuenta de PayPal")]),_c('b-form',{staticClass:"form-horizontal",on:{"submit":function($event){$event.preventDefault();_vm.handleUpdatePaypalAccount($event)}}},[_c('b-form-group',{attrs:{"label":"Correo PayPal"}},[_c('b-form-input',{directives:[{name:"validate",rawName:"v-validate",value:('required|email'),expression:"'required|email'"}],staticClass:"form-control",attrs:{"name":"paypal_email","data-vv-as":"Correo PayPal","type":"email","autocomplete":"off"},model:{value:(_vm.paypal_email),callback:function ($$v) {_vm.paypal_email=$$v},expression:"paypal_email"}}),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('paypal_email')),expression:"errors.has('paypal_email')"}],staticClass:"has-error"},[_vm._v(_vm._s(_vm.errors.first('paypal_email')))]),_c('b-form-group',{attrs:{"label":"Confirma tu correo Paypal"}},[_c('b-form-input',{directives:[{name:"validate",rawName:"v-validate",value:('required|email|confirmed:paypal_email'),expression:"'required|email|confirmed:paypal_email'"}],staticClass:"form-control",attrs:{"name":"paypal_email_confirmation","data-vv-as":"Confirma tu correo Paypal","type":"email","autocomplete":"off"},model:{value:(_vm.paypal_email_confirmation),callback:function ($$v) {_vm.paypal_email_confirmation=$$v},expression:"paypal_email_confirmation"}}),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('paypal_email_confirmation')),expression:"errors.has('paypal_email_confirmation')"}],staticClass:"has-error"},[_vm._v(_vm._s(_vm.errors.first('paypal_email_confirmation')))])],1),_c('b-form-group',{staticClass:"text-center"}),_c('b-button',{attrs:{"type":"submit","variant":"primary"}},[_vm._v("Ingresar")])],1)],1)],1)]):_vm._e()]),(_vm.complaint.ticket_info && _vm.complaint.ticket_info.tickets.length > 0)?_c('h4',{staticClass:"complaint-details-title"},[_vm._v("Detalles de su reclamo")]):_vm._e(),_c('b-tabs',[_c('b-tab',{attrs:{"title":"Pasaje"}},[(_vm.complaint.ticket_info && _vm.complaint.ticket_info.tickets.length > 0)?_c('table',{staticClass:"table"},[_c('tr',{directives:[{name:"show",rawName:"v-show",value:(_vm.complaint.ticket_info.tickets.length > 0),expression:"complaint.ticket_info.tickets.length > 0"}]},[_c('td',[_vm._v("Pasajes afectados")]),_c('td',[_vm._v(_vm._s(_vm.complaint.ticket_info.tickets.join(', ')))])]),_c('tr',[_c('td',[_vm._v("Empresa(s)")]),_c('td',[_vm._v(_vm._s(_vm._f("formatOperator")(_vm.complaint.ticket_info.bus_operators)))])]),_c('tr',[_c('td',[_vm._v("Fecha de salida (Ida)")]),_c('td',[_vm._v(_vm._s(_vm._f("formatDate")(_vm.complaint.ticket_info.departure)))])]),_c('tr',[_c('td',[_vm._v("Hora de salida (Ida)")]),_c('td',[_vm._v(_vm._s(_vm._f("formatHour")(_vm.complaint.ticket_info.departure)))])]),(_vm.complaint.ticket_info.arrival)?_c('tr',[_c('td',[_vm._v("Fecha de salida (Vuelta)")]),_c('td',[_vm._v(_vm._s(_vm._f("formatDate")(_vm.complaint.ticket_info.arrival)))])]):_vm._e(),(_vm.complaint.ticket_info.arrival)?_c('tr',[_c('td',[_vm._v("Hora de salida (Vuelta)")]),_c('td',[_vm._v(_vm._s(_vm._f("formatHour")(_vm.complaint.ticket_info.arrival)))])]):_vm._e(),_c('tr',[_c('td',[_vm._v("Método de pago")]),_c('td',[_vm._v(_vm._s(_vm.complaint.ticket_info.payment_method))])]),_c('tr',[_c('td',[_vm._v("Precio")]),_c('td',[_vm._v(_vm._s(_vm.complaint.ticket_info.price)+" "+_vm._s(_vm.complaint.ticket_info.sold_currency))])])]):_vm._e()]),(this.complaint.additional_infos.length > 0)?_c('b-tab',{attrs:{"id":"tab-information-request","title":"Solicitudes de información"}},[_c('b-list-group',[_c('input',{attrs:{"id":"requestFile","type":"file","hidden":"hidden"},on:{"change":function($event){_vm.uploadFile()}}}),_c('hr'),_vm._l((this.complaint.additional_infos),function(r){return _c('b-list-group-item',{key:r.name},[_c('icon',{attrs:{"name":"inbox"}}),_c('span',{domProps:{"innerHTML":_vm._s(r.request)}}),(r.url === null)?_c('b-button',{staticClass:"float-right",attrs:{"variant":"primary"},on:{"click":function($event){_vm.addFile(r._id.$oid)}}},[_c('icon',{attrs:{"name":"paperclip"}}),_vm._v(" Adjuntar")],1):_vm._e(),(r.url !== null)?_c('a',{staticClass:"float-right",attrs:{"href":r.url}},[_vm._v(_vm._s(((r.name) + "." + (r.format))))]):_vm._e()],1)})],2)],1):_vm._e()],1),(_vm.wizard_status !== 'resolved' && !([3, 6, 7, 9].includes(_vm.complaint.category)))?_c('div',{staticClass:"disclaimer"},[_c('p',[_vm._v(_vm._s(_vm.$t('status.disclaimer.advise')))]),_c('p',[_vm._v(_vm._s(_vm.$t('status.disclaimer.contact')))])]):_vm._e()],1)],1):_c('icon',{staticClass:"loading-section",attrs:{"name":"spinner","scale":"5","pulse":"pulse"}}),_c('b-modal',{ref:"paypalModal",attrs:{"size":"lg","hide-header":"hide-header","hide-footer":"hide-footer","no-close-on-backdrop":"no-close-on-backdrop"}},[_c('div',{staticClass:"modal-body"},[_c('p',{staticClass:"text-center cancellation-modal-success-icon"},[_c('icon',{attrs:{"name":"check","scale":"5"}})],1),_c('p',{staticClass:"text-center"},[_vm._v("Hemos recibido su cuenta PayPal exitosamente. Por favor revise su correo electrónico.")]),_c('br'),_c('br'),_c('p',{staticClass:"text-center"},[_c('b-button',{staticClass:"btn btn-recorrido",on:{"click":_vm.closeModal}},[_vm._v("Cerrar")])],1)])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "MlcB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Momf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ReloadAppDialog',{attrs:{"showDialog":_vm.showDialog}}),_c('b-row',{staticClass:"mb-12"},[_c('b-col',{staticClass:"mb-12"},[_c('div',[_c('b-alert',{attrs:{"variant":"success","dismissible":"dismissible","show":_vm.sendedMailAlert},on:{"dismiss-count-down":_vm.countDownChanged}},[_vm._v("Se enviará un mail junto con el archivo csv")])],1)])],1),_c('b-row',{staticClass:"mb-2"},[_c('b-col',{attrs:{"md":"1"}},[_c('b-btn',{attrs:{"variant":"primary","size":"sm"},on:{"click":_vm.exportData}},[_c('icon',{attrs:{"name":"download"}}),_vm._v(" Exportar tabla")],1)],1),_c('b-col',{attrs:{"md":"2"}},[_c('b-btn',{attrs:{"disabled":_vm.sendedMailAlert != 0,"variant":"success","size":"sm"},on:{"click":_vm.exportBackup}},[_c('icon',{attrs:{"name":"download"}}),_vm._v(" Descargar todos")],1)],1)],1),_c('b-row',{staticClass:"mb-2"},[_c('b-col',{attrs:{"md":"4"}},[_c('span',{staticClass:"button-group"},[_c('b-btn',{staticClass:"btn-space",attrs:{"size":"sm"},on:{"click":function($event){_vm.searchByState('Pendiente decisión - Departamento ERR')}}},[_vm._v("Pendientes ERR")]),_c('b-btn',{staticClass:"btn-space",attrs:{"size":"sm"},on:{"click":function($event){_vm.searchByState('Resuelto')}}},[_vm._v("Resueltos")]),_c('b-btn',{staticClass:"btn-space",attrs:{"size":"sm"},on:{"click":function($event){_vm.searchByState('Rechazado')}}},[_vm._v("Rechazados")])],1)])],1),_c('b-row',{staticClass:"justify-content-md-center"},[_c('b-col',{attrs:{"md":"12"}},[_c('ag-grid-vue',{staticClass:"ag-theme-balham",staticStyle:{"width":"100%","height":"700px"},attrs:{"columnDefs":_vm.columnDefs,"rowData":_vm.rowData,"gridOptions":_vm.gridOptions}})],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_kindergarten__ = __webpack_require__("Ar/W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_kindergarten___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_kindergarten__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_notification__ = __webpack_require__("CLX7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_notification___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_notification__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_bootstrap_vue__ = __webpack_require__("e6fC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_clipboard2__ = __webpack_require__("wvfG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_clipboard2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_clipboard2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_analytics__ = __webpack_require__("AYPi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_analytics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_analytics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_awesome_components_Icon__ = __webpack_require__("D4uH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_i18n__ = __webpack_require__("TXmL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vee_validate_dist_locale_es__ = __webpack_require__("On01");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vee_validate_dist_locale_es___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vee_validate_dist_locale_es__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vee_validate__ = __webpack_require__("sUu7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue2_filters__ = __webpack_require__("OjAt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue2_filters___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vue2_filters__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vuejs_dialog__ = __webpack_require__("7VfX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vuejs_dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vuejs_dialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_dni__ = __webpack_require__("Eayd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_dni___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_vue_dni__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_awesome_icons__ = __webpack_require__("D/PP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_bootstrap_scss_bootstrap_scss__ = __webpack_require__("SSNS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_bootstrap_scss_bootstrap_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_bootstrap_scss_bootstrap_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_bootstrap_vue_dist_bootstrap_vue_css__ = __webpack_require__("9M+g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_bootstrap_vue_dist_bootstrap_vue_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_bootstrap_vue_dist_bootstrap_vue_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_ag_grid_community_dist_styles_ag_grid_css__ = __webpack_require__("z4t4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_ag_grid_community_dist_styles_ag_grid_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_ag_grid_community_dist_styles_ag_grid_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_ag_grid_community_dist_styles_ag_theme_balham_css__ = __webpack_require__("p9NS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_ag_grid_community_dist_styles_ag_theme_balham_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_ag_grid_community_dist_styles_ag_theme_balham_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__assets_css_kexa_styles_scss__ = __webpack_require__("aA+L");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__assets_css_kexa_styles_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__assets_css_kexa_styles_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__filters_filters__ = __webpack_require__("V1NV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__child__ = __webpack_require__("55sj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__locals_es_CL_json__ = __webpack_require__("d4Ct");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__locals_es_CL_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__locals_es_CL_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__locals_es_PE_json__ = __webpack_require__("9eaa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__locals_es_PE_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__locals_es_PE_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__locals_es_MX_json__ = __webpack_require__("/N/F");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__locals_es_MX_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__locals_es_MX_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_ReloadAppDialog__ = __webpack_require__("/ZFF");
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.





























__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_kindergarten___default.a, {
  child: __WEBPACK_IMPORTED_MODULE_23__child__["a" /* default */]
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_7_vue_i18n__["a" /* default */]);

var i18n = new __WEBPACK_IMPORTED_MODULE_7_vue_i18n__["a" /* default */]({
  messages: {
    es_PE: __WEBPACK_IMPORTED_MODULE_25__locals_es_PE_json___default.a,
    es_CL: __WEBPACK_IMPORTED_MODULE_24__locals_es_CL_json___default.a,
    es_MX: __WEBPACK_IMPORTED_MODULE_26__locals_es_MX_json___default.a
  }
});

switch (location.host.split('.').pop()) {
  case 'pe':
    i18n.locale = 'es_PE';
    break;
  case 'mx':
    i18n.locale = 'es_MX';
    break;
  default:
    i18n.locale = 'es_CL';
    break;
}

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_9_vee_validate__["a" /* default */], {
  fieldsBagName: 'veeFields',
  i18nRootKey: 'validations',
  i18n: i18n,
  dictionary: {
    es_CL: __WEBPACK_IMPORTED_MODULE_8_vee_validate_dist_locale_es___default.a,
    es_PE: __WEBPACK_IMPORTED_MODULE_8_vee_validate_dist_locale_es___default.a
  }
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_bootstrap_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue_notification___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_vue_clipboard2___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_10_vue2_filters___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_11_vuejs_dialog___default.a, {
  okText: 'Continuar',
  cancelText: 'Cancelar'
});
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('icon', __WEBPACK_IMPORTED_MODULE_6_vue_awesome_components_Icon__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('rutFilter', __WEBPACK_IMPORTED_MODULE_12_vue_dni__["rutFilter"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].directive('rut', __WEBPACK_IMPORTED_MODULE_12_vue_dni__["rutInputDirective"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_vue_analytics___default.a, {
  id: 'UA-48735171-18'
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_20__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_19__App__["a" /* default */] },
  store: __WEBPACK_IMPORTED_MODULE_21__store__["a" /* default */],
  i18n: i18n
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('ReloadAppDialog', __WEBPACK_IMPORTED_MODULE_27__components_ReloadAppDialog__["a" /* default */]);

/***/ }),

/***/ "NTCI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('v-header'),_vm._v(" "),_c('b-container',{attrs:{"fluid":""}},[_c('router-view')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "NiGY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue2_selectize__ = __webpack_require__("py5U");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue2_selectize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue2_selectize__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_input_tag__ = __webpack_require__("28+M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_input_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_input_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_apiService__ = __webpack_require__("a/3G");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants_Status_constants__ = __webpack_require__("XXAu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_dateService__ = __webpack_require__("4F1w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vee_validate__ = __webpack_require__("sUu7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_dni__ = __webpack_require__("Eayd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_dni___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_dni__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_ui_TemplateModalEditor__ = __webpack_require__("lgUc");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'new',
  components: {
    Selectize: __WEBPACK_IMPORTED_MODULE_0_vue2_selectize___default.a,
    InputTag: __WEBPACK_IMPORTED_MODULE_1_vue_input_tag___default.a,
    TemplateModalEditor: __WEBPACK_IMPORTED_MODULE_8__components_ui_TemplateModalEditor__["a" /* default */]
  },
  computed: {
    ticketResponseClass: function ticketResponseClass() {
      var theClass = void 0;

      if (this.getTicketsError) {
        theClass = 'has-error';
      } else if (!this.getTicketsError && this.booking_tickets.length > 0) {
        theClass = 'tickets-found';
      }
      return theClass;
    }
  },
  data: function data() {
    return {
      loader: false,
      getTicketsLoader: false,
      getTicketsError: false,
      bank_info: {},
      complaint: {
        fast_track: true,
        category: -1,
        comment: '',
        description: '',
        zendesk: [],
        status: 0,
        ticket_info: {
          tickets: [],
          bus_operators: []
        }
      },
      template_selected: '',
      template_selected_option: '',
      templateModalOpen: false,
      templateModalText: '',
      booking_tickets: [],
      selected: [],
      statuses: __WEBPACK_IMPORTED_MODULE_4__constants_Status_constants__["a" /* default */].STATUSES,
      banks: __WEBPACK_IMPORTED_MODULE_4__constants_Status_constants__["a" /* default */].BANKS,
      accounts: __WEBPACK_IMPORTED_MODULE_4__constants_Status_constants__["a" /* default */].ACCOUNTS,
      comment_templates: __WEBPACK_IMPORTED_MODULE_4__constants_Status_constants__["a" /* default */].COMMENT_TEMPLATES,
      first_ticket: null,
      intervalId: null,
      showDialog: false
    };
  },
  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_6_vee_validate__["b" /* Validator */].extend('rut', __WEBPACK_IMPORTED_MODULE_7_vue_dni__["rutValidator"]);
    if (Object.prototype.hasOwnProperty.call(this.$route.query, 'zendesk')) {
      this.$set(this.complaint, 'zendesk', [this.$route.query.zendesk]);
      this.fetchData();
    }
    if (Object.prototype.hasOwnProperty.call(this.$route.query, 'booking')) {
      this.$set(this.complaint.ticket_info, 'booking_number', this.$route.query.booking);
      this.getTickets();
    }
    if (Object.prototype.hasOwnProperty.call(this.$route.query, 'category')) {
      this.$set(this.complaint, 'category', this.$route.query.category);
    }
    this.refreshReloaAppStatus();
  },

  watch: {
    selected: function selected() {
      var _this = this;

      var info = this.complaint.ticket_info;
      info.tickets = this.selected;
      var filtered = this.booking_tickets.filter(function (ticket) {
        return _this.selected.includes(ticket.number);
      });
      var dep = filtered[0];
      var arr = filtered[filtered.length - 1];
      info.departure_date = dep.departure_date;
      info.departure_hour = dep.departure_hour;
      info.departure = dep.departs_at;
      if (filtered.length > 1 && dep.inbound !== arr.inbound && arr.inbound) {
        info.arrival_date = arr.departure_date;
        info.arrival_hour = arr.departure_hour;
        info.arrival = arr.departs_at;
      } else {
        info.arrival_date = null;
        info.arrival_hour = null;
        info.arrival = null;
      }
      info.payment_method = filtered[0].payment_method;
      info.email = filtered[0].email;
      info.fullname = filtered[0].fullname;
      info.price = filtered.reduce(function (total, ticket) {
        return total + parseInt(ticket.price, 10);
      }, 0);
      info.price_usd = filtered.reduce(function (total, ticket) {
        return total + parseFloat(ticket.price_usd, 10);
      }, 0);
      info.original_price = filtered.reduce(function (total, ticket) {
        return total + parseInt(ticket.original_price, 10);
      }, 0);
      info.payment_method = filtered[0].payment_method;
      info.paypal_transaction = filtered[0].paypal_transaction;
      info.sold_currency = filtered[0].sold_currency;
      info.operator_currency = filtered[0].operator_currency;
      info.sales_company = filtered[0].sales_company;
      info.is_whitelabel = filtered[0].is_whitelabel;
      info.ticket_ids = filtered.map(function (ticket) {
        return ticket.id;
      });
      info.bus_operators = filtered.map(function (ticket) {
        if (ticket.id === dep.id) {
          return dep.bus_operator;
        } else if (ticket.id === arr.id) {
          return arr.bus_operator;
        }
        return ticket.bus_operator;
      }).filter(function (val, i, self) {
        return self.indexOf(val) === i;
      });
    }
  },
  methods: {
    create: function create() {
      var $this = this;
      if (!this.complaint.comment) {
        this.$notify({
          group: 'request',
          type: 'warning',
          title: 'Advertencia',
          text: 'Debe llenar una plantilla',
          duration: 3000
        });
        return;
      }
      if (this.template_selected) {
        this.complaint.comment = this.template_selected;
      }
      $this.saveComplaint();
    },
    setTemplateSelected: function setTemplateSelected(event) {
      if (!event) {
        this.template_selected = '';
        this.templateModalText = '';
        return;
      }
      var ticketInfo = this.complaint && this.complaint.ticket_info || {};
      var busOperators = Array.isArray(ticketInfo.bus_operators) ? ticketInfo.bus_operators : [];
      var genderRaw = this.complaint && this.complaint.issuer_gender || '';
      var genderNormalized = String(genderRaw).toLowerCase();
      var genderText = '';
      if (['mujer', 'female', 'f'].includes(genderNormalized)) {
        genderText = 'La';
      } else if (['hombre', 'male', 'm'].includes(genderNormalized)) {
        genderText = 'Lo';
      }
      var replaceOrKeep = function replaceOrKeep(value, token) {
        return value || token;
      };
      var templateText = String(event).replace(/\[date\]/g, replaceOrKeep(ticketInfo.departure_date, '[date]')).replace(/\[hour\]/g, replaceOrKeep(ticketInfo.departure_hour, '[hour]')).replace(/\[bus_operator\]/g, replaceOrKeep(busOperators[0], '[bus_operator]')).replace(/\[gender\]/g, replaceOrKeep(genderText, '[gender]'));
      this.templateModalText = templateText;
      this.templateModalOpen = true;
    },
    handleTemplateModalClose: function handleTemplateModalClose(text) {
      this.templateModalOpen = false;
      this.template_selected = text;
      if (text) {
        this.complaint.comment = text;
      }
    },
    handleTemplateModalCancel: function handleTemplateModalCancel() {
      this.templateModalOpen = false;
    },
    saveComplaint: function saveComplaint() {
      var $this = this;
      __WEBPACK_IMPORTED_MODULE_3__services_apiService__["a" /* default */].post(this.complaint).then(function () {
        __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push('/complaints');
      }).catch(function (res) {
        $this.$notify({
          group: 'request',
          type: 'error',
          title: 'Error',
          text: res.body,
          duration: 3000
        });
      });
    },
    fetchData: function fetchData() {
      var _this2 = this;

      var ticket = this.complaint.zendesk[0];
      if (ticket === undefined) {
        this.$set(this.complaint, 'first_contact', null);
        this.$set(this.complaint, 'last_contact', null);
        this.$set(this.complaint, 'issuer_contact', null);
        this.$set(this.complaint, 'issuer_name', null);
        this.$set(this.complaint, 'source', null);
        this.$set(this.complaint, 'description', null);
        this.first_ticket = null;
      } else if (this.first_ticket !== ticket) {
        this.loader = true;
        __WEBPACK_IMPORTED_MODULE_3__services_apiService__["a" /* default */].zendeskInfo(this.complaint.zendesk[0]).then(function (res) {
          _this2.loader = false;
          var t = res.body.ticket;
          var created = __WEBPACK_IMPORTED_MODULE_5__utils_dateService__["a" /* default */].getDate(t.created_at);
          var updated = __WEBPACK_IMPORTED_MODULE_5__utils_dateService__["a" /* default */].getDate(t.updated_at);
          _this2.$set(_this2.complaint, 'first_contact', created);
          _this2.$set(_this2.complaint, 'last_contact', updated);
          _this2.$set(_this2.complaint, 'issuer_contact', _this2.getIssuerData(t.via));
          _this2.$set(_this2.complaint, 'issuer_name', t.via.source.from.name);
          _this2.$set(_this2.complaint, 'source', t.via.channel);
          _this2.$set(_this2.complaint, 'description', t.description);
          _this2.first_ticket = _this2.complaint.zendesk[0];
        }).catch(function () {
          _this2.$notify({
            group: 'request',
            type: 'error',
            title: 'Error',
            text: 'Ocurrió un error con ese ticket de Zendesk.',
            duration: 3000
          });
        });
      }
    },
    getTickets: function getTickets() {
      var _this3 = this;

      this.getTicketsLoader = true;
      this.getTicketsError = false;
      __WEBPACK_IMPORTED_MODULE_3__services_apiService__["a" /* default */].ticketInfo(this.complaint.ticket_info.booking_number, '', 'pre_approved').then(function (res) {
        console.log('Response from KexaApi');
        console.log(res);
        _this3.getTicketsLoader = false;
        _this3.$set(_this3, 'booking_tickets', res.body.data);
        if (res.body.data.length !== 0) {
          _this3.$set(_this3.complaint.ticket_info, 'booking_number', res.body.data[0].token);
        }

        var invalidTickets = res.body.invalid_tickets;

        if (invalidTickets.length > 0) {
          _this3.$notify({
            group: 'request',
            type: 'warning',
            title: 'Advertencia',
            text: 'Los tickets con n\xFAmero: ' + invalidTickets + ' incumplen una de las siguientes condiciones:' + '<br>- Tiene categoría Transbank error y más de 90 días a partir de la fecha de salida' + '<br>- Tiene categoría Reclamo cupón y más de los 6 meses del periodo de validez' + '<br>- Tienen otra categoría y más de 30 días a partir de la fecha de salida',
            duration: 8000
          });
        }
      }).catch(function (e) {
        console.log('An error was found');
        console.log(e);
        _this3.getTicketsError = true;
        _this3.$notify({
          group: 'request',
          type: 'error',
          title: 'Error',
          text: 'Número de compra no encontrado',
          duration: 3000
        });
      });
    },
    formatOperator: function formatOperator(value) {
      return value.length === 2 ? value[0] + ' (Ida) ' + value[1] + ' (Vuelta)' : '' + value[0];
    },
    getIssuerData: function getIssuerData(src) {
      if (src.channel === 'email') {
        return src.source.from.address;
      }
      if (src.channel === 'facebook') {
        return src.source.from.profile_url;
      }
      return src.source.from.phone;
    },
    refreshReloaAppStatus: function refreshReloaAppStatus() {
      var _this4 = this;

      this.intervalId = setInterval(function () {
        __WEBPACK_IMPORTED_MODULE_3__services_apiService__["a" /* default */].reloadAppStatus().then(function (response) {
          if (response.body) {
            _this4.showDialog = true;
          }
        });
      }, 900000);
    }
  },
  beforeDestroy: function beforeDestroy() {
    clearInterval(this.intervalId);
  }
});

/***/ }),

/***/ "O0rK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-row',[_c('ReloadAppDialog',{attrs:{"showDialog":_vm.showDialog}}),_c('b-col',{attrs:{"md":"1","offset-md":"1"}},[(_vm.$isAllowed('createOperator'))?_c('b-btn',{attrs:{"variant":"primary"},on:{"click":_vm.createOperator}},[_vm._v("Nuevo")]):_vm._e()],1),_c('b-col',{attrs:{"md":"4","offset-md":"5"}},[_c('b-form-input',{attrs:{"type":"text","placeholder":"Filtrar"},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}})],1)],1),_c('b-row',{staticClass:"justify-content-md-center"},[_c('b-col',{attrs:{"md":"10"}},[_c('b-table',{attrs:{"hover":"hover","fields":_vm.operatorFields,"items":_vm.filteredOperators},on:{"row-clicked":_vm.loadOperator}})],1),_c('b-modal',{staticClass:"operatorModal",attrs:{"busy":true,"size":"lg"},model:{value:(_vm.modalShow),callback:function ($$v) {_vm.modalShow=$$v},expression:"modalShow"}},[_c('b-form',{staticClass:"form-horizontal"},[_c('b-row',[_c('b-col',{attrs:{"md":"6"}},[_c('b-form-group',{attrs:{"label":"Nombre"}},[_c('b-form-input',{staticClass:"form-control",attrs:{"name":"operator[name]","type":"text"},model:{value:(_vm.operator.name),callback:function ($$v) {_vm.operator.name=$$v},expression:"operator.name"}})],1),_c('b-form-group',{attrs:{"label":"Correo electrónico"}},[_c('b-form-input',{staticClass:"form-control",attrs:{"name":"operator[email]","type":"email"},model:{value:(_vm.operator.email),callback:function ($$v) {_vm.operator.email=$$v},expression:"operator.email"}})],1),_c('b-form-group',{attrs:{"label":"Teléfono"}},[_c('b-form-input',{staticClass:"form-control",attrs:{"name":"operator[phone]","type":"text"},model:{value:(_vm.operator.phone),callback:function ($$v) {_vm.operator.phone=$$v},expression:"operator.phone"}})],1),_c('b-form-group',{attrs:{"label":"Contacto"}},[_c('b-form-input',{staticClass:"form-control",attrs:{"name":"operator[contact]","type":"text"},model:{value:(_vm.operator.contact),callback:function ($$v) {_vm.operator.contact=$$v},expression:"operator.contact"}})],1),_c('b-form-group',{attrs:{"label":"Remitente"}},[_c('selectize',{attrs:{"name":"operator[user_id]","placeholder":"Seleccione un remitente"},model:{value:(_vm.operator.user_id),callback:function ($$v) {_vm.operator.user_id=$$v},expression:"operator.user_id"}},_vm._l((_vm.err),function(user){return _c('option',{key:user.id,domProps:{"value":user.id}},[_vm._v(_vm._s(user.name))])}))],1),_c('b-form-group',[_c('b-form-checkbox',{attrs:{"value":"true"},model:{value:(_vm.operator.auto),callback:function ($$v) {_vm.operator.auto=$$v},expression:"operator.auto"}},[_vm._v("Enviar correo automáticamente")])],1),_c('b-form-group',[_c('b-form-checkbox',{attrs:{"value":"true"},model:{value:(_vm.operator.reminder),callback:function ($$v) {_vm.operator.reminder=$$v},expression:"operator.reminder"}},[_vm._v("Activar recordatorios")])],1),_c('b-form-group',{attrs:{"label":"Id BOB"}},[_c('b-form-input',{staticClass:"form-control",attrs:{"name":"operator[internal_id]","type":"text"},model:{value:(_vm.operator.internal_id),callback:function ($$v) {_vm.operator.internal_id=$$v},expression:"operator.internal_id"}})],1)],1),_c('b-col',{attrs:{"md":"6"}},[_c('b-form-group',{attrs:{"label":"Inicio notificación"}},[_c('vue-editor',{attrs:{"id":"operator-opening","editorToolbar":_vm.customToolbar},model:{value:(_vm.operator.opening),callback:function ($$v) {_vm.operator.opening=$$v},expression:"operator.opening"}})],1),_c('b-form-group',{attrs:{"label":"Fin notificación"}},[_c('vue-editor',{attrs:{"id":"operator-ending","editorToolbar":_vm.customToolbar},model:{value:(_vm.operator.ending),callback:function ($$v) {_vm.operator.ending=$$v},expression:"operator.ending"}})],1),_c('b-form-group',{attrs:{"label":"Inicio recordatorio"}},[_c('vue-editor',{attrs:{"id":"operator-opening-reminder","editorToolbar":_vm.customToolbar},model:{value:(_vm.operator.reminder_opening),callback:function ($$v) {_vm.operator.reminder_opening=$$v},expression:"operator.reminder_opening"}})],1),_c('b-form-group',{attrs:{"label":"Fin recordatorio"}},[_c('vue-editor',{attrs:{"id":"operator-ending-reminder","editorToolbar":_vm.customToolbar},model:{value:(_vm.operator.reminder_ending),callback:function ($$v) {_vm.operator.reminder_ending=$$v},expression:"operator.reminder_ending"}})],1)],1)],1)],1),_c('div',{attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('b-btn',{attrs:{"variant":"secondary"},on:{"click":_vm.closeModal}},[_vm._v("Cancelar")]),(_vm.action==='create')?_c('b-btn',{attrs:{"variant":"primary"},on:{"click":_vm.registerOperator}},[_vm._v("Registrar")]):_vm._e(),(_vm.action==='update')?_c('b-btn',{attrs:{"variant":"primary"},on:{"click":_vm.updateOperator}},[_vm._v("Actualizar")]):_vm._e()],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "OaZv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h1',[_vm._v("Logout")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "OmsM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ComplaintsEcommerce_vue__ = __webpack_require__("xAMB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_631e744c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_ComplaintsEcommerce_vue__ = __webpack_require__("0E/T");
function injectStyle (ssrContext) {
  __webpack_require__("Wi0o")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ComplaintsEcommerce_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_631e744c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_ComplaintsEcommerce_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "P31c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue2_selectize__ = __webpack_require__("py5U");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue2_selectize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue2_selectize__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_input_tag__ = __webpack_require__("28+M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_input_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_input_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jwt_decode__ = __webpack_require__("365x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_apiService__ = __webpack_require__("a/3G");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants_Integration_constants__ = __webpack_require__("J6kb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constants_Status_constants__ = __webpack_require__("XXAu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_dateService__ = __webpack_require__("4F1w");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable no-console */









/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'new',
  components: {
    Selectize: __WEBPACK_IMPORTED_MODULE_1_vue2_selectize___default.a,
    InputTag: __WEBPACK_IMPORTED_MODULE_2_vue_input_tag___default.a
  },
  computed: {
    ticketResponseClass: function ticketResponseClass() {
      var theClass = void 0;

      if (this.getTicketsError) {
        theClass = 'has-error';
      }
      return theClass;
    }
  },
  data: function data() {
    return {
      loader: false,
      getTicketsLoader: false,
      getTicketsError: false,
      complaint: {
        zendesk: [],
        status: 0,
        issuer_gender: 'male',
        ticket_info: {
          tickets: [],
          bus_operators: []
        },
        internal_source: {
          origin: '',
          responsible: ''
        }
      },
      booking_tickets: [],
      selected: [],
      statuses: __WEBPACK_IMPORTED_MODULE_7__constants_Status_constants__["a" /* default */].STATUSES,
      categories: [],
      first_ticket: null,
      description_placeholder: 'Ej: Devolución en cupón, camión nunca llegó',
      name_placeholder: 'Ej: Ernesto Alcazar',
      intervalId: null,
      showDialog: false
    };
  },
  mounted: function mounted() {
    this.fetchCategories();
    if (Object.prototype.hasOwnProperty.call(this.$route.query, 'zendesk')) {
      this.$set(this.complaint, 'zendesk', [this.$route.query.zendesk]);
      this.fetchData();
    }
    if (Object.prototype.hasOwnProperty.call(this.$route.query, 'booking')) {
      this.$set(this.complaint.ticket_info, 'booking_number', this.$route.query.booking);
      this.getTickets();
    }
    if (Object.prototype.hasOwnProperty.call(this.$route.query, 'category')) {
      this.$set(this.complaint, 'category', this.$route.query.category);
    }
    if (this.complaint.ticket_info.booking_number === undefined && this.complaint.zendesk.length === 0 && this.complaint.category === undefined && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.$route.query).length !== 0) {
      this.getBehatzaileData();
    }
    this.refreshReloaAppStatus();
  },
  beforeDestroy: function beforeDestroy() {
    clearInterval(this.intervalId);
  },

  watch: {
    selected: function selected() {
      var _this = this;

      if (this.selected.length === 0) {
        var booking = this.complaint.ticket_info.booking_number;
        this.complaint.ticket_info = {
          booking_number: booking,
          tickets: [],
          bus_operators: []
        };
      } else {
        var info = this.complaint.ticket_info;
        info.tickets = this.selected;
        var filtered = this.booking_tickets.filter(function (ticket) {
          return _this.selected.includes(ticket.number);
        });
        var dep = filtered[0];
        var arr = filtered[filtered.length - 1];
        info.departure_date = dep.departure_date;
        info.departure_hour = dep.departure_hour;
        info.origin = dep.departure;
        info.destination = dep.destination;
        info.departure = dep.departs_at;
        if (filtered.length > 1 && dep.inbound !== arr.inbound && arr.inbound) {
          info.arrival_date = arr.departure_date;
          info.arrival_hour = arr.departure_hour;
          info.arrival = arr.departs_at;
        } else {
          info.arrival_date = null;
          info.arrival_hour = null;
          info.arrival = null;
        }
        info.price = filtered.reduce(function (total, ticket) {
          return total + parseInt(ticket.price, 10);
        }, 0);
        info.price_ibc = filtered.reduce(function (total, ticket) {
          return total + parseInt(ticket.price_ibc, 10);
        }, 0);
        info.price_usd = filtered.reduce(function (total, ticket) {
          return total + parseFloat(ticket.price_usd, 10);
        }, 0);
        info.original_price = filtered.reduce(function (total, ticket) {
          return total + parseInt(ticket.original_price, 10);
        }, 0);
        info.payment_method = filtered[0].payment_method;
        info.paypal_transaction = filtered[0].paypal_transaction;
        info.sold_currency = filtered[0].sold_currency;
        info.operator_currency = filtered[0].operator_currency;
        info.sales_company = filtered[0].sales_company;
        info.is_whitelabel = filtered[0].is_whitelabel;
        info.ticket_ids = filtered.map(function (ticket) {
          return ticket.id;
        });
        if (filtered[0].email !== 'accounting@recorrido.cl') {
          info.email = filtered[0].email;
        }
        info.fullname = filtered[0].fullname;
        info.bus_operators = filtered.map(function (ticket) {
          if (ticket.id === dep.id) {
            return dep.bus_operator;
          } else if (ticket.id === arr.id) {
            return arr.bus_operator;
          }
          return ticket.bus_operator;
        }).filter(function (val, i, self) {
          return self.indexOf(val) === i;
        });
        info.discount_coupons = filtered[0].discount_coupons;
      }
    }
  },
  methods: {
    create: function create() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_5__services_apiService__["a" /* default */].post(this.complaint).then(function () {
        __WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */].push('/complaints');
      }).catch(function (res) {
        _this2.$notify({
          group: 'request',
          type: 'error',
          title: 'Error',
          text: res.body.join('<br>'),
          duration: 3000,
          dangerouslyUseHTMLString: true
        });
      });
    },
    fetchCategories: function fetchCategories() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_5__services_apiService__["a" /* default */].get_categories().then(function (res) {
        _this3.categories = res.body.reduce(function (acc, item) {
          acc[item.number] = { description: item.name };
          return acc;
        }, {});
      });
    },
    fetchData: function fetchData() {
      var _this4 = this;

      var ticket = this.complaint.zendesk[0];
      if (ticket === undefined) {
        this.$set(this.complaint, 'first_contact', null);
        this.$set(this.complaint, 'last_contact', null);
        this.$set(this.complaint, 'issuer_contact', null);
        this.$set(this.complaint, 'issuer_name', null);
        this.$set(this.complaint, 'source', null);
        this.$set(this.complaint, 'description', null);
        this.first_ticket = null;
      } else if (this.first_ticket !== ticket) {
        this.loader = true;
        __WEBPACK_IMPORTED_MODULE_5__services_apiService__["a" /* default */].zendeskInfo(this.complaint.zendesk[0]).then(function (res) {
          _this4.loader = false;
          var t = res.body.ticket;
          var created = __WEBPACK_IMPORTED_MODULE_8__utils_dateService__["a" /* default */].getDate(t.created_at);
          var updated = __WEBPACK_IMPORTED_MODULE_8__utils_dateService__["a" /* default */].getDate(t.updated_at);
          _this4.$set(_this4.complaint, 'first_contact', created);
          _this4.$set(_this4.complaint, 'last_contact', updated);
          _this4.$set(_this4.complaint, 'issuer_contact', _this4.getIssuerData(t.via) || '-');
          _this4.$set(_this4.complaint, 'issuer_name', t.via.source.from.name || '-');
          _this4.$set(_this4.complaint, 'source', t.via.channel);
          _this4.$set(_this4.complaint, 'description', t.description);
          _this4.first_ticket = _this4.complaint.zendesk[0];
        }).catch(function () {
          _this4.$notify({
            group: 'request',
            type: 'error',
            title: 'Error',
            text: 'Ocurrió un error con ese ticket de Zendesk.',
            duration: 3000
          });
        });
      }
    },
    getTickets: function getTickets() {
      var _this5 = this;

      this.getTicketsLoader = true;
      this.getTicketsError = false;
      __WEBPACK_IMPORTED_MODULE_5__services_apiService__["a" /* default */].ticketInfo(this.complaint.ticket_info.booking_number, this.complaint.category).then(function (res) {
        console.log('Response from KexaApi');
        console.log(res);
        _this5.getTicketsLoader = false;
        _this5.$set(_this5, 'booking_tickets', res.body.data);

        if (res.body.data.length !== 0) {
          _this5.$set(_this5.complaint.ticket_info, 'booking_number', res.body.data[0].token);
        }
        var invalidTickets = res.body.invalid_tickets;

        if (invalidTickets.length > 0) {
          _this5.$notify({
            group: 'request',
            type: 'warning',
            title: 'Advertencia',
            text: 'No se consideraron los tickets con n\xFAmero: ' + invalidTickets + ', debido a alguna de estas razones:' + '<br>- Tiene categoría Transbank error y más de 90 días a partir de la fecha de salida' + '<br>- Tiene categoría Reclamo cupón y más de los 6 meses del periodo de validez' + '<br>- Tienen otra categoría y más de 30 días a partir de la fecha de salida',
            duration: 8000
          });
        }
      }).catch(function (e) {
        console.log('An error was found');
        console.log(e);
        _this5.getTicketsError = true;
        _this5.$notify({
          group: 'request',
          type: 'error',
          title: 'Error',
          text: 'Número de compra no encontrado',
          duration: 3000
        });
      });
    },
    formatOperator: function formatOperator(value) {
      return value.length === 2 ? value[0] + ' (Ida) ' + value[1] + ' (Vuelta)' : '' + value[0];
    },
    getIssuerData: function getIssuerData(src) {
      if (src.channel === 'email') {
        return src.source.from.address;
      }
      if (src.channel === 'facebook') {
        return src.source.from.profile_url;
      }
      return src.source.from.phone;
    },
    getBehatzaileData: function getBehatzaileData() {
      try {
        var data = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_jwt_decode__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.$route.query)[0]);
        if (data && data.origin === __WEBPACK_IMPORTED_MODULE_6__constants_Integration_constants__["a" /* default */].BEHATZAILE_TOKEN) {
          // TODO: move to vite env in a future vue update
          this.$set(this.complaint.ticket_info, 'booking_number', data.booking);
          this.$set(this.complaint.internal_source, 'origin', 'behatzaile');
          this.$set(this.complaint.internal_source, 'responsible', data.user);
          this.getTickets();
        } else {
          throw new Error();
        }
      } catch (e) {
        this.$notify({
          group: 'request',
          type: 'error',
          title: 'Error',
          text: 'El ingreso de reclamo no coincide. <br/> Genere el reclamo desde un link válido.',
          duration: 5000
        });
        setTimeout(function () {
          return __WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */].push({ name: 'complaints' });
        }, 5000);
      }
    },
    onSearchChange: function onSearchChange() {
      this.booking_tickets = [];
      this.selected = [];
      this.complaint.ticket_info = {
        booking_number: this.complaint.ticket_info.booking_number,
        tickets: [],
        bus_operators: []
      };
    },
    refreshReloaAppStatus: function refreshReloaAppStatus() {
      var _this6 = this;

      this.intervalId = setInterval(function () {
        __WEBPACK_IMPORTED_MODULE_5__services_apiService__["a" /* default */].reloadAppStatus().then(function (response) {
          if (response.body) {
            _this6.showDialog = true;
          }
        });
      }, 900000);
    }
  }
});

/***/ }),

/***/ "PCMc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Categories_vue__ = __webpack_require__("E7HZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0dde5dfa_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Categories_vue__ = __webpack_require__("vvws");
function injectStyle (ssrContext) {
  __webpack_require__("aEBH")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Categories_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0dde5dfa_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Categories_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "PT+o":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "PWjZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PasswordCreation_vue__ = __webpack_require__("wfGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0a142eb5_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_PasswordCreation_vue__ = __webpack_require__("8WzD");
function injectStyle (ssrContext) {
  __webpack_require__("Jd5C")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PasswordCreation_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0a142eb5_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_PasswordCreation_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Pn1R":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCA0MCA0MCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48dGl0bGU+U2xpY2UgMTwvdGl0bGU+PGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj48cGF0aCBkPSJNNDAgMjBjMCAxMS05IDIwLTIwIDIwUzAgMzEgMCAyMCA5IDAgMjAgMHMyMCA5IDIwIDIweiIgZmlsbD0iI0Q3NUE0QSIvPjxwYXRoIGQ9Ik0xMi44IDI3LjJsMTQuNC0xNC40bS0xNC40IDBsMTQuNCAxNC40IiBzdHJva2U9IiNGRkYiIHN0cm9rZS13aWR0aD0iMS42Ii8+PC9nPjwvc3ZnPg=="

/***/ }),

/***/ "Q8mS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Qh7t":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__basePerimeter__ = __webpack_require__("G0wa");



var infoWhitelist = ['pending_err', 'pending_requested', 'edb_accepted', 'edb_rejected', 'pending_edb', 'edb_request'];
var ERRWhitelist = ['pending_err', 'pending_requested', 'edb_accepted', 'edb_rejected', 'pending_edb'];

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1__basePerimeter__["a" /* default */]({
  purpose: 'actions',
  govern: {
    'can viewAdmin': function viewAdmin() {
      return this.isAdmin();
    },
    'can viewCRM': function viewCRM() {
      return this.isCRM();
    },
    'can viewERR': function viewERR() {
      return this.isERR() || this.isFDP();
    },
    'can viewFDP': function viewFDP() {
      return this.isFDP();
    },
    'can makeInfoRequest': function makeInfoRequest() {
      var currentState = __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].getters.selected.aasm_state;
      var currentCategory = __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].getters.selected.category;
      return (this.isERR() || this.isFDP()) && infoWhitelist.includes(currentState) && currentCategory !== -1;
    },
    'can approveReimbursement': function approveReimbursement() {
      var currentState = __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].getters.selected.aasm_state;
      return (this.isERR() || this.isFDP()) && ERRWhitelist.includes(currentState);
    },
    'can closeComplaint': function closeComplaint() {
      var currentState = __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].getters.selected.aasm_state;
      return (this.isERR() || this.isFDP()) && ERRWhitelist.includes(currentState);
    },
    'can rejectComplaint': function rejectComplaint() {
      var currentState = __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].getters.selected.aasm_state;
      return (this.isERR() || this.isFDP()) && ERRWhitelist.includes(currentState);
    },
    'can sendToEDB': function sendToEDB() {
      return this.isERR() && ['pending_err'].includes(__WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].getters.selected.aasm_state) && __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].getters.selected.category !== -1;
    },
    'can requestInfo': function requestInfo() {
      return this.isCRM() && __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].getters.selected.aasm_state === 'pending_info';
    },
    'can notifyApproval': function notifyApproval() {
      return this.isCRM() && ['approved_communication'].includes(__WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].getters.selected.aasm_state);
    },
    'can notifyRejection': function notifyRejection() {
      return this.isCRM() && ['rejected_communication'].includes(__WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].getters.selected.aasm_state);
    },
    'can resendERR': function resendERR() {
      return this.isCRM() && ['pending_requested'].includes(__WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].getters.selected.aasm_state);
    },
    'can reimburse': function reimburse() {
      return this.isFDP() && __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].getters.selected.aasm_state === 'approved_reimbursement';
    },
    'can deleteAttachment': function deleteAttachment() {
      return this.isERR() || this.isAdmin();
    },
    'can viewAll': function viewAll() {
      return this.isERR();
    }
  },
  getActivityAction: function getActivityAction() {
    return this.isERR() ? 'complaint_err_request' : 'complaint_crm_request';
  },

  expose: ['getActivityAction']
}));

/***/ }),

/***/ "SP86":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants_Status_constants__ = __webpack_require__("XXAu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue2_selectize__ = __webpack_require__("py5U");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue2_selectize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue2_selectize__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_apiService__ = __webpack_require__("a/3G");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vee_validate__ = __webpack_require__("sUu7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_dni__ = __webpack_require__("Eayd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_dni___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_dni__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue2_datepicker__ = __webpack_require__("VrvJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue2_datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue2_datepicker__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ShowBankAccountForm',
  props: {
    complaint: {}
  },
  data: function data() {
    return {
      banks: __WEBPACK_IMPORTED_MODULE_0__constants_Status_constants__["a" /* default */].BANKS,
      documents: __WEBPACK_IMPORTED_MODULE_0__constants_Status_constants__["a" /* default */].DOCUMENTS,
      accounts: []
    };
  },
  beforeMount: function beforeMount() {
    __WEBPACK_IMPORTED_MODULE_3_vee_validate__["b" /* Validator */].extend('rut', __WEBPACK_IMPORTED_MODULE_4_vue_dni__["rutValidator"]);
    if (this.complaint.country === 'PE') {
      if (this.complaint.bank_account === null) {
        this.complaint.bank_account = {};
      }
      var options = __WEBPACK_IMPORTED_MODULE_0__constants_Status_constants__["a" /* default */].ACCOUNTS;
      options = options.filter(function (word) {
        return word.code !== 0;
      });
      this.accounts = options;
    } else if (this.complaint.country === 'CL' && this.complaint.bank_account.bank !== undefined) {
      this.account_types(this.complaint.bank_account.bank);
    }
  },

  components: {
    Selectize: __WEBPACK_IMPORTED_MODULE_1_vue2_selectize___default.a,
    DatePicker: __WEBPACK_IMPORTED_MODULE_5_vue2_datepicker___default.a
  },
  computed: {
    bank_button: function bank_button() {
      return this.complaint.bank_account.name === undefined ? 'Ingresar' : 'Actualizar';
    },
    isApprovedPayrollPaypal: function isApprovedPayrollPaypal() {
      return this.complaint.refund_method === 'payroll_paypal' && this.complaint.aasm_state === 'approved_reimbursement';
    }
  },
  methods: {
    account_types: function account_types(event) {
      this.accounts = null;
      var options = __WEBPACK_IMPORTED_MODULE_0__constants_Status_constants__["a" /* default */].ACCOUNTS;
      if (['COOPEUCH', 'BANCO ITAU'].includes(event)) {
        options = options.filter(function (word) {
          return word.code !== 2;
        });
      }
      this.accounts = options;
    },
    updateBank: function updateBank() {
      var _this = this;

      var $this = this;
      this.$validator.validateAll().then(function (valid) {
        if (valid) {
          var data = { bank_account: $this.complaint.bank_account };
          if ($this.complaint.refund_method === 'payroll_paypal') {
            data.paypal_email = $this.complaint.reimbursement.paypal_email;
          }

          __WEBPACK_IMPORTED_MODULE_2__services_apiService__["a" /* default */].status_bank($this.$route.params.complaint_id, data).then(function () {
            _this.$emit('fetchComplaint');
            $this.$root.$emit('bv::hide::modal', 'editBankData');
          }).catch(function () {
            $this.$notify({
              group: 'show_complaint',
              type: 'error',
              title: 'Error',
              text: 'Se encontraron errores en el formulario',
              duration: 3000
            });
          });
        }
      });
    }
  }
});

/***/ }),

/***/ "SSNS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "SUb6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Actions_vue__ = __webpack_require__("ptzr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2c96bc57_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Actions_vue__ = __webpack_require__("q1Qf");
function injectStyle (ssrContext) {
  __webpack_require__("H64N")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Actions_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2c96bc57_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Actions_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "TKn+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Users_vue__ = __webpack_require__("dxC/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3e2f61f6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Users_vue__ = __webpack_require__("97At");
function injectStyle (ssrContext) {
  __webpack_require__("BYbG")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Users_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3e2f61f6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Users_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "TQg0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "V1NV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_Status_constants__ = __webpack_require__("XXAu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_dateService__ = __webpack_require__("4F1w");




__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('formatDate', function (value) {
  return __WEBPACK_IMPORTED_MODULE_2__utils_dateService__["a" /* default */].getDate(value);
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('formatFullDate', function (value) {
  return __WEBPACK_IMPORTED_MODULE_2__utils_dateService__["a" /* default */].getDate(value, 'DD/MM/YYYY - HH:mm');
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('formatCommentDate', function (value) {
  return __WEBPACK_IMPORTED_MODULE_2__utils_dateService__["a" /* default */].getDate(value, 'dddd D, MMMM - HH:mm a');
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('formatHour', function (value) {
  return __WEBPACK_IMPORTED_MODULE_2__utils_dateService__["a" /* default */].getDate(value, 'HH:mm');
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('truncateDescription', function (text) {
  var longestLength = 200;
  if (text.length > longestLength) {
    return text.slice(0, longestLength) + '...';
  }
  return text;
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('formatAction', function (value) {
  var out = value === undefined ? null : __WEBPACK_IMPORTED_MODULE_1__constants_Status_constants__["a" /* default */].ACTIONS[value].description;
  return out;
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('formatStatus', function (value) {
  var out = value === undefined ? null : __WEBPACK_IMPORTED_MODULE_1__constants_Status_constants__["a" /* default */].STATUSES[value].description;
  return out;
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('formatStatusEcommerce', function (value) {
  var out = value === undefined ? null : __WEBPACK_IMPORTED_MODULE_1__constants_Status_constants__["a" /* default */].STATUSES_ECOMMERCE[value].description;
  return out;
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('formatOperator', function (value) {
  var val = value.length === 2 ? value[0] + ' (Ida) ' + value[1] + ' (Vuelta)' : '' + value[0];
  return val;
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('stripHTML', function (value) {
  var div = document.createElement('div');
  div.innerHTML = value;
  var text = div.textContent || div.innerText || '';
  return text;
});

/***/ }),

/***/ "VC1Y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-form',{staticClass:"form-horizontal",on:{"submit":function($event){$event.preventDefault();_vm.updateBank($event)}}},[(_vm.complaint.country === 'CL')?_c('div',[_c('b-form-group',{attrs:{"label":"Nombre"}},[_c('b-form-input',{directives:[{name:"validate",rawName:"v-validate",value:('required|alpha_spaces|max:40'),expression:"'required|alpha_spaces|max:40'"}],staticClass:"form-control",attrs:{"data-vv-as":"nombre","name":"bank_account[name]","required":"required"},model:{value:(_vm.complaint.bank_account.name),callback:function ($$v) {_vm.complaint.bank_account.name=(typeof $$v === 'string'? $$v.trim(): $$v)},expression:"complaint.bank_account.name"}}),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('bank_account[name]')),expression:"errors.has('bank_account[name]')"}],staticClass:"has-error"},[_vm._v(_vm._s(_vm.errors.first('bank_account[name]')))])],1),_c('b-form-group',{attrs:{"label":"RUT"}},[_c('b-form-input',{directives:[{name:"rut",rawName:"v-rut:live",arg:"live"},{name:"validate",rawName:"v-validate",value:('required|rut|max:12'),expression:"'required|rut|max:12'"}],staticClass:"form-control",attrs:{"data-vv-as":"rut","name":"bank_account[rut]","required":"required"},model:{value:(_vm.complaint.bank_account.rut),callback:function ($$v) {_vm.complaint.bank_account.rut=(typeof $$v === 'string'? $$v.trim(): $$v)},expression:"complaint.bank_account.rut"}}),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('bank_account[rut]')),expression:"errors.has('bank_account[rut]')"}],staticClass:"has-error"},[_vm._v("Ingrese un rut válido")])],1),((_vm.isApprovedPayrollPaypal))?_c('b-form-group',{attrs:{"label":"Correo PayPal"}},[_c('b-form-input',{staticClass:"form-control",attrs:{"data-vv-as":"paypal_email","name":"reimbursement[paypal_email]","required":"required"},model:{value:(_vm.complaint.reimbursement.paypal_email),callback:function ($$v) {_vm.complaint.reimbursement.paypal_email=(typeof $$v === 'string'? $$v.trim(): $$v)},expression:"complaint.reimbursement.paypal_email"}}),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('reimbursement[paypal_email]')),expression:"errors.has('reimbursement[paypal_email]')"}],staticClass:"has-error"},[_vm._v("Ingrese un correo válido")])],1):_vm._e(),(!(_vm.isApprovedPayrollPaypal))?_c('b-form-group',{attrs:{"label":"Banco"}},[_c('selectize',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"data-vv-as":"banco","name":"bank_account[bank]"},on:{"input":function($event){_vm.account_types($event)}},model:{value:(_vm.complaint.bank_account.bank),callback:function ($$v) {_vm.complaint.bank_account.bank=$$v},expression:"complaint.bank_account.bank"}},_vm._l((_vm.banks),function(bank){return _c('option',{key:bank,domProps:{"value":bank}},[_vm._v(_vm._s(bank))])})),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('bank_account[bank]')),expression:"errors.has('bank_account[bank]')"}],staticClass:"has-error"},[_vm._v(_vm._s(_vm.errors.first('bank_account[bank]')))])],1):_vm._e(),(!(_vm.isApprovedPayrollPaypal))?_c('b-form-group',{attrs:{"label":"Tipo de cuenta"}},[_c('selectize',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"data-vv-as":"tipo de cuenta","name":"bank_account[type]"},model:{value:(_vm.complaint.bank_account.account_type),callback:function ($$v) {_vm.complaint.bank_account.account_type=$$v},expression:"complaint.bank_account.account_type"}},_vm._l((_vm.accounts),function(account){return _c('option',{key:account.code,domProps:{"value":account.code}},[_vm._v(_vm._s(account.description))])})),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('bank_account[type]')),expression:"errors.has('bank_account[type]')"}],staticClass:"has-error"},[_vm._v(_vm._s(_vm.errors.first('bank_account[type]')))])],1):_vm._e(),(!(_vm.isApprovedPayrollPaypal))?_c('b-form-group',{attrs:{"label":"Número de cuenta"}},[_c('b-form-input',{directives:[{name:"validate",rawName:"v-validate",value:('required|numeric|max:17'),expression:"'required|numeric|max:17'"}],staticClass:"form-control",attrs:{"data-vv-as":"número de cuenta","name":"bank_account[number]"},model:{value:(_vm.complaint.bank_account.account_number),callback:function ($$v) {_vm.complaint.bank_account.account_number=(typeof $$v === 'string'? $$v.trim(): $$v)},expression:"complaint.bank_account.account_number"}}),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('bank_account[number]')),expression:"errors.has('bank_account[number]')"}],staticClass:"has-error"},[_vm._v(_vm._s(_vm.errors.first('bank_account[number]')))])],1):_vm._e(),(('reimbursement' in _vm.complaint))?[_c('b-form-group',{attrs:{"label":"Monto devolución"}},[_c('b-form-input',{staticClass:"form-control",model:{value:(_vm.complaint.reimbursement.amount),callback:function ($$v) {_vm.complaint.reimbursement.amount=(typeof $$v === 'string'? $$v.trim(): $$v)},expression:"complaint.reimbursement.amount"}})],1),(!(_vm.isApprovedPayrollPaypal))?_c('b-form-group',{attrs:{"label":"Código de TEF"}},[_c('b-form-input',{staticClass:"form-control",model:{value:(_vm.complaint.reimbursement.tef_code),callback:function ($$v) {_vm.complaint.reimbursement.tef_code=(typeof $$v === 'string'? $$v.trim(): $$v)},expression:"complaint.reimbursement.tef_code"}})],1):_vm._e(),(!(_vm.isApprovedPayrollPaypal))?_c('b-form-group',{attrs:{"label":"Fecha de TEF"}},[_c('date-picker',{attrs:{"lang":"es","format":"dd/MM/yyyy","input-class":"form-control"},model:{value:(_vm.complaint.reimbursement.tef_date),callback:function ($$v) {_vm.complaint.reimbursement.tef_date=$$v},expression:"complaint.reimbursement.tef_date"}})],1):_vm._e()]:_vm._e()],2):(_vm.complaint.country === 'PE')?_c('div',[_c('b-form-group',{attrs:{"label":"Tipo de documento"}},[_c('selectize',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"data-vv-as":"tipo de documento","name":"bank_account[document_type]"},model:{value:(_vm.complaint.bank_account.document_type),callback:function ($$v) {_vm.complaint.bank_account.document_type=$$v},expression:"complaint.bank_account.document_type"}},_vm._l((_vm.documents),function(document){return _c('option',{key:document,domProps:{"value":document}},[_vm._v(_vm._s(document))])})),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('bank_account[document_type]')),expression:"errors.has('bank_account[document_type]')"}],staticClass:"has-error"},[_vm._v(_vm._s(_vm.errors.first('bank_account[document_type]')))])],1),_c('b-form-group',{attrs:{"label":"Número de documento"}},[_c('b-form-input',{directives:[{name:"validate",rawName:"v-validate",value:('required|numeric'),expression:"'required|numeric'"}],staticClass:"form-control",attrs:{"data-vv-as":"número de documento","name":"bank_account[document_number]"},model:{value:(_vm.complaint.bank_account.document_number),callback:function ($$v) {_vm.complaint.bank_account.document_number=(typeof $$v === 'string'? $$v.trim(): $$v)},expression:"complaint.bank_account.document_number"}}),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('bank_account[document_number]')),expression:"errors.has('bank_account[document_number]')"}],staticClass:"has-error"},[_vm._v(_vm._s(_vm.errors.first('bank_account[document_number]')))])],1),_c('b-form-group',{attrs:{"label":"Nombre del titular"}},[_c('b-form-input',{directives:[{name:"validate",rawName:"v-validate",value:('required|alpha_spaces|max:40'),expression:"'required|alpha_spaces|max:40'"}],staticClass:"form-control",attrs:{"data-vv-as":"nombre","name":"bank_account[name]","required":"required"},model:{value:(_vm.complaint.bank_account.name),callback:function ($$v) {_vm.complaint.bank_account.name=(typeof $$v === 'string'? $$v.trim(): $$v)},expression:"complaint.bank_account.name"}}),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('bank_account[name]')),expression:"errors.has('bank_account[name]')"}],staticClass:"has-error"},[_vm._v(_vm._s(_vm.errors.first('bank_account[name]')))])],1),_c('b-form-group',{attrs:{"label":"Correo"}},[_c('b-form-input',{directives:[{name:"validate",rawName:"v-validate",value:('required|email'),expression:"'required|email'"}],staticClass:"form-control",attrs:{"data-vv-as":"correo","name":"bank_account[email]","type":"email","autocomplete":"off"},model:{value:(_vm.complaint.bank_account.email),callback:function ($$v) {_vm.complaint.bank_account.email=$$v},expression:"complaint.bank_account.email"}}),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('bank_account[email]')),expression:"errors.has('bank_account[email]')"}],staticClass:"has-error"},[_vm._v(_vm._s(_vm.errors.first('bank_account[email]')))])],1),_c('b-form-group',{attrs:{"label":"Banco"}},[_c('selectize',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"data-vv-as":"banco","name":"bank_account[bank]"},model:{value:(_vm.complaint.bank_account.bank),callback:function ($$v) {_vm.complaint.bank_account.bank=$$v},expression:"complaint.bank_account.bank"}},_vm._l((_vm.banks),function(bank){return _c('option',{key:bank,domProps:{"value":bank}},[_vm._v(_vm._s(bank))])})),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('bank_account[bank]')),expression:"errors.has('bank_account[bank]')"}],staticClass:"has-error"},[_vm._v(_vm._s(_vm.errors.first('bank_account[bank]')))])],1),_c('b-form-group',{attrs:{"label":"Tipo de cuenta"}},[_c('selectize',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"data-vv-as":"tipo de cuenta","name":"bank_account[type]"},model:{value:(_vm.complaint.bank_account.account_type),callback:function ($$v) {_vm.complaint.bank_account.account_type=$$v},expression:"complaint.bank_account.account_type"}},_vm._l((_vm.accounts),function(account){return _c('option',{key:account.code,domProps:{"value":account.code}},[_vm._v(_vm._s(account.description))])})),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('bank_account[type]')),expression:"errors.has('bank_account[type]')"}],staticClass:"has-error"},[_vm._v(_vm._s(_vm.errors.first('bank_account[type]')))])],1),_c('b-form-group',{attrs:{"label":"Número de cuenta"}},[_c('b-form-input',{directives:[{name:"validate",rawName:"v-validate",value:('required|numeric|max:17'),expression:"'required|numeric|max:17'"}],staticClass:"form-control",attrs:{"data-vv-as":"número de cuenta","name":"bank_account[number]"},model:{value:(_vm.complaint.bank_account.account_number),callback:function ($$v) {_vm.complaint.bank_account.account_number=(typeof $$v === 'string'? $$v.trim(): $$v)},expression:"complaint.bank_account.account_number"}}),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('bank_account[number]')),expression:"errors.has('bank_account[number]')"}],staticClass:"has-error"},[_vm._v(_vm._s(_vm.errors.first('bank_account[number]')))])],1),_c('b-form-group',{attrs:{"label":"CCI"}},[_c('b-form-input',{directives:[{name:"validate",rawName:"v-validate",value:('required|numeric'),expression:"'required|numeric'"}],staticClass:"form-control",attrs:{"data-vv-as":"CCI","name":"bank_account[cci]"},model:{value:(_vm.complaint.bank_account.cci),callback:function ($$v) {_vm.complaint.bank_account.cci=(typeof $$v === 'string'? $$v.trim(): $$v)},expression:"complaint.bank_account.cci"}}),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('bank_account[cci]')),expression:"errors.has('bank_account[cci]')"}],staticClass:"has-error"},[_vm._v(_vm._s(_vm.errors.first('bank_account[cci]')))])],1),(('reimbursement' in _vm.complaint))?[_c('b-form-group',{attrs:{"label":"Monto devolución"}},[_c('b-form-input',{staticClass:"form-control",model:{value:(_vm.complaint.reimbursement.amount),callback:function ($$v) {_vm.complaint.reimbursement.amount=(typeof $$v === 'string'? $$v.trim(): $$v)},expression:"complaint.reimbursement.amount"}})],1),_c('b-form-group',{attrs:{"label":"Código de TEF"}},[_c('b-form-input',{staticClass:"form-control",model:{value:(_vm.complaint.reimbursement.tef_code),callback:function ($$v) {_vm.complaint.reimbursement.tef_code=(typeof $$v === 'string'? $$v.trim(): $$v)},expression:"complaint.reimbursement.tef_code"}})],1),_c('b-form-group',{attrs:{"label":"Fecha de TEF"}},[_c('date-picker',{attrs:{"lang":"es","format":"dd/MM/yyyy","input-class":"form-control"},model:{value:(_vm.complaint.reimbursement.tef_date),callback:function ($$v) {_vm.complaint.reimbursement.tef_date=$$v},expression:"complaint.reimbursement.tef_date"}})],1)]:_vm._e()],2):_vm._e(),_c('b-form-group',{staticClass:"text-center"},[_c('b-button',{attrs:{"type":"submit","variant":"primary"}},[_vm._v(_vm._s(_vm.bank_button))])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "VU4R":
/***/ (function(module, exports) {

var rowDataServerSide = void 0;

function MyDatasource() {}

MyDatasource.prototype.getRows = function (params) {
  var rowsThisPage = rowDataServerSide.slice(params.startRow, params.endRow);
  params.successCallback(rowsThisPage, rowDataServerSide.length);
};

/***/ }),

/***/ "WT8W":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Wi0o":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "XOzM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_Status_constants__ = __webpack_require__("XXAu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_apiService__ = __webpack_require__("a/3G");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_layout_LastActivity__ = __webpack_require__("sX+p");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_layout_PopoverDetail__ = __webpack_require__("gs9z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_dateService__ = __webpack_require__("4F1w");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








var parse = __webpack_require__("UVyn");

/* eslint no-underscore-dangle: ["error", { "allow": ["_id"] }] */

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'complaints',
  components: {
    LastActivity: __WEBPACK_IMPORTED_MODULE_4__components_layout_LastActivity__["a" /* default */],
    complaintPopover: __WEBPACK_IMPORTED_MODULE_5__components_layout_PopoverDetail__["a" /* default */]
  },
  data: function data() {
    return {
      complaintFields: {
        number: {
          label: 'ID',
          sortable: true
        },
        status: {
          label: 'Estado',
          tdClass: 'status-holder'
        },
        token: { label: 'Número de compra' },
        category: {
          label: 'Categoría',
          sortable: true
        },
        comment: { label: 'Requerimiento' },
        age: { label: 'Edad' },
        bus_operator: { label: 'Empresa de bus' },
        amount_requested: { label: 'Monto reclamado' }
      },
      statuses: __WEBPACK_IMPORTED_MODULE_2__constants_Status_constants__["a" /* default */].STATUSES,
      complaints: [],
      pagination: {},
      current_page: 1,
      pending: true,
      sortAge: false,
      filterText: '',
      intervalId: null,
      showDialog: false
    };
  },
  created: function created() {
    this.fetchComplaints(undefined, true);
  },

  methods: {
    busOperators: function busOperators(complaint) {
      var busOperators = complaint.ticket_info.bus_operators;

      if (busOperators.length > 1) {
        return String(busOperators).replace(',', ', ');
      }
      return String(busOperators);
    },
    complaintAge: function complaintAge(complaint) {
      return __WEBPACK_IMPORTED_MODULE_6__utils_dateService__["a" /* default */].complaintAge(complaint.created_at);
    },
    fetchComplaints: function fetchComplaints(page, pending) {
      var $this = this;
      __WEBPACK_IMPORTED_MODULE_3__services_apiService__["a" /* default */].complaints(page, pending, this.filterText, this.sortAge, false).then(function (data) {
        $this.complaints = data.body.complaints;
        $this.setPagination(data);
      });
    },
    setPagination: function setPagination(res) {
      var links = Object.prototype.hasOwnProperty.call(res.headers.map, 'links') ? parse(res.headers.map.link[0]) : null;
      var current = res.body.meta.current_page;
      var total = res.body.meta.total_count;
      var perPage = res.body.meta.per_page;
      var pagination = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
        current: parseInt(current, 10),
        total: parseInt(total, 10),
        per_page: parseInt(perPage, 10)
      }, links);
      this.pagination = pagination;
    },
    changePage: function changePage(page) {
      this.current_page = page;
      this.fetchComplaints(page, this.pending);
    },
    showComplaintDetails: function showComplaintDetails(complaint) {
      __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].commit('selectComplaint', complaint);
      this.$router.push('/complaints/' + complaint._id.$oid);
    },
    showPending: function showPending() {
      this.fetchComplaints(null, this.pending);
    },
    refreshComplaints: function refreshComplaints() {
      var $this = this;
      this.intervalId = setInterval(function () {
        $this.fetchComplaints(undefined, $this.pending);
      }, 120000);
    },
    toggleAge: function toggleAge() {
      this.sortAge = !this.sortAge;
      this.fetchComplaints(this.current_page, this.pending);
    },
    refreshReloaAppStatus: function refreshReloaAppStatus() {
      var _this = this;

      this.intervalId = setInterval(function () {
        __WEBPACK_IMPORTED_MODULE_3__services_apiService__["a" /* default */].reloadAppStatus().then(function (response) {
          if (response.body) {
            _this.showDialog = true;
          }
        });
      }, 900000);
    }
  },
  mounted: function mounted() {
    this.refreshComplaints();
    this.refreshReloaAppStatus();
    if (__WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.reloadApp) {
      this.showDialog = true;
    }
  },
  beforeDestroy: function beforeDestroy() {
    clearInterval(this.intervalId);
  }
});

/***/ }),

/***/ "XXAu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);

/* harmony default export */ __webpack_exports__["a"] = ({
  STATUSES: {
    open: { description: 'Abierto', initials: 'O' },
    pending_err: { description: 'Pendiente decisión - Departamento ERR', initials: 'PD-ERR' },
    pending_edb: { description: 'Pendiente decisión - Empresa de bus', initials: 'PD-EB' },
    pending_info: { description: 'Pendiente decisión - Pedir más información del cliente', initials: 'PD-MI' },
    pending_requested: { description: 'Pendiente decisión - Información adicional solicitada', initials: 'PD-IAS' },
    approved_communication: { description: 'Aprobado - Pendiente comunicación al cliente', initials: 'A-PCC' },
    approved_bank: { description: 'Aprobado - Pendiente envio de datos bancarios por parte del cliente', initials: 'A-PDB' },
    rejected_communication: { description: 'Rechazado - Pendiente comunicación al cliente', initials: 'R-PCC' },
    approved_reimbursement: { description: 'Aprobado - Pendiente devolución', initials: 'A-PD' },
    edb_accepted: { description: 'Aprobado por Empresa de bus', initials: 'A-EDB' },
    edb_rejected: { description: 'Rechazado por Empresa de bus', initials: 'R-EDB' },
    edb_request: { description: 'Pendiente decisión - Empresa de bus solicita información adicional', initials: 'PD-EBI' },
    rejected: { description: 'Resuelto - Rechazado', initials: 'R-R' },
    closed: { description: 'Resuelto', initials: 'R' },
    reimbursement_error: { description: 'Aprobado - Error en transferencia', initials: 'A-ET' },
    expired: { description: 'Expirado', initials: 'E' },
    approved_processing: { description: 'Aprobado - En proceso de devolución', initials: 'A-EPD' }
  },
  STATUSES_ECOMMERCE: {
    open: { description: 'Abierto', initials: 'O' },
    pending_ecommerce: { description: 'Pendiente decisión - Ecommerce', initials: 'PD-ECC' },
    refunded_ecommerce: { description: 'Reembolsado - Ecommerce', initials: 'RF-ECC' },
    rejected_ecommerce: { description: 'Rechazado - Ecommerce', initials: 'RJ-ECC' }
  },
  ACTIONS: {
    complaint_close: { description: 'cerró' },
    complaint_approve: { description: 'aprobó' },
    complaint_reject: { description: 'rechazó' },
    complaint_create: { description: 'creó' },
    complaint_comment: { description: 'comentó en' },
    complaint_update: { description: 'actualizó' },
    complaint_err_request: { description: 'solicitó información adicional sobre' },
    complaint_add_info: { description: 'adjuntó información en' },
    complaint_send_edb: { description: 'envió a compañía de bus' },
    complaint_reimburse: { description: 'realizó devolución de dinero' },
    complaint_crm_request: { description: 'solicitó información adicional del cliente sobre' },
    complaint_crm_info: { description: 'ingresó información adicional del cliente' },
    complaint_notify_rejection: { description: 'informó rechazo al cliente' },
    complaint_notify_approval: { description: 'comunicó aprobación (no monetaria) al cliente' },
    complaint_edb_approve: { description: 'aprobó' },
    complaint_edb_reject: { description: 'rechazó' },
    complaint_edb_request: { description: 'solicitó información adicional' },
    complaint_reimbursement_error: { description: 'notificó error en transferencia' },
    refund_method_changed: { description: 'cambió método de reembolso en' },
    error_method_changing: { description: 'falló cambio de método de reembolso' },
    complaint_ecommerce_rejected: { description: 'rechazó' },
    complaint_ecommerce_refunded: { description: 'reembolsó' }
  },
  BANKS: [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(location.host.split('.').pop() === 'pe' && ['Banco de Comercio', 'Banco de Crédito del Perú', 'Banco Interamericano de Finanzas (BanBif)', 'Banco Pichincha', 'BBVA', 'Citibank Perú', 'Interbank', 'MiBanco', 'Scotiabank Perú', 'Banco GNB Perú', 'Banco Falabella', 'Banco Ripley', 'Banco Santander Perú', 'Alfin Banco', 'Bank of China', 'Bci Perú', 'ICBC PERU BANK']), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(['cl', 'mx'].includes(location.host.split('.').pop()) && ['BANCO DE CHILE', 'BANCO EDWARDS', 'CITIBANK', 'BANCO ESTADO', 'SCOTIABANK', 'BBVA', 'BANCO CREDITO E INVERSIONES (BCI)', 'CORPBANCA', 'BANCO BICE', 'BANCO SANTANDER', 'BANCO ITAU', 'ABN AMOR BANK', 'BANCO SECURITY', 'BANCO FALABELLA', 'BANCO CONSORCIO', 'COOPEUCH', 'THE BANK OF TOKYO MITSUBISHI', 'BANCO SUD AMERICANO', 'BANCO DESARROLLO'])),
  ACCOUNTS: [{ code: 0, description: 'Cuenta Vista' }, { code: 1, description: 'Cuenta Corriente' }, { code: 2, description: 'Cuenta Ahorro' }],
  ROLES: {
    1: { name: '🤖' },
    2: { name: 'CRM' },
    3: { name: 'ERR' },
    4: { name: 'EDB' },
    5: { name: 'FIN' }
  },
  DOCUMENTS: ['DNI', 'RUC', 'Carnet de extranjero', 'Pasaporte'],
  PAYMENT_METHODS: ['WebPay', 'Agencia', 'Payu Crédito/Débito', 'Payu Pago Efectivo', '100% Cupones', 'Fintoc', 'OneClick'],
  REFUND_METHODS: [{ code: 'payroll_paypal', description: 'Nómina PayPal' }],
  REFUND_METHOD_TARGETS: {
    payroll_bank: 'payroll_paypal',
    devolution_tbk: 'payroll_paypal',
    devolution_fintoc: 'payroll_paypal'
  },
  COMMENT_TEMPLATES: [{ title: 'Suspensión',
    template: 'Lo/a contactamos para notificar que el servicio del día [Fecha] a las [Hora] fue suspendido por la ' + 'empresa de bus. En función de lo anterior, le ofrecemos el 100% del valor de sus pasajes. AVISO: A ' + 'su correo electrónico llegará un mensaje de recordatorio de su viaje original, por favor ignorar, ' + 'su viaje se encuentra suspendido. Por favor acusar recibo de la información.' }, { title: 'Solicitud empresa de bus / Otros',
    template: 'Hemos resuelto en conjunto con la empresa de bus, devolver el [XX]% del valor de su pasaje. Pronto ' + 'le notificaremos una vez que su reembolso entre en proceso. Lamentamos los inconvenientes.' }]
});

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_resource__ = __webpack_require__("8+8L");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_kindergarten__ = __webpack_require__("Ar/W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_kindergarten___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_kindergarten__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__child__ = __webpack_require__("55sj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Login__ = __webpack_require__("xJsL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_ConfirmEmail__ = __webpack_require__("Ccy/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_PasswordCreation__ = __webpack_require__("PWjZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Logout__ = __webpack_require__("0Kyw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_complaints_Complaints__ = __webpack_require__("mfjq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_complaints_ComplaintsEcommerce__ = __webpack_require__("OmsM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_complaints_New__ = __webpack_require__("s6sV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_complaints_NewPreApproved__ = __webpack_require__("tf+Y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_complaints_ShowComplaint__ = __webpack_require__("zGor");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_complaints_ShowComplaintEcommerce__ = __webpack_require__("lc2m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_Operators__ = __webpack_require__("L60Q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_complaints_Status__ = __webpack_require__("tFFr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_Finance__ = __webpack_require__("4T/p");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_Users__ = __webpack_require__("TKn+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_complaints_All__ = __webpack_require__("lE44");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__constants_Url_constants__ = __webpack_require__("M1ba");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__utils_functions__ = __webpack_require__("9NIY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__perimeters__ = __webpack_require__("+QQc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_Categories__ = __webpack_require__("PCMc");


























__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue_resource__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.options.root = __WEBPACK_IMPORTED_MODULE_21__constants_Url_constants__["a" /* default */].API_URL;

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    redirect: '/complaints'
  }, {
    path: '/login',
    name: 'login',
    component: __WEBPACK_IMPORTED_MODULE_6__components_Login__["a" /* default */]
  }, {
    path: '/logout',
    name: 'logout',
    component: __WEBPACK_IMPORTED_MODULE_9__components_Logout__["a" /* default */]
  }, {
    path: '/operators',
    name: 'operators',
    component: __WEBPACK_IMPORTED_MODULE_16__components_Operators__["a" /* default */],
    meta: { auth: true }
  }, {
    path: '/users',
    name: 'users',
    component: __WEBPACK_IMPORTED_MODULE_19__components_Users__["a" /* default */],
    meta: { auth: true }
  }, {
    path: '/categories',
    name: 'categories',
    component: __WEBPACK_IMPORTED_MODULE_24__components_Categories__["a" /* default */],
    meta: { auth: true }
  }, {
    path: '/finance',
    name: 'finance',
    component: __WEBPACK_IMPORTED_MODULE_18__components_Finance__["a" /* default */],
    meta: { auth: true }
  }, {
    path: '/complaints',
    name: 'complaints',
    component: __WEBPACK_IMPORTED_MODULE_10__components_complaints_Complaints__["a" /* default */],
    meta: { auth: true }
  }, {
    path: '/complaints_ecommerce',
    name: 'complaints_ecommerce',
    component: __WEBPACK_IMPORTED_MODULE_11__components_complaints_ComplaintsEcommerce__["a" /* default */],
    meta: { auth: true }
  }, {
    path: '/complaints/new',
    name: 'new',
    component: __WEBPACK_IMPORTED_MODULE_12__components_complaints_New__["a" /* default */],
    meta: { auth: true }
  }, {
    path: '/complaints/all',
    name: 'all',
    component: __WEBPACK_IMPORTED_MODULE_20__components_complaints_All__["a" /* default */],
    meta: { auth: true }
  }, {
    path: '/complaints/pre-approved',
    name: 'new_pre_approved',
    component: __WEBPACK_IMPORTED_MODULE_13__components_complaints_NewPreApproved__["a" /* default */],
    meta: { auth: true }
  }, {
    path: '/complaints_ecommerce/:complaint_id',
    name: 'show_complaint_ecommerce',
    component: __WEBPACK_IMPORTED_MODULE_15__components_complaints_ShowComplaintEcommerce__["a" /* default */],
    meta: { auth: true }
  }, {
    path: '/complaints/:complaint_id',
    name: 'show_complaint',
    component: __WEBPACK_IMPORTED_MODULE_14__components_complaints_ShowComplaint__["a" /* default */],
    meta: { auth: true }
  }, {
    path: '/status/:complaint_id',
    name: 'status',
    component: __WEBPACK_IMPORTED_MODULE_17__components_complaints_Status__["a" /* default */],
    meta: { auth: false }
  }, {
    path: '/confirm_email',
    name: 'confirm_email',
    component: __WEBPACK_IMPORTED_MODULE_7__components_ConfirmEmail__["a" /* default */],
    meta: { auth: false }
  }, {
    path: '/password_creation',
    name: 'password_creation',
    component: __WEBPACK_IMPORTED_MODULE_8__components_PasswordCreation__["a" /* default */],
    meta: { auth: false }
  }, {
    path: '*',
    redirect: '/complaints'
  }]
});

router.beforeEach(function (to, from, next) {
  __WEBPACK_IMPORTED_MODULE_22__utils_functions__["a" /* changeTitle */](to, from, next);
  if (to.meta.auth) {
    var validSession = !!localStorage.getItem('token') && Math.round(new Date().getTime() / 1000) < __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].state.expiration;
    var role = __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].state.user.role;
    if (validSession && role !== undefined) {
      var perimeter = __WEBPACK_IMPORTED_MODULE_23__perimeters__[to.name + 'Perimeter'];
      if (perimeter) {
        var sandbox = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vue_kindergarten__["createSandbox"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__child__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */]), {
          perimeters: [perimeter]
        });
        if (!sandbox.isAllowed('route')) {
          next('/');
        }
      }
      next();
    } else {
      next({ path: '/login' });
    }
  }
  next();
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),

/***/ "ZInL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-popover',{attrs:{"target":_vm.popoverTarget,"triggers":"hover focus"}},[_c('template',{attrs:{"slot":"title"},slot:"title"},[_c('h5',[_vm._v(_vm._s(_vm.thisComplaint.comment))]),_c('small',{staticClass:"complaint-status-wrapper",class:("status-" + (_vm.statuses[_vm.thisComplaint.aasm_state].initials.toLowerCase()))},[_vm._v(_vm._s(_vm.statuses[_vm.thisComplaint.aasm_state].description))])]),_c('p',[_vm._v(_vm._s(_vm._f("truncateDescription")(_vm.thisComplaint.description)))])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Zmly":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_apiService__ = __webpack_require__("a/3G");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue2_editor__ = __webpack_require__("m6he");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue2_editor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue2_editor__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'comments',
  components: {
    VueEditor: __WEBPACK_IMPORTED_MODULE_2_vue2_editor__["VueEditor"]
  },
  props: ['complaint'],
  data: function data() {
    return {
      comments: [],
      content: ''
    };
  },
  created: function created() {
    this.fetchComments();
  },

  methods: {
    fetchComments: function fetchComments() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0__services_apiService__["a" /* default */].comments(this.complaint).then(function (data) {
        _this.comments = data.body;
        __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].commit('setCommentsLength', _this.comments.length);
      });
    },
    postComment: function postComment() {
      var $this = this;
      if (this.content !== '<p><br></p>') {
        __WEBPACK_IMPORTED_MODULE_0__services_apiService__["a" /* default */].post_comment(this.complaint, this.content).then(function () {
          $this.content = '';
          $this.fetchComments();
        });
      }
    }
  }
});

/***/ }),

/***/ "a/3G":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_resource__ = __webpack_require__("8+8L");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants_Url_constants__ = __webpack_require__("M1ba");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__store__ = __webpack_require__("IcnI");









__WEBPACK_IMPORTED_MODULE_3_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_vue_resource__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_3_vue__["default"].http.interceptors.push(function (request, next) {
  request.headers.set('Authorization', 'Bearer ' + localStorage.getItem('token'));
  request.headers.set('Accept', 'application/json');
  next(function (response) {
    if (response.status === 401) {
      __WEBPACK_IMPORTED_MODULE_7__store__["a" /* default */].commit('logout');
      __WEBPACK_IMPORTED_MODULE_6__router__["a" /* default */].push({ path: 'login' });
    }
  });
});

/* eslint-disable prefer-template */
/* harmony default export */ __webpack_exports__["a"] = ({
  zendeskInfo: function zendeskInfo(ticket) {
    return __WEBPACK_IMPORTED_MODULE_3_vue__["default"].http.get(__WEBPACK_IMPORTED_MODULE_5__constants_Url_constants__["a" /* default */].API_URL + '/zendesk/' + ticket);
  },
  ticketInfo: function ticketInfo(code, category, complaintType) {
    return __WEBPACK_IMPORTED_MODULE_3_vue__["default"].http.get(__WEBPACK_IMPORTED_MODULE_5__constants_Url_constants__["a" /* default */].API_URL + '/tickets/' + code + '?category=' + category + '&complaint_type=' + complaintType);
  },
  post: function post(complaint) {
    return __WEBPACK_IMPORTED_MODULE_3_vue__["default"].http.post(__WEBPACK_IMPORTED_MODULE_5__constants_Url_constants__["a" /* default */].API_URL + '/complaints', {
      complaint: complaint });
  },
  get: function get(id) {
    return __WEBPACK_IMPORTED_MODULE_3_vue__["default"].http.get(__WEBPACK_IMPORTED_MODULE_5__constants_Url_constants__["a" /* default */].API_URL + '/complaints/' + id);
  },
  status: function status(id) {
    return __WEBPACK_IMPORTED_MODULE_3_vue__["default"].http.get(__WEBPACK_IMPORTED_MODULE_5__constants_Url_constants__["a" /* default */].API_URL + '/status/' + id);
  },
  status_submit: function status_submit(id, data) {
    return __WEBPACK_IMPORTED_MODULE_3_vue__["default"].http.put(__WEBPACK_IMPORTED_MODULE_5__constants_Url_constants__["a" /* default */].API_URL + '/status/' + id, data);
  },
  status_bank: function status_bank(id, data) {
    return __WEBPACK_IMPORTED_MODULE_3_vue__["default"].http.post(__WEBPACK_IMPORTED_MODULE_5__constants_Url_constants__["a" /* default */].API_URL + '/status/' + id + '/bank', data);
  },
  status_paypal_account: function status_paypal_account(id, paypalAccount) {
    return __WEBPACK_IMPORTED_MODULE_3_vue__["default"].http.post(__WEBPACK_IMPORTED_MODULE_5__constants_Url_constants__["a" /* default */].API_URL + '/status/' + id + '/paypal_account', paypalAccount);
  },
  update: function update(id, complaint) {
    return __WEBPACK_IMPORTED_MODULE_3_vue__["default"].http.put(__WEBPACK_IMPORTED_MODULE_5__constants_Url_constants__["a" /* default */].API_URL + '/complaints/' + id, {
      complaint: complaint });
  },
  forceUpdate: function forceUpdate(id, complaint) {
    return __WEBPACK_IMPORTED_MODULE_3_vue__["default"].http.put(__WEBPACK_IMPORTED_MODULE_5__constants_Url_constants__["a" /* default */].API_URL + '/complaints/' + id, {
      complaint: complaint, force: true });
  },
  complaints: function complaints(page, pending, text, sort, ecommerce) {
    var query = __WEBPACK_IMPORTED_MODULE_5__constants_Url_constants__["a" /* default */].API_URL + '/complaints?pending=' + pending + '&ecommerce=' + ecommerce;
    var age = sort ? 'asc' : 'desc';
    if (page !== undefined) {
      query += '&page=' + page;
    }
    if (text !== '') {
      query += '&text=' + text;
    }
    query += '&age=' + age;
    return __WEBPACK_IMPORTED_MODULE_3_vue__["default"].http.get(query);
  },
  all_complaints: function all_complaints(offset, limit, filters) {
    var filter = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(filters).map(function (key) {
      return key + '=' + encodeURIComponent(filters[key].filter);
    }).join('&');
    return __WEBPACK_IMPORTED_MODULE_3_vue__["default"].http.get(__WEBPACK_IMPORTED_MODULE_5__constants_Url_constants__["a" /* default */].API_URL + '/complaints?offset=' + offset + '&limit=' + limit + '&' + filter + '&external=true');
  },
  activities: function activities(id, ecommerce) {
    if (id === undefined) {
      return __WEBPACK_IMPORTED_MODULE_3_vue__["default"].http.get(__WEBPACK_IMPORTED_MODULE_5__constants_Url_constants__["a" /* default */].API_URL + '/activity?ecommerce=' + ecommerce);
    }
    return __WEBPACK_IMPORTED_MODULE_3_vue__["default"].http.get(__WEBPACK_IMPORTED_MODULE_5__constants_Url_constants__["a" /* default */].API_URL + '/complaints/' + id + '/activity?ecommerce=' + ecommerce);
  },
  comments: function comments(id) {
    return __WEBPACK_IMPORTED_MODULE_3_vue__["default"].http.get(__WEBPACK_IMPORTED_MODULE_5__constants_Url_constants__["a" /* default */].API_URL + '/complaints/' + id + '/comments');
  },
  upload_file: function upload_file(id, data) {
    return __WEBPACK_IMPORTED_MODULE_3_vue__["default"].http.post(__WEBPACK_IMPORTED_MODULE_5__constants_Url_constants__["a" /* default */].API_URL + '/complaints/' + id + '/additional_info', data);
  },
  append_file: function append_file(id, data) {
    return __WEBPACK_IMPORTED_MODULE_3_vue__["default"].http.put(__WEBPACK_IMPORTED_MODULE_5__constants_Url_constants__["a" /* default */].API_URL + '/complaints/' + id + '/additional_info/' + data.request_id, data);
  },
  request_info: function request_info(id, request) {
    return __WEBPACK_IMPORTED_MODULE_3_vue__["default"].http.post(__WEBPACK_IMPORTED_MODULE_5__constants_Url_constants__["a" /* default */].API_URL + '/complaints/' + id + '/additional_info', {
      request: request });
  },
  post_comment: function post_comment(id, content) {
    return __WEBPACK_IMPORTED_MODULE_3_vue__["default"].http.post(__WEBPACK_IMPORTED_MODULE_5__constants_Url_constants__["a" /* default */].API_URL + '/complaints/' + id + '/comments', {
      content: content });
  },
  register: function register(activity) {
    return __WEBPACK_IMPORTED_MODULE_3_vue__["default"].http.post(__WEBPACK_IMPORTED_MODULE_5__constants_Url_constants__["a" /* default */].API_URL + '/activity', {
      activity: activity });
  },
  get_operators: function get_operators() {
    return __WEBPACK_IMPORTED_MODULE_3_vue__["default"].http.get(__WEBPACK_IMPORTED_MODULE_5__constants_Url_constants__["a" /* default */].API_URL + '/bus_operators');
  },

  // eslint-disable-next-line
  create_operator: function create_operator(bus_operator) {
    return __WEBPACK_IMPORTED_MODULE_3_vue__["default"].http.post(__WEBPACK_IMPORTED_MODULE_5__constants_Url_constants__["a" /* default */].API_URL + '/bus_operators', {
      bus_operator: bus_operator });
  },

  // eslint-disable-next-line
  update_operator: function update_operator(bus_operator, id) {
    return __WEBPACK_IMPORTED_MODULE_3_vue__["default"].http.put(__WEBPACK_IMPORTED_MODULE_5__constants_Url_constants__["a" /* default */].API_URL + '/bus_operators/' + id, {
      bus_operator: bus_operator });
  },
  get_users: function get_users(page, search) {
    var query = __WEBPACK_IMPORTED_MODULE_5__constants_Url_constants__["a" /* default */].API_URL + '/users?&page=' + page;
    if (search.text !== '') {
      query += '&search=' + search.text;
    }
    if (search.active !== '') {
      query += '&active=' + search.active;
    }
    if (search.role !== '') {
      query += '&role_number=' + search.role;
    }
    return __WEBPACK_IMPORTED_MODULE_3_vue__["default"].http.get(query);
  },
  get_categories: function get_categories(page) {
    var ecommerce = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    var query = __WEBPACK_IMPORTED_MODULE_5__constants_Url_constants__["a" /* default */].API_URL + '/categories';
    if (page) {
      query += '?page=' + page;
    } else {
      query += '?paginate=false';
    }
    query += '&ecommerce=' + ecommerce;
    return __WEBPACK_IMPORTED_MODULE_3_vue__["default"].http.get(query);
  },

  // eslint-disable-next-line
  create_user: function create_user(user) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(user, { role_number: user.role });
    return __WEBPACK_IMPORTED_MODULE_3_vue__["default"].http.post(__WEBPACK_IMPORTED_MODULE_5__constants_Url_constants__["a" /* default */].API_URL + '/users', {
      user: user });
  },

  // eslint-disable-next-line
  update_user: function update_user(user, id) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(user, { role_number: user.role });
    return __WEBPACK_IMPORTED_MODULE_3_vue__["default"].http.put(__WEBPACK_IMPORTED_MODULE_5__constants_Url_constants__["a" /* default */].API_URL + '/users/' + id, {
      user: user });
  },
  update_category: function update_category(category, id) {
    return __WEBPACK_IMPORTED_MODULE_3_vue__["default"].http.put(__WEBPACK_IMPORTED_MODULE_5__constants_Url_constants__["a" /* default */].API_URL + '/categories/' + id, { category: category });
  },
  delete_user: function delete_user(id) {
    return __WEBPACK_IMPORTED_MODULE_3_vue__["default"].http.delete(__WEBPACK_IMPORTED_MODULE_5__constants_Url_constants__["a" /* default */].API_URL + '/users/' + id);
  },
  recover_password: function recover_password(id) {
    return __WEBPACK_IMPORTED_MODULE_3_vue__["default"].http.get(__WEBPACK_IMPORTED_MODULE_5__constants_Url_constants__["a" /* default */].API_URL + '/users/' + id + '/recover_password');
  },
  shift_active: function shift_active(id) {
    return __WEBPACK_IMPORTED_MODULE_3_vue__["default"].http.get(__WEBPACK_IMPORTED_MODULE_5__constants_Url_constants__["a" /* default */].API_URL + '/users/' + id + '/shift_active');
  },
  confirm_email: function confirm_email(token) {
    return __WEBPACK_IMPORTED_MODULE_3_vue__["default"].http.get(__WEBPACK_IMPORTED_MODULE_5__constants_Url_constants__["a" /* default */].API_URL + '/users/confirm_email?uct=' + token);
  },
  save_password: function save_password(params) {
    return __WEBPACK_IMPORTED_MODULE_3_vue__["default"].http.put(__WEBPACK_IMPORTED_MODULE_5__constants_Url_constants__["a" /* default */].API_URL + '/users/save_password', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, params));
  },
  err: function err() {
    return __WEBPACK_IMPORTED_MODULE_3_vue__["default"].http.get(__WEBPACK_IMPORTED_MODULE_5__constants_Url_constants__["a" /* default */].API_URL + '/users/err');
  },
  finance: function finance(page, text, resolved) {
    var query = __WEBPACK_IMPORTED_MODULE_5__constants_Url_constants__["a" /* default */].API_URL + '/finance/complaints?resolved=' + resolved + '&page=' + (page || 1);
    if (text !== '') {
      query += '&text=' + text;
    }
    return __WEBPACK_IMPORTED_MODULE_3_vue__["default"].http.get(query);
  },
  uploadBice: function uploadBice(data) {
    return __WEBPACK_IMPORTED_MODULE_3_vue__["default"].http.post(__WEBPACK_IMPORTED_MODULE_5__constants_Url_constants__["a" /* default */].API_URL + '/finance/import', data);
  },
  downloadBice: function downloadBice(options) {
    var query = __WEBPACK_IMPORTED_MODULE_5__constants_Url_constants__["a" /* default */].API_URL + '/finance/download?from=' + options.from + '&to=' + options.to + '&interval=' + options.interval;
    if (options.busOperator !== '') {
      query += '&bus_operator=' + options.busOperator;
    }
    if (options.category) {
      query += '&category=' + options.category;
    }
    if (options.excludedOperators) {
      query += '&excluded=' + options.excludedOperators;
    }
    return __WEBPACK_IMPORTED_MODULE_3_vue__["default"].http.get(query);
  },
  downloadAll: function downloadAll() {
    return __WEBPACK_IMPORTED_MODULE_3_vue__["default"].http.get(__WEBPACK_IMPORTED_MODULE_5__constants_Url_constants__["a" /* default */].API_URL + '/finance/export');
  },
  downloadDiscount: function downloadDiscount(from, to) {
    return __WEBPACK_IMPORTED_MODULE_3_vue__["default"].http.get(__WEBPACK_IMPORTED_MODULE_5__constants_Url_constants__["a" /* default */].API_URL + '/finance/discounts?from=' + from + '&to=' + to);
  },
  refundPaypal: function refundPaypal(options) {
    return __WEBPACK_IMPORTED_MODULE_3_vue__["default"].http.post(__WEBPACK_IMPORTED_MODULE_5__constants_Url_constants__["a" /* default */].API_URL + '/finance/refund_paypal', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, options));
  },
  getTotal: function getTotal(options) {
    var query = __WEBPACK_IMPORTED_MODULE_5__constants_Url_constants__["a" /* default */].API_URL + '/finance/total?from=' + options.from + '&to=' + options.to + '&type=' + options.action + '&interval=' + options.interval;
    if (options.busOperator !== '') {
      query += '&bus_operator=' + options.busOperator;
    }
    if (options.category) {
      query += '&category=' + options.category;
    }
    if (options.excludedOperators) {
      query += '&excluded=' + options.excludedOperators;
    }
    return __WEBPACK_IMPORTED_MODULE_3_vue__["default"].http.get(query);
  },
  removeAttachment: function removeAttachment(id, attachment) {
    return __WEBPACK_IMPORTED_MODULE_3_vue__["default"].http.delete(__WEBPACK_IMPORTED_MODULE_5__constants_Url_constants__["a" /* default */].API_URL + '/complaints/' + id + '/additional_info/' + attachment);
  },
  exportComplaints: function exportComplaints() {
    return __WEBPACK_IMPORTED_MODULE_3_vue__["default"].http.get(__WEBPACK_IMPORTED_MODULE_5__constants_Url_constants__["a" /* default */].API_URL + '/complaints/download');
  },
  changeCouponState: function changeCouponState(params) {
    return __WEBPACK_IMPORTED_MODULE_3_vue__["default"].http.put(__WEBPACK_IMPORTED_MODULE_5__constants_Url_constants__["a" /* default */].API_URL + '/ibilbidea/coupon_state', params);
  },
  updateRefundMethod: function updateRefundMethod(id, refundMethod) {
    var params = { complaint: { refund_method: refundMethod.code, bank_account: { email: refundMethod.email } } };
    return __WEBPACK_IMPORTED_MODULE_3_vue__["default"].http.put(__WEBPACK_IMPORTED_MODULE_5__constants_Url_constants__["a" /* default */].API_URL + '/complaints/' + id + '/refund_method', params);
  },
  reloadAppToFalse: function reloadAppToFalse(params) {
    return __WEBPACK_IMPORTED_MODULE_3_vue__["default"].http.put(__WEBPACK_IMPORTED_MODULE_5__constants_Url_constants__["a" /* default */].API_URL + '/users/reload_app_to_false', params);
  },
  reloadAppStatus: function reloadAppStatus() {
    return __WEBPACK_IMPORTED_MODULE_3_vue__["default"].http.get(__WEBPACK_IMPORTED_MODULE_5__constants_Url_constants__["a" /* default */].API_URL + '/users/reload_app_status/?id=' + __WEBPACK_IMPORTED_MODULE_7__store__["a" /* default */].state.id);
  },
  getSignedLink: function getSignedLink(id, infoId) {
    return __WEBPACK_IMPORTED_MODULE_3_vue__["default"].http.get(__WEBPACK_IMPORTED_MODULE_5__constants_Url_constants__["a" /* default */].API_URL + '/complaints/' + id + '/additional_info/' + infoId + '/signed_link');
  }
});

/***/ }),

/***/ "a4KA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Header_vue__ = __webpack_require__("bXtv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f4d88ad6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Header_vue__ = __webpack_require__("Hj+A");
function injectStyle (ssrContext) {
  __webpack_require__("0Rud")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Header_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f4d88ad6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Header_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "aA+L":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "aEBH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "aPSQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modal__ = __webpack_require__("rKsW");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__modal__["a" /* default */]);

/***/ }),

/***/ "aUvd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'template-modal-editor',
  props: {
    showDialog: {
      type: Boolean,
      required: true
    },
    text: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      show: false,
      draft: '',
      pendingSave: false
    };
  },

  watch: {
    showDialog: function showDialog(newValue) {
      this.show = newValue;
      if (newValue) {
        this.draft = this.text;
      }
    }
  },
  methods: {
    blurActiveElement: function blurActiveElement() {
      if (document && document.activeElement && document.activeElement.blur) {
        document.activeElement.blur();
      }
    },
    cancel: function cancel() {
      this.pendingSave = false;
      this.blurActiveElement();
      this.show = false;
    },
    save: function save() {
      this.pendingSave = true;
      this.blurActiveElement();
      this.show = false;
    },
    onHide: function onHide() {
      if (this.pendingSave) {
        this.$emit('close', this.draft);
      } else {
        this.$emit('cancel');
      }
      this.pendingSave = false;
    }
  }
});

/***/ }),

/***/ "amQy":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDciIGhlaWdodD0iNDIiIHZpZXdCb3g9IjAgMCA0NyA0MiIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48dGl0bGU+bWVzc2FnZS1pY29uPC90aXRsZT48ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxwYXRoIGQ9Ik00Mi40IDBINEMxLjggMCAwIDEuOCAwIDR2MjYuNGMwIDIuMiAxLjggNCA0IDRoMjIuMWwtMy42LTQuMWMtLjMtLjMtLjItLjguMS0xLjEuMy0uMy44LS4zIDEuMS4xbDQgNC42IDYuNiA3LjN2LTYuN2g4YzIuMiAwIDQtMS44IDQtNFY0Yy4xLTIuMi0xLjctNC0zLjktNHoiIGZpbGw9IiMxOENGRDciLz48cGF0aCBkPSJNMjAuOCAxMmgtMTJjLS40IDAtLjgtLjQtLjgtLjhzLjQtLjguOC0uOGgxMmMuNCAwIC44LjQuOC44cy0uNC44LS44Ljh6TTM2IDE4LjRIOC44Yy0uNCAwLS44LS40LS44LS44cy40LS44LjgtLjhIMzZjLjQgMCAuOC40LjguOHMtLjQuOC0uOC44ek0zNiAyNC44SDguOGMtLjQgMC0uOC0uNC0uOC0uOHMuNC0uOC44LS44SDM2Yy40IDAgLjguNC44LjhzLS40LjgtLjguOHoiIGZpbGw9IiNGRkYiLz48L2c+PC9zdmc+"

/***/ }),

/***/ "bXtv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__perimeters_complaintsPerimeter__ = __webpack_require__("EjrX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_Status_constants__ = __webpack_require__("XXAu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_img_recorrido_logo_monochrome_white_svg__ = __webpack_require__("mc/t");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_img_recorrido_logo_monochrome_white_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_img_recorrido_logo_monochrome_white_svg__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Header',
  perimeters: [__WEBPACK_IMPORTED_MODULE_1__perimeters_complaintsPerimeter__["a" /* default */]],
  data: function data() {
    return {
      roles: __WEBPACK_IMPORTED_MODULE_2__constants_Status_constants__["a" /* default */].ROLES
    };
  },

  computed: {
    isLoggedIn: function isLoggedIn() {
      return __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].state.isLogged;
    },
    user: function user() {
      return this.roles[__WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].state.user.role].name + ' / ' + __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].state.user.name;
    },
    logo: function logo() {
      return __WEBPACK_IMPORTED_MODULE_3__assets_img_recorrido_logo_monochrome_white_svg___default.a;
    }
  }
});

/***/ }),

/***/ "bmAA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('notifications',{attrs:{"group":"finance","position":"top center"}}),_c('b-row',{staticClass:"justify-content-md-center"},[_c('ReloadAppDialog',{attrs:{"showDialog":_vm.showDialog}}),_c('b-col',{attrs:{"md":"12"}},[_c('b-row',[_c('b-col',{staticClass:"download-btns",attrs:{"md":"7"}},[_c('b-button',{staticClass:"btn-space",attrs:{"variant":"primary","size":"sm"},on:{"click":_vm.exportAll}},[_c('icon',{attrs:{"name":"download"}}),_vm._v(" Todos")],1),_c('b-button',{staticClass:"btn-space",attrs:{"variant":"secondary","size":"sm"},on:{"click":function($event){_vm.openModal('discount')}}},[_c('icon',{attrs:{"name":"download"}}),_vm._v(" Descuentos")],1),_c('b-button',{staticClass:"btn-space",attrs:{"variant":"primary","size":"sm"},on:{"click":_vm.paypalModal}},[_c('icon',{attrs:{"name":"paypal"}}),_vm._v(" PayPal")],1),_c('b-button',{staticClass:"btn-space",attrs:{"variant":"success","size":"sm"},on:{"click":function($event){_vm.openModal('bice')}}},[_c('icon',{attrs:{"name":"download"}}),_vm._v(" Exportar Bice")],1),_c('b-button',{staticClass:"btn-space",attrs:{"variant":"warning","size":"sm"},on:{"click":_vm.importBice}},[_c('icon',{attrs:{"name":"upload"}}),_vm._v(" Importar Bice")],1),_c('b-button',{attrs:{"variant":"primary","pressed":_vm.resolved,"size":"sm","right":"right"},on:{"update:pressed":function($event){_vm.resolved=$event},"click":function($event){_vm.showResolved($event)}}},[_vm._v("Resueltos"),(_vm.resolved)?_c('span',[_vm._v("  ")]):_vm._e(),(_vm.resolved)?_c('icon',{attrs:{"name":"check"}}):_vm._e()],1),_c('input',{attrs:{"id":"requestFile","type":"file","hidden":"hidden"},on:{"change":function($event){_vm.uploadFile()}}})],1),_c('b-col',{attrs:{"md":"5"}},[_c('b-input-group',[_c('b-form-input',{nativeOn:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13)){ return null; }_vm.search($event)}},model:{value:(_vm.filterText),callback:function ($$v) {_vm.filterText=$$v},expression:"filterText"}}),_c('b-input-group-button',{attrs:{"slot":"right"},slot:"right"},[_c('b-btn',{on:{"click":_vm.search}},[_c('icon',{attrs:{"name":"search"}})],1)],1)],1)],1)],1),(_vm.complaints.length > 0)?_c('b-table',{attrs:{"hover":"hover","fields":_vm.complaintFields,"items":_vm.complaints},on:{"row-clicked":_vm.showComplaintDetails},scopedSlots:_vm._u([{key:"status",fn:function(thisComplaint){return [_c('div',{staticClass:"complaint-status-wrapper",class:("status-" + (_vm.statuses[thisComplaint.item.aasm_state].initials.toLowerCase())),attrs:{"id":("status-" + (thisComplaint.item._id.$oid))}},[_vm._v(_vm._s(_vm.statuses[thisComplaint.item.aasm_state].initials))]),_c('complaint-popover',{attrs:{"thisComplaint":thisComplaint.item,"popoverTarget":("status-" + (thisComplaint.item._id.$oid))}})]}},{key:"token",fn:function(thisComplaint){return [_vm._v(_vm._s(thisComplaint.item.ticket_info.booking_number))]}},{key:"category",fn:function(thisComplaint){return [_vm._v(_vm._s(thisComplaint.item.complaint_category.name))]}},{key:"comment",fn:function(thisComplaint){return [_c('div',{attrs:{"id":("comment-" + (thisComplaint.item._id.$oid))}},[_vm._v(_vm._s(thisComplaint.item.comment))]),_c('complaint-popover',{attrs:{"thisComplaint":thisComplaint.item,"popoverTarget":("comment-" + (thisComplaint.item._id.$oid))}})]}},{key:"age",fn:function(thisComplaint){return [_vm._v(_vm._s(_vm.complaintAge(thisComplaint.item)))]}},{key:"bus_operator",fn:function(thisComplaint){return [_vm._v(_vm._s(_vm.busOperators(thisComplaint.item)))]}},{key:"payment_method",fn:function(thisComplaint){return [_vm._v(_vm._s(thisComplaint.item.ticket_info.payment_method))]}},{key:"amount_requested",fn:function(thisComplaint){return [(thisComplaint.item.reimbursement)?_c('div',[(thisComplaint.item.reimbursement.compensation_type === 'm')?_c('span',[(['WebPay', 'Agencia', 'Fintoc', 'OneClick', 'Mercado Pago', 'Floid'].includes(thisComplaint.item.ticket_info.payment_method))?[_vm._v(_vm._s(_vm._f("currency")(thisComplaint.item.reimbursement.amount,'CLP $', 0, { thousandsSeparator: '.'})))]:[_vm._v(_vm._s(_vm._f("currency")(thisComplaint.item.reimbursement.amount,'USD $', 2, { thousandsSeparator: ',', decimalSeparator: '.' })))]],2):_c('span',[_vm._v("No monetario")])]):_c('div',[_vm._v("Aún no está cerrado")])]}},{key:"approved_at",fn:function(thisComplaint){return [(thisComplaint.item.reimbursement)?_c('div',[_vm._v(_vm._s(_vm._f("formatFullDate")(thisComplaint.item.approved_at)))]):_c('div',[_vm._v("Aún no está cerrado")])]}},{key:"devolution_at",fn:function(thisComplaint){return [(thisComplaint.item.reimbursement && thisComplaint.item.aasm_state === 'closed')?_c('div',[(thisComplaint.item.reimbursement.compensation_type === 'm')?_c('span',[_vm._v(_vm._s(_vm._f("formatFullDate")(thisComplaint.item.reimbursement.devolution_at)))]):_c('span',[_vm._v("No monetario")])]):_c('div',[_vm._v("Aún no está cerrado")])]}},{key:"statuses",fn:function(thisComplaint){return [_c('div',{staticClass:"btn-group",attrs:{"role":"group"}},[(thisComplaint.item.reimbursement.discount_from_company)?_c('button',{staticClass:"btn btn-sm btn-outline-danger",attrs:{"type":"button","title":"Descontar a empresa"}},[_c('icon',{attrs:{"name":"dollar"}})],1):_c('button',{staticClass:"btn btn-sm btn-outline-primary",attrs:{"type":"button","title":"No se descuenta a empresa"}},[_c('icon',{attrs:{"name":"dollar"}})],1),(thisComplaint.item.discounted)?_c('button',{staticClass:"btn btn-sm btn-success",attrs:{"type":"button","title":"Descargado en planilla de descuentos"}},[_c('icon',{attrs:{"name":"check"}})],1):_c('button',{staticClass:"btn btn-sm btn-outline-danger",attrs:{"type":"button","title":"Descargado en planilla de descuentos"}},[_c('icon',{attrs:{"name":"check"}})],1)])]}},{key:"edit_complaint",fn:function(thisComplaint){return [_c('router-link',{staticClass:"show-link",attrs:{"to":{ name: 'show_complaint', params: { complaint_id: thisComplaint.item._id.$oid } }}})]}}])}):_c('div',[_c('br'),_c('p',[_vm._v("No hay reclamos por mostrar 🎉")])]),(_vm.complaints.length > 0)?_c('b-pagination',{attrs:{"align":"center","total-rows":_vm.pagination.total,"per-page":_vm.pagination.per_page},on:{"change":_vm.changePage},model:{value:(_vm.pagination.current),callback:function ($$v) {_vm.pagination.current=$$v},expression:"pagination.current"}}):_vm._e()],1)],1),_c('b-modal',{attrs:{"busy":true},model:{value:(_vm.modalDate),callback:function ($$v) {_vm.modalDate=$$v},expression:"modalDate"}},[_c('b-form',{staticClass:"form-horizontal"},[_c('b-row',{staticClass:"justify-content-md-center"},[_c('b-col',{attrs:{"md":"6"}},[_c('b-form-group',{attrs:{"label":"Desde"}},[_c('date-picker',{attrs:{"lang":"es","format":"dd/MM/yyyy","input-class":"form-control"},model:{value:(_vm.from),callback:function ($$v) {_vm.from=$$v},expression:"from"}})],1)],1),_c('b-col',{attrs:{"md":"6"}},[_c('b-form-group',{attrs:{"label":"Hasta"}},[_c('date-picker',{attrs:{"lang":"es","format":"dd/MM/yyyy","input-class":"form-control"},model:{value:(_vm.to),callback:function ($$v) {_vm.to=$$v},expression:"to"}})],1)],1)],1),_c('b-row',{staticClass:"justify-content-md-center"},[_c('b-col',{attrs:{"md":"12"}},[_c('b-form-group',{attrs:{"label":"Filtrar por"}},[_c('b-form-radio-group',{attrs:{"options":_vm.intervalOptions},model:{value:(_vm.intervalType),callback:function ($$v) {_vm.intervalType=$$v},expression:"intervalType"}})],1)],1),_c('b-col',{attrs:{"md":"12"}},[_c('b-form-group',{attrs:{"label":"Operador"}},[_c('selectize',{model:{value:(_vm.busOperator),callback:function ($$v) {_vm.busOperator=$$v},expression:"busOperator"}},_vm._l((this.operatorsForSelect),function(operator){return _c('option',{key:operator.id,domProps:{"value":operator.id}},[_vm._v(_vm._s(operator.name))])}))],1)],1),_c('b-col',{attrs:{"md":"12"}},[_c('b-form-group',{attrs:{"label":"Excluir"}},[_c('selectize',{attrs:{"multiple":"multiple"},model:{value:(_vm.excludedOperators),callback:function ($$v) {_vm.excludedOperators=$$v},expression:"excludedOperators"}},_vm._l((_vm.operators),function(operator){return _c('option',{key:operator.id,domProps:{"value":operator.id}},[_vm._v(_vm._s(operator.name))])}))],1)],1),_c('b-col',{attrs:{"md":"12"}},[_c('b-form-group',{attrs:{"label":"Categoría"}},[_c('selectize',{attrs:{"placeholder":"Elige una categoría"},model:{value:(_vm.complaintCategory),callback:function ($$v) {_vm.complaintCategory=$$v},expression:"complaintCategory"}},_vm._l((Object.keys(_vm.categories)),function(key){return _c('option',{key:key,domProps:{"value":key}},[_vm._v(_vm._s(_vm.categories[key].description))])}))],1)],1)],1),_c('b-row',{staticClass:"justify-content-md-center"},[_c('b-col',{attrs:{"md":"12"}},[_c('b-form-group',{attrs:{"label":"Total"}},[_c('b-form-input',{staticClass:"form-control",attrs:{"value":_vm._f("currency")(_vm.total,'$', 0, { thousandsSeparator: '.'}),"type":"text","readonly":"readonly"}})],1)],1)],1)],1),_c('div',{attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('b-btn',{staticClass:"btn-space",attrs:{"variant":"secondary"},on:{"click":_vm.closeModal}},[_vm._v("Cancelar")]),_c('b-btn',{attrs:{"variant":"primary"},on:{"click":_vm.exportData}},[_vm._v("Descargar")])],1)],1),_c('b-modal',{attrs:{"busy":true},model:{value:(_vm.modalReimbursement),callback:function ($$v) {_vm.modalReimbursement=$$v},expression:"modalReimbursement"}},[_c('b-form',{staticClass:"form-horizontal"},[_c('b-row',{staticClass:"justify-content-md-center"},[_c('b-col',{attrs:{"md":"6"}},[_c('b-form-group',{attrs:{"label":"Desde"}},[_c('date-picker',{attrs:{"lang":"es","format":"dd/MM/yyyy","input-class":"form-control"},model:{value:(_vm.from),callback:function ($$v) {_vm.from=$$v},expression:"from"}})],1)],1),_c('b-col',{attrs:{"md":"6"}},[_c('b-form-group',{attrs:{"label":"Hasta"}},[_c('date-picker',{attrs:{"lang":"es","format":"dd/MM/yyyy","input-class":"form-control"},model:{value:(_vm.to),callback:function ($$v) {_vm.to=$$v},expression:"to"}})],1)],1)],1),_c('b-row',{staticClass:"justify-content-md-center"},[_c('b-col',{attrs:{"md":"12"}},[_c('b-form-group',{attrs:{"label":"Monto máximo (USD)"}},[_c('b-form-input',{staticClass:"form-control",attrs:{"type":"number"},model:{value:(_vm.maxAmount),callback:function ($$v) {_vm.maxAmount=$$v},expression:"maxAmount"}})],1)],1)],1),_c('b-row',{staticClass:"justify-content-md-center"},[_c('b-col',{attrs:{"md":"12"}},[_c('b-form-group',{attrs:{"label":"Filtrar por"}},[_c('b-form-radio-group',{attrs:{"options":_vm.intervalOptions},model:{value:(_vm.intervalType),callback:function ($$v) {_vm.intervalType=$$v},expression:"intervalType"}})],1)],1),_c('b-col',{attrs:{"md":"12"}},[_c('b-form-group',{attrs:{"label":"Operador"}},[_c('selectize',{model:{value:(_vm.busOperator),callback:function ($$v) {_vm.busOperator=$$v},expression:"busOperator"}},_vm._l((this.operatorsForSelect),function(operator){return _c('option',{key:operator.id,domProps:{"value":operator.id}},[_vm._v(_vm._s(operator.name))])}))],1)],1),_c('b-col',{attrs:{"md":"12"}},[_c('b-form-group',{attrs:{"label":"Excluir"}},[_c('selectize',{attrs:{"multiple":"multiple"},model:{value:(_vm.excludedOperators),callback:function ($$v) {_vm.excludedOperators=$$v},expression:"excludedOperators"}},_vm._l((_vm.operators),function(operator){return _c('option',{key:operator.id,domProps:{"value":operator.id}},[_vm._v(_vm._s(operator.name))])}))],1)],1),_c('b-col',{attrs:{"md":"12"}},[_c('b-form-group',{attrs:{"label":"Categoría"}},[_c('selectize',{attrs:{"placeholder":"Elige una categoría"},model:{value:(_vm.complaintCategory),callback:function ($$v) {_vm.complaintCategory=$$v},expression:"complaintCategory"}},_vm._l((Object.keys(_vm.categories)),function(key){return _c('option',{key:key,domProps:{"value":key}},[_vm._v(_vm._s(_vm.categories[key].description))])}))],1)],1)],1),_c('b-row',{staticClass:"justify-content-md-center"},[_c('b-col',{attrs:{"md":"12"}},[_c('b-form-group',{attrs:{"label":"Total"}},[_c('b-form-input',{staticClass:"form-control",attrs:{"value":_vm._f("currency")(_vm.total,'$', 2, { thousandsSeparator: ',', decimalSeparator: '.' }),"type":"text","readonly":"readonly"}})],1)],1)],1)],1),_c('div',{attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('b-btn',{staticClass:"btn-space",attrs:{"variant":"secondary"},on:{"click":_vm.closeModal}},[_vm._v("Cancelar")]),_c('b-btn',{attrs:{"variant":"primary"},on:{"click":_vm.paypalReimburse}},[_vm._v("Reembolsar")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "cMMq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__("gRE1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_apiService__ = __webpack_require__("a/3G");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants_Status_constants__ = __webpack_require__("XXAu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__datasources_datasource__ = __webpack_require__("VU4R");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__datasources_datasource___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__datasources_datasource__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_ag_grid_vue__ = __webpack_require__("Ku5W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_ag_grid_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_ag_grid_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_dateService__ = __webpack_require__("4F1w");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint no-underscore-dangle: ["error", { "allow": ["_id"] }] */






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'all',
  data: function data() {
    return {
      rowData: null,
      columnDefs: null,
      statuses: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_3__constants_Status_constants__["a" /* default */].STATUSES, __WEBPACK_IMPORTED_MODULE_3__constants_Status_constants__["a" /* default */].STATUSES_ECOMMERCE),
      dismissSecs: 5,
      sendedMailAlert: 0,
      gridOptions: {
        floatingFilter: true,
        enableServerSideFilter: true,
        paginationPageSize: 50,
        rowModelType: 'infinite',
        rowSelection: 'multiple',
        rowMultiSelectWithClick: true,
        onRowSelected: this.onRowSelected,
        onSelectionChanged: this.onSelectionChanged
      },
      showDialog: false,
      intervalId: null
    };
  },

  components: {
    'ag-grid-vue': __WEBPACK_IMPORTED_MODULE_5_ag_grid_vue__["AgGridVue"]
  },
  beforeMount: function beforeMount() {
    this.columnDefs = [{
      headerName: 'ID Reclamo',
      field: 'id',
      cellRenderer: function cellRenderer(params) {
        if (params.data === undefined) {
          return '';
        }
        return '<a href="/#/' + (params.data.ecommerce === true ? 'complaints_ecommerce' : 'complaints') + '/' + params.data.id_string + '" target="_blank">' + params.data.id + '</a>';
      }
    }, { headerName: 'Estado', field: 'state' }, { headerName: 'Booking', field: 'booking' }, { headerName: 'Tickets', field: 'tickets' }, { headerName: 'Monto', field: 'amount' }, { headerName: 'Categoría', field: 'category', suppressSorting: true }, { headerName: 'Requerimiento', field: 'comment' }, { headerName: 'Empresa de bus', field: 'bus_operators' }, { headerName: 'Grupo de empresas', field: 'group', suppressFilter: true }, { headerName: 'Edad', field: 'age', suppressFilter: true }, { headerName: 'Fecha ingreso', field: 'created_at', suppressFilter: true }, { headerName: 'Fecha envío a empresa', field: 'sent_at', suppressFilter: true }, { headerName: 'Fecha Resuelto', field: 'resolved_at', suppressFilter: true }, { headerName: 'Correo activado', field: 'reminder', suppressFilter: true }, { headerName: 'Agente', field: 'agent_name', suppressFilter: true }];
    this.refreshReloaAppStatus();
  },
  mounted: function mounted() {
    this.fetchComplaints();
  },

  methods: {
    fetchComplaints: function fetchComplaints() {
      var $this = this;
      var dataSource = {
        rowCount: null, // behave as infinite scroll
        getRows: function getRows(params) {
          __WEBPACK_IMPORTED_MODULE_2__services_apiService__["a" /* default */].all_complaints(params.startRow, params.endRow, params.filterModel).then(function (data) {
            var rowsThisPage = $this.parseResponse(data.body.data);
            var lastRow = -1;
            if (data.body.total_rows <= params.endRow) {
              lastRow = data.body.total_rows;
            }
            params.successCallback(rowsThisPage, lastRow);
          });
        }
      };
      this.gridOptions.api.setDatasource(dataSource);
    },
    onRowSelected: function onRowSelected(event) {
      var values = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(event.node.data);
      var data = values.join(',');
      this.copyText(data);
    },
    onSelectionChanged: function onSelectionChanged() {
      var nodes = this.gridOptions.api.getSelectedNodes();
      var values = nodes.map(function (k) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(k.data).join(',');
      });
      var data = values.join('\n');
      this.copyText(data);
    },
    copyText: function copyText(text) {
      navigator.permissions.query({ name: 'clipboard-write' }).then(function (result) {
        if (result.state === 'granted' || result.state === 'prompt') {
          navigator.clipboard.writeText(text).then(function () {}, function () {});
        }
      });
    },
    complaintAge: function complaintAge(complaint) {
      return __WEBPACK_IMPORTED_MODULE_6__utils_dateService__["a" /* default */].complaintAge(complaint.created_at);
    },
    parseResponse: function parseResponse(data) {
      var _this = this;

      var processed = data.map(function (complaint) {
        var price = complaint.ticket_info && complaint.ticket_info.price;
        var currency = complaint.ticket_info && complaint.ticket_info.sold_currency;
        return {
          id: complaint.number,
          id_string: complaint._id && complaint.$oid,
          state: _this.statuses && complaint.aasm_state && _this.statuses[complaint.aasm_state] && _this.statuses[complaint.aasm_state].description,
          booking: complaint.ticket_info && complaint.ticket_info.booking_number,
          tickets: complaint.ticket_info && complaint.ticket_info.tickets,
          amount: (price || '') + ' ' + (currency || ''),
          ecommerce: complaint.ecommerce,
          category: complaint.complaint_category_id && complaint.complaint_category_id.name,
          comment: complaint.comment,
          bus_operators: complaint.ticket_info && complaint.ticket_info.bus_operators,
          group: '-',
          age: _this.complaintAge && _this.complaintAge(complaint),
          created_at: __WEBPACK_IMPORTED_MODULE_6__utils_dateService__["a" /* default */] && __WEBPACK_IMPORTED_MODULE_6__utils_dateService__["a" /* default */].getDate && complaint.created_at ? __WEBPACK_IMPORTED_MODULE_6__utils_dateService__["a" /* default */].getDate(complaint.created_at, 'DD/MM/YYYY HH:mm') : null,
          sent_at: complaint.sent_at === null ? null : __WEBPACK_IMPORTED_MODULE_6__utils_dateService__["a" /* default */] && __WEBPACK_IMPORTED_MODULE_6__utils_dateService__["a" /* default */].getDate && __WEBPACK_IMPORTED_MODULE_6__utils_dateService__["a" /* default */].getDate(complaint.sent_at, 'DD/MM/YYYY HH:mm'),
          resolved_at: complaint.approved_at === null ? null : __WEBPACK_IMPORTED_MODULE_6__utils_dateService__["a" /* default */] && __WEBPACK_IMPORTED_MODULE_6__utils_dateService__["a" /* default */].getDate && __WEBPACK_IMPORTED_MODULE_6__utils_dateService__["a" /* default */].getDate(complaint.approved_at, 'DD/MM/YYYY HH:mm'),
          reminder: complaint.reminder ? 'Si' : 'No',
          agent_name: complaint.agent_name || '-'
        };
      });
      return processed;
    },
    exportData: function exportData() {
      this.gridOptions.api.exportDataAsCsv();
    },
    exportBackup: function exportBackup() {
      this.sendedMailAlert = this.dismissSecs;
      __WEBPACK_IMPORTED_MODULE_2__services_apiService__["a" /* default */].exportComplaints();
    },
    countDownChanged: function countDownChanged(dismissCountDown) {
      this.sendedMailAlert = dismissCountDown;
    },
    searchByState: function searchByState(state) {
      var stateFilterComponent = this.gridOptions.api.getFilterInstance('state');
      stateFilterComponent.filterText = state;
      this.gridOptions.api.onFilterChanged();
    },
    refreshReloaAppStatus: function refreshReloaAppStatus() {
      var _this2 = this;

      this.intervalId = setInterval(function () {
        __WEBPACK_IMPORTED_MODULE_2__services_apiService__["a" /* default */].reloadAppStatus().then(function (response) {
          if (response.body) {
            _this2.showDialog = true;
          }
        });
      }, 900000);
    }
  },
  beforeDestroy: function beforeDestroy() {
    clearInterval(this.intervalId);
  }
});

/***/ }),

/***/ "d4Ct":
/***/ (function(module, exports) {

module.exports = {"status":{"disclaimer":{"advise":"Recorrido.cl se contactará con la empresa de bus respectiva y actuará como intermediario entre usted y esta con la finalidad de obtener una resolución a su requerimiento. Recorrido.cl no tiene incidencia en las operaciones ni el tráfico de los operadores, solo comercializamos sus pasajes a través de nuestra plataforma online.","contact":"Lo contactaremos una vez que tengamos la respuesta de la empresa de buses, le pedimos disculpas de antemano, esto puede tardar algunos días."}}}

/***/ }),

/***/ "dXrS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var icons = {};

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'icon',
  props: {
    name: {
      type: String,
      validator: function validator(val) {
        if (val) {
          if (!(val in icons)) {
            __WEBPACK_IMPORTED_MODULE_0_vue__["default"].util.warn('Invalid prop: prop "icon" is referring to an unregistered icon "' + val + '".' + '\nPlesase make sure you have imported this icon before using it.', this);
            return false;
          }
          return true;
        }
        return null;
      }
    },
    scale: [Number, String],
    spin: Boolean,
    inverse: Boolean,
    pulse: Boolean,
    flip: {
      validator: function validator(val) {
        return val === 'horizontal' || val === 'vertical';
      }
    },
    label: String
  },
  data: function data() {
    return {
      x: false,
      y: false,
      childrenWidth: 0,
      childrenHeight: 0,
      outerScale: 1
    };
  },

  computed: {
    normalizedScale: function normalizedScale() {
      var scale = this.scale;
      scale = typeof scale === 'undefined' ? 1 : Number(scale);
      if (isNaN(scale) || scale <= 0) {
        __WEBPACK_IMPORTED_MODULE_0_vue__["default"].util.warn('Invalid prop: prop "scale" should be a number over 0.', this);
        return this.outerScale;
      }
      return scale * this.outerScale;
    },
    clazz: function clazz() {
      return {
        'fa-icon': true,
        'fa-spin': this.spin,
        'fa-flip-horizontal': this.flip === 'horizontal',
        'fa-flip-vertical': this.flip === 'vertical',
        'fa-inverse': this.inverse,
        'fa-pulse': this.pulse
      };
    },
    icon: function icon() {
      if (this.name) {
        return icons[this.name];
      }
      return null;
    },
    box: function box() {
      if (this.icon) {
        return '0 0 ' + this.icon.width + ' ' + this.icon.height;
      }
      return '0 0 ' + this.width + ' ' + this.height;
    },
    ratio: function ratio() {
      if (!this.icon) {
        return 1;
      }
      var _icon = this.icon,
          width = _icon.width,
          height = _icon.height;

      return Math.max(width, height) / 16;
    },
    width: function width() {
      return this.childrenWidth || this.icon && this.icon.width / this.ratio * this.normalizedScale || 0;
    },
    height: function height() {
      return this.childrenHeight || this.icon && this.icon.height / this.ratio * this.normalizedScale || 0;
    },
    style: function style() {
      if (this.normalizedScale === 1) {
        return false;
      }
      return {
        fontSize: this.normalizedScale + 'em'
      };
    }
  },
  mounted: function mounted() {
    var _this = this;

    if (this.icon) {
      return;
    }
    this.$children.forEach(function (child) {
      child.outerScale = _this.normalizedScale;
    });
    var width = 0;
    var height = 0;
    this.$children.forEach(function (child) {
      width = Math.max(width, child.width);
      height = Math.max(height, child.height);
    });
    this.childrenWidth = width;
    this.childrenHeight = height;
    this.$children.forEach(function (child) {
      child.x = (width - child.width) / 2;
      child.y = (height - child.height) / 2;
    });
  },
  register: function register(data) {
    for (var name in data) {
      var icon = data[name];

      if (!icon.paths) {
        icon.paths = [];
      }
      if (icon.d) {
        icon.paths.push({ d: icon.d });
      }

      if (!icon.polygons) {
        icon.polygons = [];
      }
      if (icon.points) {
        icon.polygons.push({ points: icon.points });
      }

      icons[name] = icon;
    }
  },

  icons: icons
});

/***/ }),

/***/ "dnfc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"compact-switch"},[_c('input',{attrs:{"type":"checkbox","disabled":_vm.disabled},domProps:{"checked":_vm.value},on:{"change":function($event){_vm.$emit('input', $event.target.checked)}}}),_c('span',{staticClass:"slider"})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "dxC/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_apiService__ = __webpack_require__("a/3G");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants_Status_constants__ = __webpack_require__("XXAu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__perimeters_usersPerimeter__ = __webpack_require__("lBuF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue2_selectize__ = __webpack_require__("py5U");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue2_selectize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue2_selectize__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_dateService__ = __webpack_require__("4F1w");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







var parse = __webpack_require__("UVyn");

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'users',
  components: [__WEBPACK_IMPORTED_MODULE_5_vue2_selectize___default.a],
  data: function data() {
    var _this = this;

    return {
      userFields: {
        email: {
          label: 'Correo Electrónico',
          sortable: true
        },
        name: {
          label: 'Nombre',
          sortable: true
        },
        last_name: {
          label: 'Apellido',
          sortable: true
        },
        role: {
          label: 'Rol',
          formatter: function formatter(value) {
            return _this.roles[value].name;
          }
        },
        last_sign_in_at: {
          label: 'Última actividad',
          sortable: true,
          formatter: function formatter(value) {
            return __WEBPACK_IMPORTED_MODULE_6__utils_dateService__["a" /* default */].isValidDate(value);
          }
        },
        active: {
          label: 'Estado',
          formatter: function formatter(value) {
            return value ? 'Activo' : 'Inactivo';
          }
        },
        password_last_updated_at: {
          label: 'Edad de contraseña',
          sortable: true,
          formatter: function formatter(value) {
            return __WEBPACK_IMPORTED_MODULE_6__utils_dateService__["a" /* default */].isNan(value);
          }
        },
        confirmation_sent_at: {
          label: 'Edad de clave de activación',
          sortable: true,
          formatter: function formatter(value) {
            return __WEBPACK_IMPORTED_MODULE_6__utils_dateService__["a" /* default */].isNan(value);
          }
        },
        actions: { label: 'Acciones' }
      },
      users: [],
      user: {},
      modalShow: false,
      action: null,
      roles: __WEBPACK_IMPORTED_MODULE_3__constants_Status_constants__["a" /* default */].ROLES,
      search: {
        text: '',
        role: '',
        active: ''
      },
      pagination: {},
      current_page: 1,
      active_options: [{ value: '', text: 'Seleccione uno' }, { value: 'true', text: 'Activo' }, { value: 'false', text: 'Inactivo' }],
      role_options: [{ value: '', text: 'Seleccione uno' }, { value: '1', text: '🤖' }, { value: '2', text: 'CRM' }, { value: '3', text: 'ERR' }, { value: '4', text: 'EBD' }, { value: '5', text: 'FIN' }],
      subteam_options: [{ value: '', text: 'Seleccione uno' }, { value: 'EDB', text: 'EDB' }, { value: 'TD', text: 'Transbank/Devoluciones' }, { value: 'REC', text: 'Recorrido' }, { value: 'LTM', text: 'Latam Pass' }],
      showDialog: false,
      intervalId: null
    };
  },

  perimeters: [__WEBPACK_IMPORTED_MODULE_4__perimeters_usersPerimeter__["a" /* default */]],
  created: function created() {
    this.fetchUsers(1);
  },
  beforeMount: function beforeMount() {
    this.refreshReloaAppStatus();
  },

  methods: {
    fetchUsers: function fetchUsers(page) {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_2__services_apiService__["a" /* default */].get_users(page, this.search).then(function (data) {
        _this2.users = data.body;
        _this2.setPagination(data);
      });
    },
    setPagination: function setPagination(res) {
      var links = Object.prototype.hasOwnProperty.call(res.headers.map, 'links') ? parse(res.headers.map.link[0]) : null;
      var current = res.headers.map.page === undefined ? res.headers.map.Page : res.headers.map.page;
      var total = res.headers.map.total === undefined ? res.headers.map.Total : res.headers.map.total;
      var perPage = res.headers.map['per-page'] === undefined ? res.headers.map['Per-Page'] : res.headers.map['per-page'];
      var pagination = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
        current: parseInt(current, 10),
        total: parseInt(total, 10),
        per_page: parseInt(perPage, 10)
      }, links);
      this.pagination = pagination;
    },
    changePage: function changePage(page) {
      this.current_page = page;
      this.fetchUsers(page);
    },
    loadUser: function loadUser(user) {
      this.beforeEditingCache = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, user);
      this.user = user;
      this.action = 'update';
      this.modalShow = true;
    },
    createUser: function createUser() {
      this.user = {
        role: '',
        subteam: ''
      };
      this.action = 'create';
      this.modalShow = true;
    },
    registerUser: function registerUser() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_2__services_apiService__["a" /* default */].create_user(this.user).then(function () {
        _this3.modalShow = false;
        _this3.fetchUsers(1);
        _this3.$notify({
          group: 'request',
          type: 'success',
          title: 'Usuario creado con éxito',
          duration: 3000
        });
      }).catch(function (response) {
        _this3.notifyError(response);
      });
    },
    updateUser: function updateUser() {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_2__services_apiService__["a" /* default */].update_user(this.user, this.user.id).then(function () {
        _this4.action = null;
        _this4.modalShow = false;
        _this4.fetchUsers(1);
        _this4.$notify({
          group: 'request',
          type: 'success',
          title: 'Usuario modificado con éxito',
          duration: 3000
        });
      }).catch(function (response) {
        _this4.notifyError(response);
      });
    },
    closeModal: function closeModal(user) {
      if (this.action === 'update') {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(user, this.beforeEditingCache);
      } else {
        this.user = {
          role: '',
          subteam: ''
        };
      }
      this.$validator.reset();
      this.action = null;
      this.modalShow = false;
    },
    onSubmit: function onSubmit(event) {
      var _this5 = this;

      event.preventDefault();
      this.$validator.validate().then(function (valid) {
        if (valid) {
          if (_this5.action === 'create') {
            _this5.registerUser();
          } else {
            _this5.updateUser();
          }
        }
      });
    },
    notifyError: function notifyError(response) {
      if (response.body.email) {
        this.errors.add({
          field: 'user[email]',
          msg: 'El correo electrónico utilizado ya está asociado a otro usuario'
        });
      } else {
        this.$notify({
          group: 'request',
          type: 'error',
          title: 'Error',
          text: response.body,
          duration: 3000
        });
      }
    },
    deleteUser: function deleteUser(user) {
      var _this6 = this;

      this.$dialog.confirm({
        title: 'Eliminar usuario',
        body: '\xBFEst\xE1s seguro que deseas borrar al usuario ' + user.name + '?'
      }).then(function () {
        __WEBPACK_IMPORTED_MODULE_2__services_apiService__["a" /* default */].delete_user(user.id).then(function () {
          _this6.fetchUsers(1);
          _this6.$notify({
            group: 'request',
            type: 'success',
            title: 'Usuario eliminado con éxito',
            duration: 3000
          });
        });
      }).catch(function () {});
    },
    recoverPassword: function recoverPassword(user) {
      var _this7 = this;

      __WEBPACK_IMPORTED_MODULE_2__services_apiService__["a" /* default */].recover_password(user.id).then(function () {
        _this7.fetchUsers(1);
        _this7.$notify({
          group: 'request',
          type: 'success',
          title: 'Correo de recuperación enviado con éxito',
          duration: 3000
        });
      });
    },
    shiftActive: function shiftActive(user) {
      var _this8 = this;

      this.$dialog.confirm({
        title: (user.active ? 'Desactivar' : 'Activar') + ' cuenta.',
        body: '\xBFEst\xE1s seguro que deseas ' + (user.active ? 'desactivar' : 'activar') + ' la cuenta de ' + user.name + '?'
      }).then(function () {
        __WEBPACK_IMPORTED_MODULE_2__services_apiService__["a" /* default */].shift_active(user.id).then(function () {
          _this8.fetchUsers(1);
          _this8.$notify({
            group: 'request',
            type: 'success',
            title: 'Cuenta ' + (user.active ? 'desactivada' : 'reactivada') + ' con \xE9xito',
            duration: 3000
          });
        });
      }).catch(function () {});
    },
    refreshReloaAppStatus: function refreshReloaAppStatus() {
      var _this9 = this;

      this.intervalId = setInterval(function () {
        __WEBPACK_IMPORTED_MODULE_2__services_apiService__["a" /* default */].reloadAppStatus().then(function (response) {
          if (response.body) {
            _this9.showDialog = true;
          }
        });
      }, 900000);
    }
  },
  beforeDestroy: function beforeDestroy() {
    clearInterval(this.intervalId);
  }
});

/***/ }),

/***/ "fU6e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('notifications',{attrs:{"group":"request","position":"top center"}}),_c('ReloadAppDialog',{attrs:{"showDialog":_vm.showDialog}}),_c('b-form',{staticClass:"form-horizontal",on:{"submit":function($event){$event.preventDefault();_vm.create($event)}}},[_c('b-row',[_c('b-col',[_c('b-form-group',{attrs:{"label":"ID Zendesk (separar con comas)"}},[(_vm.loader)?_c('icon',{staticClass:"loader-in-field",attrs:{"name":"refresh","spin":"spin"}}):_vm._e(),_c('input-tag',{attrs:{"on-change":_vm.fetchData,"tags":_vm.complaint.zendesk,"validate":'digits',"required":"required"}})],1),_c('b-form-group',{attrs:{"label":"Categoría"}},[_c('selectize',{attrs:{"name":"complaint[category]","placeholder":"Elige una categoría","required":"required"},model:{value:(_vm.complaint.category),callback:function ($$v) {_vm.complaint.category=$$v},expression:"complaint.category"}},_vm._l((Object.keys(_vm.categories).splice(0, Object.keys(_vm.categories).length - 1)),function(key){return _c('option',{key:key,domProps:{"value":key}},[_vm._v(_vm._s(_vm.categories[key].description))])}))],1),_c('b-form-group',{attrs:{"label":"Exigencia"}},[_c('b-form-input',{staticClass:"form-control",attrs:{"name":"complaint[comment]","type":"text","placeholder":_vm.description_placeholder,"required":"required"},model:{value:(_vm.complaint.comment),callback:function ($$v) {_vm.complaint.comment=(typeof $$v === 'string'? $$v.trim(): $$v)},expression:"complaint.comment"}})],1),_c('b-form-group',{attrs:{"label":"Reclamante"}},[_c('b-form-input',{staticClass:"form-control",attrs:{"name":"complaint[issuer]","type":"text","placeholder":_vm.name_placeholder,"required":"required"},model:{value:(_vm.complaint.issuer_name),callback:function ($$v) {_vm.complaint.issuer_name=(typeof $$v === 'string'? $$v.trim(): $$v)},expression:"complaint.issuer_name"}})],1),_c('b-form-group',{attrs:{"label":"Género del reclamante"}},[_c('b-form-radio-group',{attrs:{"options":[{ text: 'Hombre', value: 'male' }, { text: 'Mujer', value: 'female' }],"name":"genderSelector"},model:{value:(_vm.complaint.issuer_gender),callback:function ($$v) {_vm.complaint.issuer_gender=$$v},expression:"complaint.issuer_gender"}})],1),(_vm.complaint.description)?_c('b-form-group',{attrs:{"label":"Texto Original"}},[_c('b-form-textarea',{staticClass:"form-control",attrs:{"rows":6,"name":"complaint[description]","placeholder":"Texto Original del Cliente","tabindex":"-1","readonly":"readonly"},model:{value:(_vm.complaint.description),callback:function ($$v) {_vm.complaint.description=(typeof $$v === 'string'? $$v.trim(): $$v)},expression:"complaint.description"}})],1):_vm._e(),(_vm.complaint.first_contact)?_c('b-form-group',{attrs:{"label":"Primer contacto"}},[_c('b-form-input',{staticClass:"form-control",attrs:{"name":"complaint[first_contact]","type":"text","tabindex":"-1","readonly":"readonly"},model:{value:(_vm.complaint.first_contact),callback:function ($$v) {_vm.complaint.first_contact=$$v},expression:"complaint.first_contact"}})],1):_vm._e(),(_vm.complaint.last_contact)?_c('b-form-group',{attrs:{"label":"Último Contacto"}},[_c('b-form-input',{staticClass:"form-control",attrs:{"name":"complaint[last_contact]","type":"text","tabindex":"-1","readonly":"readonly"},model:{value:(_vm.complaint.last_contact),callback:function ($$v) {_vm.complaint.last_contact=$$v},expression:"complaint.last_contact"}})],1):_vm._e()],1),_c('b-col',[_c('b-form-group',{attrs:{"label":"Número de Compra"}},[_c('b-input-group',[_c('b-form-input',{on:{"input":_vm.onSearchChange},model:{value:(_vm.complaint.ticket_info.booking_number),callback:function ($$v) {_vm.complaint.ticket_info.booking_number=$$v},expression:"complaint.ticket_info.booking_number"}}),_c('b-input-group-button',{attrs:{"slot":"right"},slot:"right"},[_c('div',{staticClass:"get-tickets-response",class:_vm.ticketResponseClass},[(_vm.getTicketsLoader)?_c('icon',{attrs:{"name":"refresh","spin":"spin"}}):_vm._e(),(_vm.getTicketsError)?_c('icon',{attrs:{"name":"times"}}):_vm._e()],1),_c('b-btn',{attrs:{"variant":"primary"},on:{"click":function($event){_vm.getTickets()}}},[_vm._v("Buscar")])],1)],1)],1),(_vm.booking_tickets.length > 0)?_c('b-form-group',{attrs:{"label":"Pasajes"}},[_c('selectize',{attrs:{"multiple":"multiple","select-size":4,"plain":true,"placeholder":"Elige un pasaje","required":"required"},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}},_vm._l((_vm.booking_tickets),function(t){return _c('option',{key:t.id,domProps:{"value":t.number}},[_vm._v(_vm._s(((t.number) + " " + (t.departure) + " - " + (t.destination) + " (" + (t.inbound ? 'Vuelta' : 'Ida') + ")")))])})),_c('small',[_c('strong',[_vm._v("Selecciona los pasajes afectados.")])])],1):_vm._e(),(_vm.complaint.source === 'voice' && _vm.complaint.category === '3')?_c('b-form-group',{attrs:{"label":"Correo cliente"}},[_c('b-form-input',{staticClass:"form-control form-control",attrs:{"name":"complaint[ticket_info][email]","type":"text"},model:{value:(_vm.complaint.ticket_info.email),callback:function ($$v) {_vm.complaint.ticket_info.email=$$v},expression:"complaint.ticket_info.email"}})],1):_vm._e(),(_vm.booking_tickets.length > 0)?_c('b-form-group',{attrs:{"label":"Nombre del pasajero"}},[_c('b-form-input',{attrs:{"disabled":"disabled","value":_vm.complaint.ticket_info.fullname}})],1):_vm._e(),(_vm.complaint.ticket_info.bus_operators.length > 0)?_c('b-form-group',{attrs:{"label":"Empresas"}},[_c('b-form-input',{staticClass:"form-control",attrs:{"value":_vm.formatOperator(_vm.complaint.ticket_info.bus_operators),"name":"complaint[ticket_info][bus_operators]","type":"text","readonly":"readonly"}})],1):_vm._e(),(_vm.complaint.ticket_info.origin)?_c('b-form-group',{attrs:{"label":"Origen"}},[_c('b-form-input',{staticClass:"form-control form-control",attrs:{"name":"complaint[ticket_info][origin]","type":"text","readonly":"readonly"},model:{value:(_vm.complaint.ticket_info.origin),callback:function ($$v) {_vm.complaint.ticket_info.origin=$$v},expression:"complaint.ticket_info.origin"}})],1):_vm._e(),(_vm.complaint.ticket_info.destination)?_c('b-form-group',{attrs:{"label":"Destino"}},[_c('b-form-input',{staticClass:"form-control form-control",attrs:{"name":"complaint[ticket_info][destination]","type":"text","readonly":"readonly"},model:{value:(_vm.complaint.ticket_info.destination),callback:function ($$v) {_vm.complaint.ticket_info.destination=$$v},expression:"complaint.ticket_info.destination"}})],1):_vm._e(),(_vm.complaint.ticket_info.departure_date)?_c('b-form-group',{attrs:{"label":"Fecha de salida (Ida)"}},[_c('b-form-input',{staticClass:"form-control form-control",attrs:{"name":"complaint[ticket_info][departure_date]","type":"text","readonly":"readonly"},model:{value:(_vm.complaint.ticket_info.departure_date),callback:function ($$v) {_vm.complaint.ticket_info.departure_date=$$v},expression:"complaint.ticket_info.departure_date"}})],1):_vm._e(),(_vm.complaint.ticket_info.departure_hour)?_c('b-form-group',{attrs:{"label":"Hora de salida (Ida)"}},[_c('b-form-input',{staticClass:"form-control",attrs:{"name":"complaint[ticket_info][departure_hour]","type":"text","readonly":"readonly"},model:{value:(_vm.complaint.ticket_info.departure_hour),callback:function ($$v) {_vm.complaint.ticket_info.departure_hour=$$v},expression:"complaint.ticket_info.departure_hour"}})],1):_vm._e(),(_vm.complaint.ticket_info.arrival_date)?_c('b-form-group',{attrs:{"label":"Fecha de salida (Vuelta)"}},[_c('b-form-input',{staticClass:"form-control",attrs:{"name":"complaint[ticket_info][arrival_date]","type":"text","readonly":"readonly"},model:{value:(_vm.complaint.ticket_info.arrival_date),callback:function ($$v) {_vm.complaint.ticket_info.arrival_date=$$v},expression:"complaint.ticket_info.arrival_date"}})],1):_vm._e(),(_vm.complaint.ticket_info.arrival_hour)?_c('b-form-group',{attrs:{"label":"Hora de salida (Vuelta)"}},[_c('b-form-input',{staticClass:"form-control",attrs:{"name":"complaint[ticket_info][arrival_hour]","type":"text","readonly":"readonly"},model:{value:(_vm.complaint.ticket_info.arrival_hour),callback:function ($$v) {_vm.complaint.ticket_info.arrival_hour=$$v},expression:"complaint.ticket_info.arrival_hour"}})],1):_vm._e(),(_vm.complaint.ticket_info.payment_method)?_c('b-form-group',{attrs:{"label":"Método de Pago"}},[_c('b-form-input',{staticClass:"form-control",attrs:{"name":"complaint[ticket_info][payment_method]","type":"text","readonly":"readonly"},model:{value:(_vm.complaint.ticket_info.payment_method),callback:function ($$v) {_vm.complaint.ticket_info.payment_method=$$v},expression:"complaint.ticket_info.payment_method"}})],1):_vm._e(),(_vm.complaint.ticket_info.price)?_c('b-form-group',{attrs:{"label":"Monto Total"}},[_c('b-form-input',{staticClass:"form-control",attrs:{"name":"complaint[ticket_info][price]","type":"text","readonly":"readonly"},model:{value:(_vm.complaint.ticket_info.price),callback:function ($$v) {_vm.complaint.ticket_info.price=$$v},expression:"complaint.ticket_info.price"}})],1):_vm._e(),(_vm.complaint.ticket_info.price_ibc)?_c('b-form-group',{attrs:{"label":"Monto Total IBC"}},[_c('b-form-input',{staticClass:"form-control",attrs:{"name":"complaint[ticket_info][price_ibc]","type":"text","readonly":"readonly"},model:{value:(_vm.complaint.ticket_info.price_ibc),callback:function ($$v) {_vm.complaint.ticket_info.price_ibc=$$v},expression:"complaint.ticket_info.price_ibc"}})],1):_vm._e()],1)],1),_c('b-form-group',{staticClass:"text-center"},[_c('b-button',{staticClass:"positive-action btn-lg",attrs:{"type":"submit","variant":"primary"}},[_vm._v("Abrir reclamo")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "fcFS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__form_input__ = __webpack_require__("qRo1");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__form_input__["a" /* default */]);

/***/ }),

/***/ "ff44":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gG4h":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gR+i":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__basePerimeter__ = __webpack_require__("G0wa");


/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_0__basePerimeter__["a" /* default */]({
  purpose: 'categories',
  govern: {
    'can route': function route() {
      return this.isAdmin();
    },
    'can editCategories': function editCategories() {
      return this.isAdmin();
    }
  }
}));

/***/ }),

/***/ "gs9z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PopoverDetail_vue__ = __webpack_require__("p8o/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_66d5a561_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_PopoverDetail_vue__ = __webpack_require__("ZInL");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PopoverDetail_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_66d5a561_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_PopoverDetail_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "hTEU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants_Status_constants__ = __webpack_require__("XXAu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue2_selectize__ = __webpack_require__("py5U");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue2_selectize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue2_selectize__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_apiService__ = __webpack_require__("a/3G");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vee_validate__ = __webpack_require__("sUu7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_dni__ = __webpack_require__("Eayd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_dni___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_dni__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery__ = __webpack_require__("7t+N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_jquery__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'StatusBankAccountForm',
  props: {
    complaint: {}
  },
  data: function data() {
    return {
      banks: __WEBPACK_IMPORTED_MODULE_0__constants_Status_constants__["a" /* default */].BANKS,
      documents: __WEBPACK_IMPORTED_MODULE_0__constants_Status_constants__["a" /* default */].DOCUMENTS,
      accounts: []
    };
  },
  beforeMount: function beforeMount() {
    __WEBPACK_IMPORTED_MODULE_3_vee_validate__["b" /* Validator */].extend('rut', __WEBPACK_IMPORTED_MODULE_4_vue_dni__["rutValidator"]);
    if (this.complaint.bank_account === null) {
      this.complaint.bank_account = {};
    }
    if (this.complaint.country === 'PE') {
      var options = __WEBPACK_IMPORTED_MODULE_0__constants_Status_constants__["a" /* default */].ACCOUNTS;
      options = options.filter(function (word) {
        return word.code !== 0;
      });
      this.accounts = options;
    } else if (this.complaint.country === 'CL' && this.complaint.bank_account.bank !== undefined) {
      this.account_types(this.complaint.bank_account.bank);
    }
  },

  components: {
    Selectize: __WEBPACK_IMPORTED_MODULE_1_vue2_selectize___default.a
  },
  computed: {
    bank_button: function bank_button() {
      return this.complaint.bank_account.name === undefined ? 'Ingresar' : 'Actualizar';
    }
  },
  methods: {
    account_types: function account_types(event) {
      if (['COOPEUCH', 'BANCO ITAU'].includes(event)) {
        this.accounts = __WEBPACK_IMPORTED_MODULE_0__constants_Status_constants__["a" /* default */].ACCOUNTS.filter(function (word) {
          return word.code !== 2;
        });
      } else {
        this.accounts = __WEBPACK_IMPORTED_MODULE_0__constants_Status_constants__["a" /* default */].ACCOUNTS;
      }
      __WEBPACK_IMPORTED_MODULE_5_jquery___default()('#account-type').selectize().clear();
      __WEBPACK_IMPORTED_MODULE_5_jquery___default()('#account-type').selectize().clearOptions();
      __WEBPACK_IMPORTED_MODULE_5_jquery___default()('#account-type').selectize().refreshOptions(false);
    },
    updateBank: function updateBank() {
      var $this = this;
      this.$validator.validateAll().then(function (valid) {
        if (valid) {
          __WEBPACK_IMPORTED_MODULE_2__services_apiService__["a" /* default */].status_bank($this.$route.params.complaint_id, {
            bank_account: $this.complaint.bank_account
          }).then(function () {
            $this.$refs.bankModal.show();
          }).catch(function () {});
        }
      });
    },
    closeModal: function closeModal() {
      this.$refs.bankModal.hide();
      this.$emit('fetchComplaint');
    }
  }
});

/***/ }),

/***/ "jaqg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "jteb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_apiService__ = __webpack_require__("a/3G");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_Status_constants__ = __webpack_require__("XXAu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_img_recorrido_logo_monochrome_black_svg__ = __webpack_require__("krvD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_img_recorrido_logo_monochrome_black_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_img_recorrido_logo_monochrome_black_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_img_reject_icon_svg__ = __webpack_require__("Pn1R");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_img_reject_icon_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_img_reject_icon_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_img_approve_icon_svg__ = __webpack_require__("oMfB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_img_approve_icon_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__assets_img_approve_icon_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_img_message_icon_svg__ = __webpack_require__("amQy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_img_message_icon_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__assets_img_message_icon_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_img_transfer_icon_svg__ = __webpack_require__("AkGe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_img_transfer_icon_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__assets_img_transfer_icon_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_img_request_icon_png__ = __webpack_require__("/gGb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_img_request_icon_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__assets_img_request_icon_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_forms_StatusBankAccountForm__ = __webpack_require__("4ZhY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_dateService__ = __webpack_require__("4F1w");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'status',
  data: function data() {
    return {
      accounts: [],
      bank_info: {},
      banks: __WEBPACK_IMPORTED_MODULE_1__constants_Status_constants__["a" /* default */].BANKS,
      complaint: {},
      rejectIcon: __WEBPACK_IMPORTED_MODULE_3__assets_img_reject_icon_svg___default.a,
      approveIcon: __WEBPACK_IMPORTED_MODULE_4__assets_img_approve_icon_svg___default.a,
      messageIcon: __WEBPACK_IMPORTED_MODULE_5__assets_img_message_icon_svg___default.a,
      transferIcon: __WEBPACK_IMPORTED_MODULE_6__assets_img_transfer_icon_svg___default.a,
      requestIcon: __WEBPACK_IMPORTED_MODULE_7__assets_img_request_icon_png___default.a,
      payment_method: '',
      wizard_status: '',
      max: 16,
      paypal_email_confirmation: '',
      paypal_email: ''
    };
  },
  beforeMount: function beforeMount() {
    this.fetchComplaint();
  },

  components: {
    StatusBankAccountForm: __WEBPACK_IMPORTED_MODULE_8__components_forms_StatusBankAccountForm__["a" /* default */]
  },
  computed: {
    complaintOlderThanAWeek: function complaintOlderThanAWeek() {
      return __WEBPACK_IMPORTED_MODULE_9__utils_dateService__["a" /* default */].isAfterAWeek(this.complaint.created_at);
    },
    issuer_name: function issuer_name() {
      var name = this.complaint.source === 'voice' ? this.complaint.ticket_info.fullname : this.complaint.issuer_name || 'cliente';
      return name;
    },
    setFormalOpening: function setFormalOpening() {
      var formalOpening = 'Estimad';
      if (this.complaint.issuer_gender === null) {
        formalOpening += 'o/a';
      } else if (this.complaint.issuer_gender === 'male') {
        formalOpening += 'o';
      } else if (this.complaint.issuer_gender === 'female') {
        formalOpening += 'a';
      }
      return formalOpening;
    },
    logo: function logo() {
      return __WEBPACK_IMPORTED_MODULE_2__assets_img_recorrido_logo_monochrome_black_svg___default.a;
    }
  },
  methods: {
    handleUpdatePaypalAccount: function handleUpdatePaypalAccount() {
      var _this = this;

      var $this = this;
      this.$validator.validateAll().then(function (valid) {
        if (valid) {
          if ($this.paypal_email === $this.complaint.reimbursement.paypal_email) {
            _this.$dialog.confirm('El pago a esta cuenta de paypal fue rechazado anteriormente, ¿está seguro de querer ingresar esta cuenta nuevamente?', _this.dialogOptions).then(function () {
              _this.updatePaypalAccount();
            });
          } else {
            _this.updatePaypalAccount();
          }
        }
      });
    },
    updatePaypalAccount: function updatePaypalAccount() {
      var $this = this;
      __WEBPACK_IMPORTED_MODULE_0__services_apiService__["a" /* default */].status_paypal_account($this.$route.params.complaint_id, {
        paypal_account: $this.paypal_email
      }).then(function () {
        $this.$refs.paypalModal.show();
      }).catch(function () {});
    },
    closeModal: function closeModal() {
      this.$refs.paypalModal.hide();
      this.fetchComplaint();
    },
    fetchComplaint: function fetchComplaint() {
      var _this2 = this;

      var $this = this;
      __WEBPACK_IMPORTED_MODULE_0__services_apiService__["a" /* default */].status(this.$route.params.complaint_id).then(function (data) {
        $this.complaint = data.body;
        if ($this.complaint.bank_account === null && $this.complaint.country === 'CL') {
          $this.complaint.bank_account = {
            account_type: 0
          };
        }
        document.title = 'Reclamo #' + $this.complaint.number + ' | Kexa';
        setTimeout(function () {
          return $this.activeClass();
        }, 0);
        if (true) {
          _this2.$ga.page(_this2.$router);
          _this2.$ga.event('public_view', 'pageview', 'Reclamo #' + $this.complaint.number);
        }
      });
    },
    addFile: function addFile(id) {
      document.getElementById('requestFile').click();
      this.request_id = id;
    },
    uploadFile: function uploadFile() {
      var _this3 = this;

      var formData = new FormData();
      formData.append('request_id', this.request_id);
      formData.append('file', document.getElementById('requestFile').files[0]);
      __WEBPACK_IMPORTED_MODULE_0__services_apiService__["a" /* default */].status_submit(this.$route.params.complaint_id, formData).then(function () {
        _this3.fetchComplaint();
      }).catch(function () {
        _this3.$notify({
          group: 'status',
          type: 'error',
          title: 'Error',
          text: 'Ocurrió un error al subir el archivo',
          duration: 3000
        });
      });
    },
    activeClass: function activeClass() {
      var wizardActiveStep = 'active-step';
      var thirdGroup = ['approved_bank', 'approved_reimbursement', 'approved_communication', 'closed', 'rejected', 'expired'];
      var currentAasmState = this.complaint.aasm_state;
      var secondItem = document.querySelector('.a-wizard-step:nth-child(2)');
      var thirdItem = document.querySelector('.a-wizard-step:nth-child(3)');

      if (currentAasmState !== undefined && currentAasmState !== 'open') {
        if (thirdGroup.includes(currentAasmState)) {
          thirdItem.classList.add(wizardActiveStep);
          this.wizard_status = 'resolved';
        } else {
          secondItem.classList.add(wizardActiveStep);
          this.wizard_status = 'review';
        }
      }
    },
    openInformationRequestTab: function openInformationRequestTab() {
      document.querySelector('[id^="tab-information-request"].nav-link').click();
    },
    customFormat: function customFormat(value) {
      return __WEBPACK_IMPORTED_MODULE_9__utils_dateService__["a" /* default */].customFormat(value);
    },
    getExpiredMessage: function getExpiredMessage() {
      switch (this.complaint.ticket_info.payment_method) {
        case 'PayPal':
          return 'Pasaron 3 meses desde que el reclamo fue aprobado y no se logró realizar el reembolso a través de Paypal';
        case 'Payu Crédito/Débito':
          return 'Pasaron 3 meses desde que el reclamo fue aprobado y no se logró realizar el reembolso a través de PayU';
        default:
          if (this.complaint.bank_account.bank === undefined) {
            return 'Pasaron 3 meses desde que el reclamo fue aprobado y el cliente no envió sus datos bancarios para realizar el reembolso';
          }
          return 'Pasaron 3 meses desde que se intentó realizar el reembolso pero los datos bancarios eran incorrectos y el cliente no los envió nuevamente';
      }
    }
  }
});

/***/ }),

/***/ "jvgQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kJiG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__form_file__ = __webpack_require__("9NuQ");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__form_file__["a" /* default */]);

/***/ }),

/***/ "kKUE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ToggleSwitch_vue__ = __webpack_require__("lR2t");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_af4488d8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_ToggleSwitch_vue__ = __webpack_require__("dnfc");
function injectStyle (ssrContext) {
  __webpack_require__("TQg0")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-af4488d8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ToggleSwitch_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_af4488d8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_ToggleSwitch_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "kYY1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_apiService__ = __webpack_require__("a/3G");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__("YaEn");
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'confirm_email',
  data: function data() {
    return {
      id: ''
    };
  },
  mounted: function mounted() {
    var _this = this;

    if (this.$route.query.uct !== undefined) {
      __WEBPACK_IMPORTED_MODULE_0__services_apiService__["a" /* default */].confirm_email(this.$route.query.uct).then(function (data) {
        _this.id = data.bodyText;
        _this.notifyMessage('success', 'Confirmado', 'El correo fue confirmado exitosamente');
      }).catch(function () {
        _this.notifyMessage('error', 'Error', 'El usuario no fue encontrado o ya esta activo');
      });
    } else {
      this.notifyMessage('error', 'Error', 'El token no esta presente');
    }
  },

  methods: {
    notifyMessage: function notifyMessage(type, title, message) {
      var _this2 = this;

      this.$notify({
        group: 'auth',
        type: type,
        title: title,
        text: message,
        duration: 5000
      });
      if (type === 'success') {
        setTimeout(function () {
          return __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */].push({ name: 'password_creation', params: { uct: _this2.$route.query.uct } });
        }, 5000);
      } else {
        setTimeout(function () {
          return __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */].push({ name: 'login' });
        }, 5000);
      }
    }
  }
});

/***/ }),

/***/ "krvD":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "lBuF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__basePerimeter__ = __webpack_require__("G0wa");


/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_0__basePerimeter__["a" /* default */]({
  purpose: 'users',
  govern: {
    'can route': function route() {
      return this.isAdmin();
    },
    'can createUser': function createUser() {
      return this.isAdmin();
    }
  }
}));

/***/ }),

/***/ "lE44":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_All_vue__ = __webpack_require__("cMMq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ef5241ae_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_All_vue__ = __webpack_require__("Momf");
function injectStyle (ssrContext) {
  __webpack_require__("6nbN")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_All_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ef5241ae_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_All_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "lR2t":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ToggleSwitch',
  props: {
    value: Boolean,
    disabled: {
      type: Boolean,
      default: false
    }
  }
});

/***/ }),

/***/ "lc2m":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ShowComplaintEcommerce_vue__ = __webpack_require__("/1ZK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3cbef9e1_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_ShowComplaintEcommerce_vue__ = __webpack_require__("7Upu");
function injectStyle (ssrContext) {
  __webpack_require__("+RXk")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ShowComplaintEcommerce_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3cbef9e1_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_ShowComplaintEcommerce_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "lcc6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{attrs:{"width":"30%","title":"⚠️ Atención","no-close-on-backdrop":"no-close-on-backdrop","hide-header-close":"hide-header-close","show-close":false},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[_c('div',{staticClass:"modal-body"},[_c('p',{staticClass:"text"},[_vm._v("Hemos realizado algunos cambios en la aplicación, por favor recarga para continuar.")])]),_c('div',{attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('b-btn',{attrs:{"variant":"primary"},on:{"click":_vm.realoadApp}},[_vm._v("Recargar")])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "lgUc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TemplateModalEditor_vue__ = __webpack_require__("aUvd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6431988c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_TemplateModalEditor_vue__ = __webpack_require__("F6JL");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TemplateModalEditor_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6431988c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_TemplateModalEditor_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "mc/t":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "mfjq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Complaints_vue__ = __webpack_require__("XOzM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_13b3510a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Complaints_vue__ = __webpack_require__("FKAQ");
function injectStyle (ssrContext) {
  __webpack_require__("Q8mS")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Complaints_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_13b3510a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Complaints_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "nKb+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_Url_constants__ = __webpack_require__("M1ba");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'login',
  data: function data() {
    return {
      loader: false,
      email: '',
      password: ''
    };
  },

  methods: {
    login: function login() {
      var _this = this;

      this.loader = true;
      this.infoError = false;
      this.$http.post(__WEBPACK_IMPORTED_MODULE_2__constants_Url_constants__["a" /* default */].TOKEN_URL, {
        auth: {
          email: this.email,
          password: this.password
        }
      }).then(function (response) {
        __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].commit('login', response.body.jwt);
        __WEBPACK_IMPORTED_MODULE_0__router__["a" /* default */].push('/complaints');
      }, function (response) {
        var error = response.status === 423 ? 'Cuenta inactiva' : 'El inicio de sesión falló. Inténtalo de nuevo.';
        _this.$notify({
          group: 'auth',
          type: 'error',
          title: 'Error',
          text: error,
          duration: 10000
        });
        _this.loader = false;
        _this.password = '';
      });
    }
  }
});

/***/ }),

/***/ "nOi6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__basePerimeter__ = __webpack_require__("G0wa");


/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_0__basePerimeter__["a" /* default */]({
  purpose: 'finance',
  govern: {
    'can route': function route() {
      return this.isAdmin() || this.isFDP();
    }
  }
}));

/***/ }),

/***/ "oMfB":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCA0MCA0MCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48dGl0bGU+YXBwcm92ZS1pY29uPC90aXRsZT48ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxwYXRoIGQ9Ik00MCAyMGMwIDExLTkgMjAtMjAgMjBTMCAzMSAwIDIwIDkgMCAyMCAwczIwIDkgMjAgMjB6IiBmaWxsPSIjMjVBRTg4Ii8+PHBhdGggc3Ryb2tlPSIjRkZGIiBzdHJva2Utd2lkdGg9IjEuNiIgZD0iTTMwLjQgMTJMMTcuNiAyNi40bC04LTYuNCIvPjwvZz48L3N2Zz4="

/***/ }),

/***/ "oSgn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticClass:"justify-content-md-center"},[_c('ReloadAppDialog',{attrs:{"showDialog":_vm.showDialog}}),_c('TemplateModalEditor',{attrs:{"showDialog":_vm.templateModalOpen,"text":_vm.templateModalText},on:{"close":_vm.handleTemplateModalClose,"cancel":_vm.handleTemplateModalCancel}}),_c('notifications',{attrs:{"group":"request","position":"top center"}}),_c('b-col',{attrs:{"md":"12"}},[_c('h2',{staticClass:"text-center"},[_vm._v("Abrir Reclamo pre-aprobado")])]),_c('b-col',{attrs:{"md":"2"}}),_c('hr'),_c('b-col',{attrs:{"md":"12"}},[_c('b-form',{staticClass:"form-horizontal",on:{"submit":function($event){$event.preventDefault();_vm.create($event)}}},[_c('b-row',[_c('b-col',{attrs:{"md":"2"}}),_c('b-col',[_c('b-row',[_c('b-col',{attrs:{"md":"3"}},[_c('label',[_vm._v("Número de Compra")])]),_c('b-col',{attrs:{"md":"9"}},[_c('b-input-group',[_c('b-form-input',{model:{value:(_vm.complaint.ticket_info.booking_number),callback:function ($$v) {_vm.complaint.ticket_info.booking_number=$$v},expression:"complaint.ticket_info.booking_number"}}),_c('b-input-group-button',{attrs:{"slot":"right"},slot:"right"}),_c('div',{staticClass:"get-tickets-response",class:_vm.ticketResponseClass},[(_vm.getTicketsLoader && !_vm.getTicketsError)?_c('icon',{attrs:{"name":"refresh","spin":"spin"}}):_vm._e(),(_vm.getTicketsError)?_c('icon',{attrs:{"name":"times"}}):_vm._e(),(_vm.booking_tickets.length > 0 && !_vm.getTicketsError && !_vm.getTicketsLoader)?_c('icon',{attrs:{"name":"check"}}):_vm._e()],1),_c('b-btn',{attrs:{"variant":"primary"},on:{"click":function($event){_vm.getTickets()}}},[_vm._v("Buscar")])],1)],1)],1),_c('b-form-group',[_c('br'),(_vm.booking_tickets.length > 0)?_c('b-row',[_c('b-col',{attrs:{"md":"3"}},[_c('label',[_vm._v("Pasajes")])]),_c('b-col',{attrs:{"md":"9"}},[_c('selectize',{attrs:{"multiple":"multiple","select-size":4,"plain":true,"placeholder":"Elige un pasaje"},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}},_vm._l((_vm.booking_tickets),function(t){return _c('option',{key:t.id,domProps:{"value":t.number}},[_vm._v(_vm._s(((t.number) + " " + (t.departure) + " - " + (t.destination) + " (" + (t.inbound ? 'Vuelta' : 'Ida') + ")")))])})),_c('small',[_vm._v("Selecciona los pasajes afectados.")])],1),_c('b-col',{attrs:{"md":"3"}},[_c('label',[_vm._v("Reclamante")])]),_c('b-col',{attrs:{"md":"9"}},[_c('b-form-group',[_c('b-form-input',{model:{value:(_vm.complaint.ticket_info.fullname),callback:function ($$v) {_vm.complaint.ticket_info.fullname=$$v},expression:"complaint.ticket_info.fullname"}})],1)],1),_c('b-col',{attrs:{"md":"3"}},[_c('label',[_vm._v("Género del reclamante")])]),_c('b-col',{attrs:{"md":"9"}},[_c('b-form-group',[_c('b-form-radio-group',{attrs:{"options":[{ text: 'Hombre', value: 'male' }, { text: 'Mujer', value: 'female' }],"name":"genderSelector"},model:{value:(_vm.complaint.issuer_gender),callback:function ($$v) {_vm.complaint.issuer_gender=$$v},expression:"complaint.issuer_gender"}})],1)],1)],1):_vm._e()],1),(_vm.complaint.ticket_info.bus_operators.length > 0)?_c('b-form-group',{attrs:{"label":"Empresas"}},[_c('b-form-input',{staticClass:"form-control",attrs:{"value":_vm.formatOperator(_vm.complaint.ticket_info.bus_operators),"name":"complaint[ticket_info][bus_operators]","type":"text","readonly":"readonly"}})],1):_vm._e(),(_vm.complaint.ticket_info.departure_date)?_c('b-form-group',{attrs:{"label":"Fecha de salida (Ida)"}},[_c('b-form-input',{staticClass:"form-control form-control",attrs:{"name":"complaint[ticket_info][departure_date]","type":"text","readonly":"readonly"},model:{value:(_vm.complaint.ticket_info.departure_date),callback:function ($$v) {_vm.complaint.ticket_info.departure_date=$$v},expression:"complaint.ticket_info.departure_date"}})],1):_vm._e(),(_vm.complaint.ticket_info.departure_hour)?_c('b-form-group',{attrs:{"label":"Hora de salida (Ida)"}},[_c('b-form-input',{staticClass:"form-control",attrs:{"name":"complaint[ticket_info][departure_hour]","type":"text","readonly":"readonly"},model:{value:(_vm.complaint.ticket_info.departure_hour),callback:function ($$v) {_vm.complaint.ticket_info.departure_hour=$$v},expression:"complaint.ticket_info.departure_hour"}})],1):_vm._e(),(_vm.complaint.ticket_info.arrival_date)?_c('b-form-group',{attrs:{"label":"Fecha de salida (Vuelta)"}},[_c('b-form-input',{staticClass:"form-control",attrs:{"name":"complaint[ticket_info][arrival_date]","type":"text","readonly":"readonly"},model:{value:(_vm.complaint.ticket_info.arrival_date),callback:function ($$v) {_vm.complaint.ticket_info.arrival_date=$$v},expression:"complaint.ticket_info.arrival_date"}})],1):_vm._e(),(_vm.complaint.ticket_info.arrival_hour)?_c('b-form-group',{attrs:{"label":"Hora de salida (Vuelta)"}},[_c('b-form-input',{staticClass:"form-control",attrs:{"name":"complaint[ticket_info][arrival_hour]","type":"text","readonly":"readonly"},model:{value:(_vm.complaint.ticket_info.arrival_hour),callback:function ($$v) {_vm.complaint.ticket_info.arrival_hour=$$v},expression:"complaint.ticket_info.arrival_hour"}})],1):_vm._e(),(_vm.complaint.ticket_info.payment_method)?_c('b-form-group',{attrs:{"label":"Método de Pago"}},[_c('b-form-input',{staticClass:"form-control",attrs:{"name":"complaint[ticket_info][payment_method]","type":"text","readonly":"readonly"},model:{value:(_vm.complaint.ticket_info.payment_method),callback:function ($$v) {_vm.complaint.ticket_info.payment_method=$$v},expression:"complaint.ticket_info.payment_method"}})],1):_vm._e(),(_vm.complaint.ticket_info.price)?_c('b-form-group',{attrs:{"label":"Monto Total"}},[_c('b-form-input',{staticClass:"form-control",attrs:{"name":"complaint[ticket_info][price]","type":"text","readonly":"readonly"},model:{value:(_vm.complaint.ticket_info.price),callback:function ($$v) {_vm.complaint.ticket_info.price=$$v},expression:"complaint.ticket_info.price"}})],1):_vm._e(),_c('b-form-group',{attrs:{"label":"Plantillas"}},[_c('selectize',{attrs:{"name":"template_selected"},on:{"input":function($event){_vm.setTemplateSelected($event)}},model:{value:(_vm.template_selected_option),callback:function ($$v) {_vm.template_selected_option=$$v},expression:"template_selected_option"}},[_c('option',{domProps:{"value":''}},[_vm._v("Selecciona un motivo")]),_vm._l((_vm.comment_templates),function(template,index){return _c('option',{domProps:{"value":template.template}},[_vm._v(_vm._s(template.title))])})],2)],1),(_vm.template_selected)?_c('b-form-group',{attrs:{"label":"Texto seleccionado"}},[_c('b-form-textarea',{staticClass:"form-control",attrs:{"rows":6,"readonly":"readonly"},model:{value:(_vm.template_selected),callback:function ($$v) {_vm.template_selected=$$v},expression:"template_selected"}})],1):_vm._e()],1),_c('b-col',{attrs:{"md":"2"}})],1),_c('b-form-group',{staticClass:"text-center"},[_c('br'),_c('b-button',{staticClass:"positive-action btn-lg",attrs:{"type":"submit","variant":"primary"}},[_vm._v("Abrir reclamo pre-aprobado")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "p8o/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_Status_constants__ = __webpack_require__("XXAu");

//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['thisComplaint', 'popoverTarget'],
  data: function data() {
    return {
      statuses: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_1__constants_Status_constants__["a" /* default */].STATUSES, __WEBPACK_IMPORTED_MODULE_1__constants_Status_constants__["a" /* default */].STATUSES_ECOMMERCE)
    };
  }
});

/***/ }),

/***/ "p9NS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pOFu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ptzr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_apiService__ = __webpack_require__("a/3G");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__perimeters_actionsPerimeter__ = __webpack_require__("Qh7t");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_layout_ActionButton__ = __webpack_require__("rnIC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue2_editor__ = __webpack_require__("m6he");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue2_editor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue2_editor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_functions__ = __webpack_require__("9NIY");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'actions',
  props: ['complaint'],
  components: {
    actionButton: __WEBPACK_IMPORTED_MODULE_4__components_layout_ActionButton__["a" /* default */],
    VueEditor: __WEBPACK_IMPORTED_MODULE_5_vue2_editor__["VueEditor"]
  },
  perimeters: [__WEBPACK_IMPORTED_MODULE_3__perimeters_actionsPerimeter__["a" /* default */]],
  data: function data() {
    return {
      customer_name: this.$store.getters.selected.issuer_name,
      button_response: {},
      action: {
        response: {
          comment: null
        },
        reimbursement: {
          amount: 0,
          percentage: 0,
          compensation_type: 'm',
          discount_from_company: false,
          discount: 0,
          discount_percentage: 0,
          comment: ''
        }
      },
      dialogOptions: {
        okText: 'Continuar',
        cancelText: 'Cancelar'
      },
      activity: {
        message: '',
        code: null
      },
      compensation_type: '',
      complaint_price: 0,
      complaint_price_usd: 0,
      complaint_original_price: 0,
      complaint_price_percentage: 0,
      complaint_price_amount: 0,
      bus_operator_discount: false,
      bus_operator_discount_percentage: 0,
      bus_operator_discount_amount: 0,
      customer_information: '',
      text_cta: 'Proceder',
      customToolbar: [['bold', 'italic', 'underline'], [{ list: 'ordered' }, { list: 'bullet' }]],
      decimal_error: false,
      percentage_error: false
    };
  },
  beforeMount: function beforeMount() {
    this.setComplaintPrice();
  },
  mounted: function mounted() {
    this.availableButtons();
  },

  computed: {
    lastMessage: function lastMessage() {
      if ('internal_messages' in this.complaint) {
        return this.complaint.internal_messages.length;
      }
      return 0;
    }
  },
  methods: {
    availableButtons: function availableButtons() {
      var children = this.$children;
      var complaintActions = document.querySelector('.complaint-actions');
      var complaintTitle = complaintActions.querySelector('h4');

      // There is always one element that makes it necessary to count from
      // one to get an accurate result
      if (children.length === 1) {
        complaintActions.classList.add('no-buttons');
        if (__WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.selected.aasm_state === 'rejected' || __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.selected.aasm_state === 'closed') {
          complaintTitle.innerText = '✅ El reclamo está resuelto';
        } else {
          complaintTitle.innerText = 'No hay acciones disponibles para procesar el reclamo, ' + 'ya que otro equipo es responsable de dar una instrucción. \nPor favor revise el estado del reclamo.';
        }
      }

      return children;
    },
    extraComment: function extraComment(e) {
      // TODO: Refactor. This function performs too many actions
      this.button_response = e;
      if (e.code === 'approval') {
        this.activity.code = 'complaint_approve';
        this.text_cta = 'Proceder';
      } else if (e.code === 'rejection') {
        this.activity.code = 'complaint_reject';
        this.text_cta = 'Confirmar rechazo';
      } else if (e.code === 'bus-operator') {
        this.activity.code = 'complaint_send_edb';
        this.text_cta = 'Reenviar a empresa';
      } else if (e.code === 'more-information') {
        this.activity.code = this.$sandbox.actions.getActivityAction();
        var opening = this.complaint.issuer_gender === 'male' ? 'Estimado' : 'Estimada';
        this.text_cta = this.activity.code === 'complaint_err_request' ? 'Asignar a CRM' : 'Enviar mensaje al cliente';
        this.activity.message = this.activity.code === 'complaint_err_request' ? '' : opening + ' ' + this.complaint.issuer_name + '<br><br><br>Atte.,<br>Recorrido.cl';
      } else if (e.code === 'rejection-message') {
        this.activity.code = 'complaint_notify_rejection';
        this.text_cta = 'Enviar mensaje';
      } else if (e.code === 'approval-message') {
        this.activity.code = 'complaint_notify_approval';
        this.text_cta = 'Enviar mensaje';
      } else if (e.code === 'to-err') {
        this.activity.code = 'complaint_crm_info';
        this.text_cta = 'Proceder';
      } else {
        this.text_cta = 'Proceder';
      }
    },
    setComplaintPercentage: function setComplaintPercentage(e) {
      this.action.reimbursement.percentage = e.target.value;
      if (this.complaint.complaint_category.number === 2 && this.action.reimbursement.percentage > 15) {
        this.percentage_error = true;
      } else {
        this.percentage_error = false;
      }
      if (this.complaint.ticket_info.sold_currency === 'CLP') {
        this.action.reimbursement.amount = (e.target.value * this.complaint_price / 100).toFixed();
      } else if (this.complaint.ticket_info.sold_currency === 'USD') {
        this.action.reimbursement.amount = (e.target.value * this.complaint_price_usd / 100).toFixed(2);
      } else {
        this.action.reimbursement.amount = (e.target.value * this.complaint_price / 100).toFixed(2);
      }

      this.action.reimbursement.amount_ioc = this.getReimbursementAmountIoc();
      this.action.reimbursement.amount_ibc = this.getReimbursementAmountIbc();
    },
    setComplaintAmount: function setComplaintAmount(e) {
      this.action.reimbursement.amount = e.target.value;
      if (this.complaint.ticket_info.sold_currency === 'CLP') {
        if (e.target.value !== 0 && e.target.value % 1 !== 0) {
          this.decimal_error = true;
        } else {
          this.decimal_error = false;
        }
        this.action.reimbursement.percentage = (100 * (e.target.value / this.complaint_price)).toFixed();
      } else if (this.complaint.ticket_info.sold_currency === 'USD') {
        this.action.reimbursement.percentage = (100 * (e.target.value / this.complaint_price_usd)).toFixed(2);
      } else {
        this.action.reimbursement.percentage = (100 * (e.target.value / this.complaint_price)).toFixed(2);
      }

      this.action.reimbursement.amount_ioc = this.getReimbursementAmountIoc();
      this.action.reimbursement.amount_ibc = this.getReimbursementAmountIbc();
    },
    getComplaintPriceIoc: function getComplaintPriceIoc() {
      return this.complaint.ticket_info.tickets_data.reduce(function (accumulator, object) {
        return accumulator + object.final_price_ioc;
      }, 0);
    },
    getReimbursementAmountIoc: function getReimbursementAmountIoc() {
      var priceIoc = this.getComplaintPriceIoc();

      if (this.complaint.ticket_info.operator_currency === 'CLP') {
        return (this.action.reimbursement.percentage * priceIoc / 100).toFixed();
      }

      return (this.action.reimbursement.percentage * priceIoc / 100).toFixed(2);
    },
    getReimbursementAmountIbc: function getReimbursementAmountIbc() {
      var priceIoc = this.getComplaintPriceIoc();

      if (this.complaint.ticket_info.price_ibc !== '' || this.complaint.ticket_info.price_ibc !== null) {
        return (this.action.reimbursement.percentage * this.complaint.ticket_info.price_ibc / 100).toFixed();
      }

      return (this.action.reimbursement.percentage * priceIoc / 100).toFixed();
    },
    setCompanyDiscount: function setCompanyDiscount(e) {
      this.action.reimbursement.discount = e.target.value;
      this.action.reimbursement.discount_percentage = (100 * (e.target.value / this.complaint_original_price)).toFixed(2);
    },
    setCompanyDiscountPercentage: function setCompanyDiscountPercentage(e) {
      this.action.reimbursement.discount_percentage = e.target.value;
      this.action.reimbursement.discount = (e.target.value * this.complaint_original_price / 100).toFixed(2);
    },
    setComplaintPrice: function setComplaintPrice() {
      this.complaint_price = this.complaint.ticket_info.price;
      this.complaint_original_price = this.complaint.ticket_info.original_price;
      this.complaint_price_usd = this.complaint.ticket_info.price_usd;
    },
    copyComplaintText: function copyComplaintText() {
      var checkCopyComplaint = document.querySelector('#check-copy-complaint');

      if (checkCopyComplaint.checked) {
        this.activity.message = this.complaint.description;
      } else {
        this.activity.message = '';
      }
    },
    updateStatus: function updateStatus() {
      var _this = this;

      if (this.button_response.code === 'approval' && this.action.reimbursement.compensation_type === 'm' && this.action.reimbursement.percentage === 0) {
        this.$notify({
          group: 'action_msgs',
          type: 'error',
          title: 'Error',
          text: 'Monto de devolución debe ser mayor a 0',
          duration: 3000
        });
        return;
      }
      var valid = true;
      if (['approval-message', 'rejection-message'].includes(this.button_response.code) && this.action.response.comment === '') {
        valid = false;
      }
      if (['more-information', 'rejection'].includes(this.button_response.code) && this.activity.message === '') {
        valid = false;
      }
      var actionsWithMessages = ['more-information', 'rejection', 'bus-operator', 'approval-message', 'rejection-message', 'to-err'];
      var params = __WEBPACK_IMPORTED_MODULE_6__utils_functions__["b" /* filterParams */](this.action, this.button_response.next);
      var $this = this;
      /* eslint-disable no-alert */
      if (valid) {
        this.$dialog.confirm('¿Estás seguro que deseas proceder?', this.dialogOptions).then(function () {
          __WEBPACK_IMPORTED_MODULE_1__services_apiService__["a" /* default */].update(_this.$route.params.complaint_id, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
            new_state: _this.button_response.next
          }, params)).then(function () {
            if (actionsWithMessages.includes($this.button_response.code)) {
              $this.registerActivity();
            }
            $this.$parent.fetchComplaint();
            $this.button_response = {
              code: null,
              next: null
            };
            $this.$emit('sendUpdate');
            $this.availableButtons();
            $this.clear();
            if (!_this.complaint.ecommerce && !_this.action.reimbursement.discount_from_company) {
              __WEBPACK_IMPORTED_MODULE_1__services_apiService__["a" /* default */].changeCouponState({
                booking_token: $this.complaint.ticket_info.booking_number,
                complaint_number: $this.complaint.number
              }).then();
            }
          }).catch(function (res) {
            if (res.status === 405) {
              _this.$notify({
                group: 'show_complaint',
                type: 'error',
                text: res.body.error ? res.body.error : 'No es posible actualizar este reclamo, porque ya está siendo procesado por una cancelación. Solo puede ser actualizado a Resuelto',
                duration: 8000
              });
            } else {
              $this.$notify({
                group: 'action_msgs',
                type: 'error',
                title: 'Error',
                text: 'base' in res.body ? res.body.base[0] : res.body,
                duration: 8000
              });
            }
          });
        }).catch(function () {});
      } else {
        $this.$notify({
          group: 'action_msgs',
          type: 'error',
          title: 'Error',
          text: 'Debe ingresar un mensaje',
          duration: 3000
        });
      }
    },
    registerActivity: function registerActivity() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_1__services_apiService__["a" /* default */].register({
        complaint_id: this.$route.params.complaint_id,
        code: this.activity.code,
        message: this.activity.message
      }).then(function () {
        _this2.activity.message = null;
      });
    },
    clear: function clear() {
      var buttons = document.querySelectorAll('.buttons-container .btn');
      buttons.forEach(function (currentButton) {
        currentButton.classList.remove('btn-inactive');
      });
    },
    format: function format(value) {
      var number = parseFloat(value);
      var output = 0;
      if (number > 100) {
        output = 100;
      } else if (number < 0) {
        output = 0;
      } else {
        output = number;
      }
      return output;
    }
  }
});

/***/ }),

/***/ "q1Qf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{staticClass:"buttons-container",on:{"submit":function($event){$event.preventDefault();_vm.updateStatus($event)}}},[_c('notifications',{attrs:{"group":"action_msgs","position":"top center"}}),(_vm.complaint.ecommerce === true)?[_c('div',[(_vm.complaint.aasm_state ==='pending_ecommerce')?_c('action-button',{attrs:{"variant":"approved","actionId":"refunded_ecommerce","text":"Aceptar","disabled":_vm.complaint.additional_infos.filter(function (info) { return info.source === 'internal' && info.name !== null; }).length === 0},on:{"extra":_vm.extraComment}}):_vm._e(),(_vm.complaint.aasm_state ==='pending_ecommerce')?_c('action-button',{attrs:{"variant":"reject-complaint","actionId":"rejected_ecommerce","text":"Rechazar"},on:{"extra":_vm.extraComment}}):_vm._e()],1),_c('div',[(_vm.complaint.aasm_state ==='pending_ecommerce' && _vm.complaint.additional_infos.filter(function (info) { return info.source === 'internal' && info.name !== null; }).length === 0 && (_vm.button_response.next === 'refunded_ecommerce' || _vm.button_response.next === undefined))?_c('b-alert',{staticClass:"m-1",attrs:{"show":"show","variant":"info"}},[_vm._v("Para aceptar debe cargar el comprobante de reembolso en archivos adjuntos")]):_vm._e()],1)]:[(_vm.$isAllowed('viewAdmin'))?_c('div',[_c('action-button',{attrs:{"variant":"approved","actionId":"closed","text":"Aceptar"},on:{"extra":_vm.extraComment}}),_c('action-button',{attrs:{"variant":"reject-complaint","actionId":"rejected","text":"Rechazar"},on:{"extra":_vm.extraComment}})],1):_vm._e(),(_vm.$isAllowed('viewCRM'))?_c('div',[(_vm.$isAllowed('requestInfo'))?_c('action-button',{attrs:{"variant":"primary","actionId":"pending_requested","text":"Solicitar información adicional"},on:{"extra":_vm.extraComment}}):_vm._e(),(_vm.$isAllowed('notifyRejection'))?_c('action-button',{attrs:{"variant":"primary","actionId":"notified_rejection","text":"Notificar rechazo"},on:{"extra":_vm.extraComment}}):_vm._e(),(_vm.$isAllowed('notifyApproval'))?_c('action-button',{attrs:{"variant":"primary","actionId":"notified_approval","text":"Notificar aprobación"},on:{"extra":_vm.extraComment}}):_vm._e(),(_vm.$isAllowed('resendERR'))?_c('action-button',{attrs:{"variant":"primary","actionId":"pending_err","text":"Confirmar ingreso de información"},on:{"extra":_vm.extraComment}}):_vm._e()],1):_vm._e(),(_vm.$isAllowed('viewERR'))?_c('div',[(_vm.$isAllowed('sendToEDB'))?_c('action-button',{attrs:{"variant":"send-bus-operator","actionId":"pending_edb","text":"Enviar a la empresa de bus"},on:{"extra":_vm.extraComment}}):_vm._e(),(_vm.$isAllowed('makeInfoRequest'))?_c('action-button',{attrs:{"variant":"ask-information","actionId":"pending_info","text":"Pedir más información"},on:{"extra":_vm.extraComment}}):_vm._e(),(_vm.$isAllowed('approveReimbursement'))?_c('action-button',{attrs:{"variant":"approved","actionId":"approved_reimbursement","text":"Aprobado - Pendiente devolución"},on:{"extra":_vm.extraComment}}):_vm._e(),(_vm.$isAllowed('closeComplaint'))?_c('action-button',{attrs:{"variant":"approved","actionId":"closed","text":"Cerrar"},on:{"extra":_vm.extraComment}}):_vm._e(),(_vm.$isAllowed('rejectComplaint'))?_c('action-button',{attrs:{"variant":"reject-complaint","actionId":"rejected_communication","text":"Rechazar"},on:{"extra":_vm.extraComment}}):_vm._e()],1):_vm._e(),(_vm.$isAllowed('viewFDP'))?_c('div',[(_vm.$isAllowed('reimburse'))?_c('action-button',{attrs:{"variant":"approved","actionId":"closed","text":"Devolución realizada"},on:{"extra":_vm.extraComment}}):_vm._e(),(_vm.$isAllowed('reimburse'))?_c('action-button',{attrs:{"variant":"reject-complaint","actionId":"reimbursement_error","text":"Error en transferencia"},on:{"extra":_vm.extraComment}}):_vm._e()],1):_vm._e()],(_vm.button_response.code === 'approval')?_c('b-form-group',[_c('h5',[_vm._v("Detalles de la aprobación")]),_c('h6',[_vm._v("Cliente: "+_vm._s(_vm.customer_name))]),_c('label',[_vm._v("Compensación"),_c('b-form-radio-group',{attrs:{"options":[{ text: 'Monetaria', value: 'm' }, { text: 'Otra', value: 'o' }]},model:{value:(_vm.action.reimbursement.compensation_type),callback:function ($$v) {_vm.action.reimbursement.compensation_type=$$v},expression:"action.reimbursement.compensation_type"}})],1),(_vm.action.reimbursement.compensation_type === 'm')?_c('div',[_c('label',{staticClass:"input-group"},[_vm._v("Porcentaje: "),_c('input',{attrs:{"type":"text","formatter":_vm.format},domProps:{"value":_vm.action.reimbursement.percentage},on:{"input":function($event){_vm.setComplaintPercentage($event)}}}),_c('span',{staticClass:"input-group-addon"},[_vm._v("%")])]),_c('label',{staticClass:"input-group"},[_vm._v("Monto:        "),_c('span',{staticClass:"input-group-addon"},[_vm._v("$")]),_c('input',{attrs:{"type":"text"},domProps:{"value":_vm.action.reimbursement.amount},on:{"input":function($event){_vm.setComplaintAmount($event)}}})]),(_vm.action.reimbursement.percentage > 200)?_c('b-alert',{attrs:{"show":"show","variant":"danger"}},[_vm._v("El monto supera más que el doble del valor reclamado. Por favor ingresar el valor total en la casilla del monto, no del porcentaje. Si se necesita devolver más que el doble del monto reclamado, ingresar el reclamo manualmente a Canc_Admin.")]):_vm._e(),(_vm.decimal_error)?_c('b-alert',{attrs:{"show":"show","variant":"danger"}},[_vm._v("El monto en CLP no puede incluir decimales. Por favor ingresar un monto válido.")]):_vm._e(),(_vm.percentage_error)?_c('b-alert',{attrs:{"show":"show","variant":"danger"}},[_vm._v("La categoría \"Suspensión / Paso cerrado\" solo acepta hasta el 15% de devolución")]):_vm._e()],1):_vm._e(),_c('vue-editor',{attrs:{"id":"customer-text","placeholder":"Comentario","editorToolbar":_vm.customToolbar},model:{value:(_vm.action.reimbursement.comment),callback:function ($$v) {_vm.action.reimbursement.comment=$$v},expression:"action.reimbursement.comment"}}),_c('strong',[_vm._v("Opcional: Lo que se ingresa aquí se comunica al cliente")]),_c('b-form-group',{attrs:{"label":"Empresa de bus"}},[_c('strong',[_vm._v(_vm._s(_vm.complaint.ticket_info.bus_operators[0]))])]),(_vm.action.reimbursement.compensation_type === 'm')?_c('b-form-group',{attrs:{"label":"Descontar de empresa de bus"}},[_c('b-form-radio-group',{attrs:{"options":[{ text: 'Sí', value: true }, { text: 'No', value: false }]},model:{value:(_vm.action.reimbursement.discount_from_company),callback:function ($$v) {_vm.action.reimbursement.discount_from_company=$$v},expression:"action.reimbursement.discount_from_company"}})],1):_vm._e(),(_vm.action.reimbursement.discount_from_company)?_c('b-form-group',[_c('label',{staticClass:"input-group"},[_vm._v("Porcentaje  "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.action.reimbursement.discount_percentage),expression:"action.reimbursement.discount_percentage"}],attrs:{"type":"text","formatter":_vm.format},domProps:{"value":(_vm.action.reimbursement.discount_percentage)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.action.reimbursement.discount_percentage=$event.target.value},function($event){_vm.setCompanyDiscountPercentage($event)}]}}),_c('span',{staticClass:"input-group-addon"},[_vm._v("%")])]),_c('label',{staticClass:"input-group"},[_vm._v("Monto    "),_c('span',{staticClass:"input-group-addon"},[_vm._v("$")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.action.reimbursement.discount),expression:"action.reimbursement.discount"}],attrs:{"type":"text"},domProps:{"value":(_vm.action.reimbursement.discount)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.action.reimbursement.discount=$event.target.value},function($event){_vm.setCompanyDiscount($event)}]}})])]):_vm._e()],1):_vm._e(),(_vm.button_response.code === 'bus-operator')?_c('b-form-group',[_c('h5',[_vm._v("Detalles para la empresa de bus")]),_c('label',[_vm._v("Texto del cliente"),_c('b-form-checkbox-group',[_c('b-form-checkbox',{attrs:{"id":"check-copy-complaint"},on:{"change":_vm.copyComplaintText}},[_vm._v("Copiar del Reclamo")])],1)],1),_c('vue-editor',{attrs:{"id":"customer-text","editorToolbar":_vm.customToolbar},model:{value:(_vm.activity.message),callback:function ($$v) {_vm.activity.message=$$v},expression:"activity.message"}}),_c('strong',[_c('small',[_vm._v("Obligatorio: este texto será visible para la empresa de bus.")])]),_c('h6',[_vm._v("Exigencia del cliente")]),_c('p',[_vm._v(_vm._s(_vm.complaint.comment))])],1):_vm._e(),(_vm.button_response.code === 'more-information')?_c('b-form-group',[_c('h5',[_vm._v("¿Qué se necesita del cliente?"),_c('vue-editor',{attrs:{"id":"customer-text","editorToolbar":_vm.customToolbar},model:{value:(_vm.activity.message),callback:function ($$v) {_vm.activity.message=$$v},expression:"activity.message"}}),_c('small',[_c('strong',[_vm._v("Obligatorio. Lo que se ingresa aquí, se comunica directamente al cliente.")])])],1)]):_vm._e(),(_vm.button_response.code === 'rejection')?_c('b-form-group',[_c('h5',[_vm._v("Detalles del rechazo")]),_c('label',[_vm._v("Razón del rechazo")]),_c('vue-editor',{attrs:{"id":"customer-text","editorToolbar":_vm.customToolbar},model:{value:(_vm.activity.message),callback:function ($$v) {_vm.activity.message=$$v},expression:"activity.message"}}),_c('strong',[_vm._v("Obligatorio. Debe ser instrucción para el SAC. Lo que se ingresa aquí, NO se comunica al cliente sino solo internamente al SAC.")])],1):_vm._e(),(_vm.button_response.code === 'rejection-message')?_c('b-form-group',[_c('h5',[_vm._v("Mensaje"),_c('vue-editor',{attrs:{"id":"customer-text","editorToolbar":_vm.customToolbar},model:{value:(_vm.action.response.comment),callback:function ($$v) {_vm.action.response.comment=$$v},expression:"action.response.comment"}}),_c('strong',[_c('small',[_vm._v("Obligatorio")])])],1)]):_vm._e(),(_vm.button_response.code === 'approval-message')?_c('b-form-group',[_c('h5',[_vm._v("Mensaje"),_c('vue-editor',{attrs:{"id":"customer-text","editorToolbar":_vm.customToolbar},model:{value:(_vm.action.response.comment),callback:function ($$v) {_vm.action.response.comment=$$v},expression:"action.response.comment"}}),_c('strong',[_c('small',[_vm._v("Obligatorio")])])],1)]):_vm._e(),(_vm.action.reimbursement.percentage <= 200 && !_vm.decimal_error && !_vm.percentage_error)?_c('b-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.button_response.code != undefined),expression:"button_response.code != undefined"}],staticClass:"positive-action btn-lg",attrs:{"type":"submit","variant":"primary"}},[_vm._v(_vm._s(_vm.text_cta))]):_vm._e(),(_vm.action.reimbursement.percentage > 200)?_c('b-alert',{attrs:{"show":"show","variant":"danger"}},[_vm._v("El monto de devolución no puede superar el doble del precio del ticket.")]):_vm._e(),(_vm.decimal_error)?_c('b-alert',{attrs:{"show":"show","variant":"danger"}},[_vm._v("El monto de devolución en CLP no puede incluir decimales.")]):_vm._e(),(_vm.percentage_error)?_c('b-alert',{attrs:{"show":"show","variant":"danger"}},[_vm._v("El porcentaje de devolución no puede ser mayor al 15%.")]):_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "q2GD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_apiService__ = __webpack_require__("a/3G");
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    showDialog: {
      type: Boolean,
      required: true
    }
  },
  data: function data() {
    return {
      show: false
    };
  },

  watch: {
    showDialog: function showDialog(newValue) {
      this.show = newValue;
    }
  },
  methods: {
    realoadApp: function realoadApp() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_1__services_apiService__["a" /* default */].reloadAppToFalse({ id: __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].state.id }).then(function () {
        __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].commit('setReloadApp', false);
        _this.show = false;
        window.location.reload();
      });
    }
  }
});

/***/ }),

/***/ "r15W":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_progress_vue__ = __webpack_require__("xKc6");
function injectStyle (ssrContext) {
  __webpack_require__("WT8W")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_progress_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "rnIC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ActionButton_vue__ = __webpack_require__("95Fp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6109a40e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_ActionButton_vue__ = __webpack_require__("CJ5O");
function injectStyle (ssrContext) {
  __webpack_require__("MlcB")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ActionButton_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6109a40e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_ActionButton_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "s6sV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_New_vue__ = __webpack_require__("P31c");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6f1d8f36_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_New_vue__ = __webpack_require__("fU6e");
function injectStyle (ssrContext) {
  __webpack_require__("83/Z")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_New_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6f1d8f36_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_New_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "sRqS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__basePerimeter__ = __webpack_require__("G0wa");


/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_0__basePerimeter__["a" /* default */]({
  purpose: 'new_complaint',
  govern: {
    'can route': function route() {
      return this.isAdmin() || this.isCRM();
    },
    'can createComplaint': function createComplaint() {
      return this.isAdmin() || this.isCRM();
    }
  }
}));

/***/ }),

/***/ "sX+p":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LastActivity_vue__ = __webpack_require__("xqu0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3bc46ee0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_LastActivity_vue__ = __webpack_require__("v4qg");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LastActivity_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3bc46ee0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_LastActivity_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "tBfJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tFFr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Status_vue__ = __webpack_require__("jteb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d05fb3ea_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Status_vue__ = __webpack_require__("MZ6X");
function injectStyle (ssrContext) {
  __webpack_require__("jvgQ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Status_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d05fb3ea_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Status_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "tf+Y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NewPreApproved_vue__ = __webpack_require__("NiGY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ec813a8c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_NewPreApproved_vue__ = __webpack_require__("oSgn");
function injectStyle (ssrContext) {
  __webpack_require__("5g7+")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NewPreApproved_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ec813a8c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_NewPreApproved_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "uR+g":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',[_c('b-col',{attrs:{"md":"4"}}),_c('b-col',{attrs:{"cols":"12","md":"4"}},[_c('form',{on:{"submit":function($event){$event.preventDefault();_vm.login($event)}}},[_c('h2',[_vm._v("Ingresar")]),_c('notifications',{attrs:{"group":"auth","position":"top center"}}),_c('b-form-group',{attrs:{"label":"Correo electrónico","label-for":"user-email"}},[_c('b-form-input',{staticClass:"field form-control",attrs:{"name":"email","type":"email","placeholder":"usuario@recorrido.cl","id":"user-email"},model:{value:(_vm.email),callback:function ($$v) {_vm.email=(typeof $$v === 'string'? $$v.trim(): $$v)},expression:"email"}})],1),_c('b-form-group',{attrs:{"label":"Contraseña","label-for":"user-password"}},[_c('b-form-input',{staticClass:"field form-control",attrs:{"name":"password","type":"password","placeholder":"******","id":"user-password"},model:{value:(_vm.password),callback:function ($$v) {_vm.password=(typeof $$v === 'string'? $$v.trim(): $$v)},expression:"password"}})],1),_c('div',{staticClass:"text-center form-group"},[_c('button',{staticClass:"btn btn-default btn-primary btn-lg"},[_vm._v("Iniciar sesión")])])],1)]),_c('b-col',{attrs:{"md":"4"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "v/ar":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "v4qg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-table',{attrs:{"striped":"striped","hover":"hover","fields":_vm.activityFields,"items":_vm.lastActions},on:{"row-clicked":_vm.showComplaintDetails},scopedSlots:_vm._u([{key:"message",fn:function(data){return [_c('span',{class:("role-" + (_vm.roleClass(data.item.role, data.item.action)))},[_vm._v(_vm._s(_vm.roles[data.item.role].name)+" / "+_vm._s(data.item.name))]),_vm._v(" "+_vm._s(_vm._f("formatAction")(data.item.action))),_c('router-link',{attrs:{"to":{ name: _vm.ecommerce ? 'show_complaint_ecommerce' : 'show_complaint', params: { complaint_id: data.item.complaint } }}},[_vm._v(_vm._s((" #" + (data.item.number))))]),(data.item.message)?_c('span',[_vm._v(". "+_vm._s(_vm._f("stripHTML")(data.item.message))+".")]):_vm._e(),(data.item.created_at)?_c('span',[_vm._v(" - "+_vm._s(_vm._f("formatCommentDate")(data.item.created_at)))]):_vm._e()]}}])})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "vvws":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ReloadAppDialog',{attrs:{"showDialog":_vm.showDialog}}),_c('b-row',{staticClass:"top-bar"},[_c('notifications',{attrs:{"group":"request","position":"top center"}})],1),_c('b-row',{staticClass:"justify-content-md-center"},[_c('b-col',{attrs:{"md":"10"}},[_c('b-table',{attrs:{"hover":"hover","fields":_vm.categoryFields,"items":_vm.categories,"striped":"striped"},scopedSlots:_vm._u([{key:"color",fn:function(category){return [_c('div',{staticClass:"cell-matrix-color d-flex align-items-center"}),_c('span',{staticClass:"cell-matrix-color__label"},[_vm._v(_vm._s(category.item.color))]),_c('span',{staticClass:"cell-matrix-color__preview",style:({ 'background-color': category.item.color })})]}},{key:"actions",fn:function(category){return [_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover.top",value:('Editar'),expression:"'Editar'",modifiers:{"hover":true,"top":true}}],staticClass:"icon-button",attrs:{"variant":"link"},on:{"click":function($event){_vm.loadCategory(category.item)}}},[_c('icon',{attrs:{"name":"edit"}})],1)]}}])}),(_vm.categories.length > 0)?_c('b-pagination',{attrs:{"align":"center","total-rows":_vm.pagination.total,"per-page":_vm.pagination.per_page},on:{"change":_vm.changePage},model:{value:(_vm.pagination.current),callback:function ($$v) {_vm.pagination.current=$$v},expression:"pagination.current"}}):_vm._e()],1)],1),_c('b-form',{staticClass:"form-horizontal",on:{"submit":_vm.onSubmit}},[_c('b-modal',{attrs:{"busy":true,"size":"lg","title":("Editar Categoría " + (_vm.category.name)),"no-close-on-backdrop":"no-close-on-backdrop"},on:{"hide":function($event){_vm.closeModal(_vm.category)}},model:{value:(_vm.modalShow),callback:function ($$v) {_vm.modalShow=$$v},expression:"modalShow"}},[_c('b-row',[_c('b-col',{attrs:{"md":"12"}},[_c('b-form-group',{attrs:{"label":"Urgencia"}},[_c('b-form-select',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"data-vv-as":"urgency","name":"category[urgency]","options":_vm.urgency_options,"autocomplete":"off"},model:{value:(_vm.category.urgency),callback:function ($$v) {_vm.category.urgency=$$v},expression:"category.urgency"}}),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('category[urgency]')),expression:"errors.has('category[urgency]')"}],staticClass:"danger"},[_vm._v(_vm._s(_vm.errors.first('category[urgency]')))])],1)],1),_c('b-col',{attrs:{"md":"6"}},[_c('b-form-group',{attrs:{"label":"Usar color"}},[_c('ToggleSwitch',{attrs:{"disabled":_vm.disableUseColor},model:{value:(_vm.category.use_color),callback:function ($$v) {_vm.category.use_color=$$v},expression:"category.use_color"}})],1)],1)],1),_c('div',{attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('b-btn',{staticClass:"btn-space",attrs:{"variant":"secondary"},on:{"click":function($event){_vm.closeModal(_vm.category)}}},[_vm._v("Cancelar")]),_c('b-btn',{staticClass:"btn-space",attrs:{"variant":"primary","type":"submit"}},[_vm._v("Actualizar")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "wfGp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_apiService__ = __webpack_require__("a/3G");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__("YaEn");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'confirm_email',
  data: function data() {
    return {
      password: '',
      password_confirmation: ''
    };
  },
  created: function created() {
    this.$validator.extend('verify_password', {
      getMessage: function getMessage() {
        return 'La contraseña debe tener al menos: 1 mayúsculas, 1 minúsculas, 1 número, y un caracter especial (, . _ & ? etc)';
      },
      validate: function validate(value) {
        var strongRegex = new RegExp('^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$?_%^&*,.])(?=.{8,})');
        return strongRegex.test(value);
      }
    });
  },

  methods: {
    createPassword: function createPassword() {
      var _this = this;

      this.$validator.validate().then(function (valid) {
        if (valid) {
          var params = {
            uct: _this.$route.params.uct,
            rpt: _this.$route.query.rpt,
            password: _this.password,
            password_confirmation: _this.password_confirmation
          };
          __WEBPACK_IMPORTED_MODULE_0__services_apiService__["a" /* default */].save_password(params).then(function () {
            _this.$notify({
              group: 'auth',
              type: 'success',
              title: 'Contraseña creada con éxito',
              duration: 3000
            });
            setTimeout(function () {
              return __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */].push({ name: 'login' });
            }, 3000);
          }).catch(function () {
            _this.$notify({
              group: 'auth',
              type: 'error',
              title: 'Error',
              text: 'Usuario no encontrado',
              duration: 3000
            });
            setTimeout(function () {
              return __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */].push({ name: 'login' });
            }, 3000);
          });
        }
      });
    }
  }
});

/***/ }),

/***/ "xAMB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_Status_constants__ = __webpack_require__("XXAu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_apiService__ = __webpack_require__("a/3G");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_layout_LastActivity__ = __webpack_require__("sX+p");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_layout_PopoverDetail__ = __webpack_require__("gs9z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_dateService__ = __webpack_require__("4F1w");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








var parse = __webpack_require__("UVyn");

/* eslint no-underscore-dangle: ["error", { "allow": ["_id"] }] */

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'complaints',
  components: {
    LastActivity: __WEBPACK_IMPORTED_MODULE_4__components_layout_LastActivity__["a" /* default */],
    complaintPopover: __WEBPACK_IMPORTED_MODULE_5__components_layout_PopoverDetail__["a" /* default */]
  },
  data: function data() {
    return {
      complaintFields: {
        number: {
          label: 'ID',
          sortable: true
        },
        status: {
          label: 'Estado',
          tdClass: 'status-holder'
        },
        token: { label: 'Número de compra' },
        category: {
          label: 'Categoría',
          sortable: true
        },
        age: { label: 'Edad' },
        bus_operator: { label: 'Empresa de bus' }
      },
      statuses: __WEBPACK_IMPORTED_MODULE_2__constants_Status_constants__["a" /* default */].STATUSES_ECOMMERCE,
      complaints: [],
      pagination: {},
      current_page: 1,
      pending: true,
      sortAge: false,
      filterText: '',
      intervalId: null,
      showDialog: false
    };
  },
  created: function created() {
    this.fetchComplaints(undefined, true);
  },

  methods: {
    busOperators: function busOperators(complaint) {
      var busOperators = complaint.ticket_info.bus_operators;

      if (busOperators.length > 1) {
        return String(busOperators).replace(',', ', ');
      }
      return String(busOperators);
    },
    complaintAge: function complaintAge(complaint) {
      return __WEBPACK_IMPORTED_MODULE_6__utils_dateService__["a" /* default */].complaintAge(complaint.created_at);
    },
    fetchComplaints: function fetchComplaints(page, pending) {
      var $this = this;
      __WEBPACK_IMPORTED_MODULE_3__services_apiService__["a" /* default */].complaints(page, pending, this.filterText, this.sortAge, true).then(function (data) {
        $this.complaints = data.body.complaints;
        $this.setPagination(data);
      });
    },
    setPagination: function setPagination(res) {
      var links = Object.prototype.hasOwnProperty.call(res.headers.map, 'links') ? parse(res.headers.map.link[0]) : null;
      var current = res.body.meta.current_page;
      var total = res.body.meta.total_count;
      var perPage = res.body.meta.per_page;
      var pagination = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
        current: parseInt(current, 10),
        total: parseInt(total, 10),
        per_page: parseInt(perPage, 10)
      }, links);
      this.pagination = pagination;
    },
    changePage: function changePage(page) {
      this.current_page = page;
      this.fetchComplaints(page, this.pending);
    },
    showComplaintDetails: function showComplaintDetails(complaint) {
      __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].commit('selectComplaint', complaint);
      this.$router.push('/complaints_ecommerce/' + complaint._id.$oid);
    },
    showPending: function showPending() {
      this.fetchComplaints(null, this.pending);
    },
    refreshComplaints: function refreshComplaints() {
      var $this = this;
      this.intervalId = setInterval(function () {
        $this.fetchComplaints(undefined, $this.pending);
      }, 120000);
    },
    toggleAge: function toggleAge() {
      this.sortAge = !this.sortAge;
      this.fetchComplaints(this.current_page, this.pending);
    },
    refreshReloaAppStatus: function refreshReloaAppStatus() {
      var _this = this;

      this.intervalId = setInterval(function () {
        __WEBPACK_IMPORTED_MODULE_3__services_apiService__["a" /* default */].reloadAppStatus().then(function (response) {
          if (response.body) {
            _this.showDialog = true;
          }
        });
      }, 900000);
    }
  },
  mounted: function mounted() {
    this.refreshComplaints();
    this.refreshReloaAppStatus();
    if (__WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].state.reloadApp) {
      this.showDialog = true;
    }
  },
  beforeDestroy: function beforeDestroy() {
    clearInterval(this.intervalId);
  }
});

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_layout_Header__ = __webpack_require__("a4KA");
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  components: {
    'v-header': __WEBPACK_IMPORTED_MODULE_0__components_layout_Header__["a" /* default */]
  }
});

/***/ }),

/***/ "xJsL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__ = __webpack_require__("nKb+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c431e656_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__ = __webpack_require__("uR+g");
function injectStyle (ssrContext) {
  __webpack_require__("tBfJ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-c431e656"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c431e656_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "xKc6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__progress__ = __webpack_require__("E9Zr");
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__progress__["a" /* default */]);

/***/ }),

/***/ "xqu0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_apiService__ = __webpack_require__("a/3G");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_Status_constants__ = __webpack_require__("XXAu");
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'last-activity',
  data: function data() {
    return {
      activityFields: {
        message: {
          label: 'Última actividad'
        }
      },
      lastActions: [],
      intervalId: null,
      roles: __WEBPACK_IMPORTED_MODULE_1__constants_Status_constants__["a" /* default */].ROLES
    };
  },
  created: function created() {
    this.fetchActivities();
  },

  methods: {
    fetchActivities: function fetchActivities() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0__services_apiService__["a" /* default */].activities(this.complaint, this.ecommerce).then(function (data) {
        _this.lastActions = data.body;
      });
    },
    showComplaintDetails: function showComplaintDetails(item) {
      this.$router.push('/complaints/' + item.complaint);
    },
    pollActivities: function pollActivities() {
      var _this2 = this;

      this.intervalId = setInterval(function () {
        _this2.fetchActivities();
      }, 120000);
    },
    roleClass: function roleClass(roleId, action) {
      if (action.includes('error')) {
        return 'error';
      }

      if (roleId === 2) {
        return 'crm';
      } else if (roleId === 3) {
        return 'err';
      } else if (roleId === 4) {
        return 'edb';
      } else if (roleId === 5) {
        return 'fin';
      }
      return 'empty';
    }
  },
  props: {
    complaint: {
      type: [String, Number],
      required: false
    },
    ecommerce: {
      type: Boolean,
      default: false
    }
  },
  mounted: function mounted() {
    this.pollActivities();
  },
  beforeDestroy: function beforeDestroy() {
    clearInterval(this.intervalId);
  }
});

/***/ }),

/***/ "z4t4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "zGor":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ShowComplaint_vue__ = __webpack_require__("MRiZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d05538ce_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_ShowComplaint_vue__ = __webpack_require__("GBGs");
function injectStyle (ssrContext) {
  __webpack_require__("jaqg")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ShowComplaint_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d05538ce_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_ShowComplaint_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "zp9P":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ShowBankAccountForm_vue__ = __webpack_require__("SP86");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5bf108b9_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_ShowBankAccountForm_vue__ = __webpack_require__("VC1Y");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ShowBankAccountForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5bf108b9_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_ShowBankAccountForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.02cde27778dd38b9620d.js